package br.com.htms.inspeccaocampo.form

import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthSession
import br.com.htms.inspeccaocampo.auth.AuthUser
import br.com.htms.inspeccaocampo.auth.ProfileTypes
import br.com.htms.inspeccaocampo.auth.RemoteInspection
import br.com.htms.inspeccaocampo.data.ObraCatalog
import br.com.htms.inspeccaocampo.data.ObraItem
import br.com.htms.inspeccaocampo.data.AlojamentoValidacao
import br.com.htms.inspeccaocampo.data.AppConfig
import br.com.htms.inspeccaocampo.data.colaboradores.ColabEscopo
import br.com.htms.inspeccaocampo.data.ChecklistAlojamentoCatalog
import br.com.htms.inspeccaocampo.data.ChecklistVetoresCatalog
import br.com.htms.inspeccaocampo.data.ComunicacaoOcorrenciasValidacao
import br.com.htms.inspeccaocampo.data.ConfigStore
import br.com.htms.inspeccaocampo.data.EpiRelacaoStore
import br.com.htms.inspeccaocampo.data.DraftStore
import br.com.htms.inspeccaocampo.data.epi.EpiCatalog
import br.com.htms.inspeccaocampo.data.epi.EpiRelacaoItem
import br.com.htms.inspeccaocampo.data.ErroCampo
import br.com.htms.inspeccaocampo.data.FormChecklistAlojamento
import br.com.htms.inspeccaocampo.data.FormComunicacaoOcorrencias
import br.com.htms.inspeccaocampo.data.FormInspecao
import br.com.htms.inspeccaocampo.data.FormJson
import br.com.htms.inspeccaocampo.data.FormRelatorioFoto
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.data.FormRemSeguranca
import br.com.htms.inspeccaocampo.data.AcompAmbAba
import br.com.htms.inspeccaocampo.data.AcompAmbDossier
import br.com.htms.inspeccaocampo.data.AcompAmbJson
import br.com.htms.inspeccaocampo.data.AcompAmbMonthPayload
import br.com.htms.inspeccaocampo.data.AcompAmbMonthRow
import br.com.htms.inspeccaocampo.data.AcompAmbSchema
import br.com.htms.inspeccaocampo.data.FormAcompanhamentoAmbiental
import br.com.htms.inspeccaocampo.data.RemAbrangencia
import br.com.htms.inspeccaocampo.data.RemDossier
import br.com.htms.inspeccaocampo.data.RemJson
import br.com.htms.inspeccaocampo.data.RemMonthPayload
import br.com.htms.inspeccaocampo.data.RemMonthRow
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.InspecaoCatalog
import br.com.htms.inspeccaocampo.data.InspecaoCompleta
import br.com.htms.inspeccaocampo.data.InspecaoStore
import br.com.htms.inspeccaocampo.data.InspecaoValidacao
import br.com.htms.inspeccaocampo.data.ItemCampoPersonalizado
import br.com.htms.inspeccaocampo.data.ItemConformidade
import br.com.htms.inspeccaocampo.data.ItemVerificacao
import br.com.htms.inspeccaocampo.data.RelatorioFotoCatalog
import br.com.htms.inspeccaocampo.data.RespostaConformidade
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.RespostaTernaria
import br.com.htms.inspeccaocampo.data.SecaoSimNao
import br.com.htms.inspeccaocampo.data.TreinamentoDados
import br.com.htms.inspeccaocampo.data.checklist.AxiaRequisitosMev
import br.com.htms.inspeccaocampo.data.checklist.ChecklistDiarioMarca
import br.com.htms.inspeccaocampo.data.checklist.ChecklistDiarioValidacao
import br.com.htms.inspeccaocampo.data.checklist.ChecklistTipo
import br.com.htms.inspeccaocampo.data.checklist.FormChecklistDiario
import br.com.htms.inspeccaocampo.data.checklist.comTipo
import br.com.htms.inspeccaocampo.data.checklist.semConteudoBase64 as checklistDiarioSemBase64
import br.com.htms.inspeccaocampo.data.semConteudoBase64
import br.com.htms.inspeccaocampo.data.temConteudoRascunho
import br.com.htms.inspeccaocampo.export.ExportNames
import br.com.htms.inspeccaocampo.export.JpegPdfBuilder
import br.com.htms.inspeccaocampo.export.OrdemServicoPdfBuilder
import br.com.htms.inspeccaocampo.export.FichaEpiPdfBuilder
import br.com.htms.inspeccaocampo.export.CertificadoDados
import br.com.htms.inspeccaocampo.export.CertificadoPdfBuilder
import br.com.htms.inspeccaocampo.data.epi.FichaEpiDados
import br.com.htms.inspeccaocampo.data.os.OrdemServicoDados
import br.com.htms.inspeccaocampo.data.funcionarios.Cpf
import br.com.htms.inspeccaocampo.data.funcionarios.Funcionario
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionarioDocumento
import br.com.htms.inspeccaocampo.data.funcionarios.FuncionariosApi
import br.com.htms.inspeccaocampo.export.SharedExcelBuilder
import br.com.htms.inspeccaocampo.export.SharedExporter
import br.com.htms.inspeccaocampo.platform.PhotoStampData
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.PlatformImage
import br.com.htms.inspeccaocampo.platform.LiveNrCamera
import br.com.htms.inspeccaocampo.platform.PlatformServices
import br.com.htms.inspeccaocampo.platform.CapturedPhoto
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.monthOf
import br.com.htms.inspeccaocampo.platform.yearOf
import br.com.htms.inspeccaocampo.util.AdminSenha
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.NonCancellable
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.TimeoutCancellationException
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import kotlinx.coroutines.withTimeout
import kotlinx.coroutines.withTimeoutOrNull
import kotlinx.coroutines.yield

enum class AppTab { HUB, FORM, HISTORICO, CONFIG, ORDEM_SERVICO, FUNCIONARIOS, FICHA_EPI, CERTIFICADO, APR, ATIVOS, COLABORADORES, EFETIVO, OCORRENCIAS, DASHBOARDS, ESTOQUE }

/** Menu principal: raiz (escolha) → Checklists/Formulários ou Emissão de Documentos. */
enum class HubSecao { RAIZ, FORMULARIOS, DOCUMENTOS }

data class HistoricoUiState(
    val exportandoId: Long? = null,
    /** Download remoto (Baixar PDF / Excel). */
    val exportandoRemoteId: String? = null,
    /** "pdf" | "excel" enquanto [exportandoRemoteId] está ativo. */
    val baixandoRemotoKind: String? = null,
    /** Admin: regenerar anexos (não confundir com download). */
    val gerandoAnexosRemoteId: String? = null,
    val exportandoLote: Boolean = false,
    val exportandoConsolidado: Boolean = false,
    val sincronizandoPendentes: Boolean = false,
    val mensagem: String? = null
)

/**
 * Progresso do envio ao servidor. Enquanto [ativo], a tela fica bloqueada:
 * fechar/trocar de aba no meio do PDF/Excel deixava a inspeção sem anexos.
 */
data class EnvioProgresso(
    val ativo: Boolean = false,
    val percent: Int = 0,
    val etapa: String = "",
    val concluido: Boolean = false,
    val falhou: Boolean = false,
    val detalhe: String? = null
)

/**
 * Controlador completo do app compartilhado (iOS e host CMP).
 */
class AppController {
    companion object {
        /** Limite para gerar PDF/Excel + POST (rede lenta de campo / Safari). */
        private const val UPLOAD_TIMEOUT_MS = 300_000L
        /** Tentativas imediatas só para falha transitória de rede. */
        private const val UPLOAD_RETRY_MAX = 5
        private val UPLOAD_RETRY_BACKOFF_MS = listOf(2_000L, 6_000L, 15_000L, 30_000L, 60_000L)
        private const val MODULO_FORMULARIOS = "Checklists e Formulários"
        private const val MODULO_DOCUMENTOS = "Emissão de Documentos"
        private const val MSG_SALVO_REENVIAR =
            " Salvo neste aparelho. O envio segue automaticamente quando a rede melhorar."
    }

    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Main)

    /** Foto: Main.immediate mantém o gesto do usuário até o input.click() (exigência do Safari). */
    private fun launchFoto(block: suspend () -> Unit) {
        scope.launch(Dispatchers.Main.immediate) { block() }
    }
    private val store = InspecaoStore()
    private val draftStore = DraftStore()
    private val configStore = ConfigStore()
    private val epiRelacaoStore = EpiRelacaoStore()
    private val _epiRelacao = MutableStateFlow(EpiCatalog.seedRelacao())
    val epiRelacao: StateFlow<List<EpiRelacaoItem>> = _epiRelacao.asStateFlow()
    private var sincronizandoPendentes = false
    private var reenvioAgendado = false
    /** Uploads em andamento (protege contra fechar a aba no meio do envio). */
    private var uploadsEmAndamento = 0
    /** Tentativas de anexar PDF/Excel a um JSON já enviado (evita loop infinito). */
    private val tentativasAnexo = mutableMapOf<Long, Int>()
    /** Último envio anexou PDF/Excel? Usado só na mensagem final do progresso. */
    private var ultimoEnvioComAnexos = false

    private val _tab = MutableStateFlow(AppTab.HUB)
    val tab: StateFlow<AppTab> = _tab.asStateFlow()

    private val _formTipoAtivo = MutableStateFlow(FormTipo.INSPECAO_CAMPO)
    val formTipoAtivo: StateFlow<FormTipo> = _formTipoAtivo.asStateFlow()

    private val _form = MutableStateFlow(FormInspecao(dataHorarioMs = currentTimeMillis()))
    val form: StateFlow<FormInspecao> = _form.asStateFlow()

    private val _relatorioForm = MutableStateFlow(FormRelatorioFoto(dataHorarioMs = currentTimeMillis()))
    val relatorioForm: StateFlow<FormRelatorioFoto> = _relatorioForm.asStateFlow()

    private val _checklistForm = MutableStateFlow(FormChecklistAlojamento(dataHorarioMs = currentTimeMillis()))
    val checklistForm: StateFlow<FormChecklistAlojamento> = _checklistForm.asStateFlow()

    private val _ocorrenciasForm = MutableStateFlow(FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis()))
    val ocorrenciasForm: StateFlow<FormComunicacaoOcorrencias> = _ocorrenciasForm.asStateFlow()

    private val _analiseVisualNrForm = MutableStateFlow(
        br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr(dataHorarioMs = currentTimeMillis())
    )
    val analiseVisualNrForm:
        StateFlow<br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr> =
        _analiseVisualNrForm.asStateFlow()
    private val _analiseVisualNrAnalisando = MutableStateFlow(false)
    val analiseVisualNrAnalisando: StateFlow<Boolean> = _analiseVisualNrAnalisando.asStateFlow()
    private var nrVisualReanalisarApos = false
    private var nrVisualReanalisarSoFotoId: String? = null
    private var nrVisualDebounceJob: Job? = null
    private val cacheVisaoNr = mutableMapOf<String, CacheVisaoNr>()

    private val _remForm = MutableStateFlow(FormRemSeguranca())
    val remForm: StateFlow<FormRemSeguranca> = _remForm.asStateFlow()
    private val _remSalvando = MutableStateFlow(false)
    val remSalvando: StateFlow<Boolean> = _remSalvando.asStateFlow()
    private val _remBaixando = MutableStateFlow(false)
    val remBaixando: StateFlow<Boolean> = _remBaixando.asStateFlow()
    private val _remDossiers = MutableStateFlow<List<RemDossier>>(emptyList())
    val remDossiers: StateFlow<List<RemDossier>> = _remDossiers.asStateFlow()
    private val _remExportandoId = MutableStateFlow<String?>(null)
    val remExportandoId: StateFlow<String?> = _remExportandoId.asStateFlow()

    private val _relSegForm = MutableStateFlow(br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca())
    val relSegForm: StateFlow<br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca> = _relSegForm.asStateFlow()
    private val _relSegSalvando = MutableStateFlow(false)
    val relSegSalvando: StateFlow<Boolean> = _relSegSalvando.asStateFlow()
    private val _relSegBaixando = MutableStateFlow(false)
    val relSegBaixando: StateFlow<Boolean> = _relSegBaixando.asStateFlow()
    private val _relSegDossiers = MutableStateFlow<List<br.com.htms.inspeccaocampo.data.RelSegDossier>>(emptyList())
    val relSegDossiers: StateFlow<List<br.com.htms.inspeccaocampo.data.RelSegDossier>> = _relSegDossiers.asStateFlow()
    private val _relSegExportandoId = MutableStateFlow<String?>(null)
    val relSegExportandoId: StateFlow<String?> = _relSegExportandoId.asStateFlow()

    private val _acompAmbForm = MutableStateFlow(FormAcompanhamentoAmbiental())
    val acompAmbForm: StateFlow<FormAcompanhamentoAmbiental> = _acompAmbForm.asStateFlow()
    private val _acompAmbSalvando = MutableStateFlow(false)
    val acompAmbSalvando: StateFlow<Boolean> = _acompAmbSalvando.asStateFlow()
    private val _acompAmbBaixando = MutableStateFlow(false)
    val acompAmbBaixando: StateFlow<Boolean> = _acompAmbBaixando.asStateFlow()
    private val _acompAmbDossiers = MutableStateFlow<List<AcompAmbDossier>>(emptyList())
    val acompAmbDossiers: StateFlow<List<AcompAmbDossier>> = _acompAmbDossiers.asStateFlow()
    private val _acompAmbExportandoId = MutableStateFlow<String?>(null)
    val acompAmbExportandoId: StateFlow<String?> = _acompAmbExportandoId.asStateFlow()

    private val _checklistDiarioForm = MutableStateFlow(FormChecklistDiario.novo(ChecklistDiarioMarca.HTMS))
    val checklistDiarioForm: StateFlow<FormChecklistDiario> = _checklistDiarioForm.asStateFlow()

    private val _erros = MutableStateFlow<List<ErroCampo>>(emptyList())
    val erros: StateFlow<List<ErroCampo>> = _erros.asStateFlow()

    private val _idEdicao = MutableStateFlow<Long?>(null)
    val idEdicao: StateFlow<Long?> = _idEdicao.asStateFlow()
    /** Rascunho lido na abertura. Fica guardado até o usuário escolher o formulário. */
    private var rascunhoInspecaoId: Long? = null
    private var rascunhoInspecaoPronto = false
    private var rascunhoChecklistId: Long? = null
    private var rascunhoChecklistPronto = false

    private val _mensagem = MutableStateFlow<String?>(null)
    val mensagem: StateFlow<String?> = _mensagem.asStateFlow()

    private val _capturandoGps = MutableStateFlow(false)
    val capturandoGps: StateFlow<Boolean> = _capturandoGps.asStateFlow()

    private val _modoTreinamento = MutableStateFlow(false)
    val modoTreinamento: StateFlow<Boolean> = _modoTreinamento.asStateFlow()

    private val _appConfig = MutableStateFlow(AppConfig.padrao())
    val appConfig: StateFlow<AppConfig> = _appConfig.asStateFlow()

    private val _assinaturaEditando = MutableStateFlow<String?>(null)
    val assinaturaEditando: StateFlow<String?> = _assinaturaEditando.asStateFlow()

    private val _inspecoes = MutableStateFlow<List<InspecaoCompleta>>(emptyList())
    val inspecoes: StateFlow<List<InspecaoCompleta>> = _inspecoes.asStateFlow()

    private val _historico = MutableStateFlow(HistoricoUiState())
    val historico: StateFlow<HistoricoUiState> = _historico.asStateFlow()

    private val _envioProgresso = MutableStateFlow(EnvioProgresso())
    val envioProgresso: StateFlow<EnvioProgresso> = _envioProgresso.asStateFlow()

    private val _pendentesCount = MutableStateFlow(0)
    val pendentesCount: StateFlow<Int> = _pendentesCount.asStateFlow()

    private val _rascunhoRestaurado = MutableStateFlow(false)
    val rascunhoRestaurado: StateFlow<Boolean> = _rascunhoRestaurado.asStateFlow()

    private val _authUser = MutableStateFlow<AuthUser?>(null)
    val authUser: StateFlow<AuthUser?> = _authUser.asStateFlow()

    private val _authReady = MutableStateFlow(!AuthApi.isLoginRequired())
    val authReady: StateFlow<Boolean> = _authReady.asStateFlow()

    private val _remoteInspections = MutableStateFlow<List<RemoteInspection>>(emptyList())
    val remoteInspections: StateFlow<List<RemoteInspection>> = _remoteInspections.asStateFlow()

    private val _obrasAtivas = MutableStateFlow(ObraCatalog.seedAtivas())
    val obrasAtivas: StateFlow<List<ObraItem>> = _obrasAtivas.asStateFlow()

    val loginRequired: Boolean get() = AuthApi.isLoginRequired()
    val isAdmin: Boolean get() = _authUser.value?.isAdmin == true
    val isMaster: Boolean get() = _authUser.value?.isMaster == true

    private suspend fun aplicarCarimbo(path: String, dados: PhotoStampData): ByteArray? {
        val nomeLogado = _authUser.value?.displayName.orEmpty()
        return PlatformImage.applyStamp(
            path,
            dados.copy(
                tstResponsavel = dados.tstResponsavel.ifBlank { nomeLogado },
                rotuloResponsavel = rotuloPerfilCampo()
            )
        )
    }

    private fun rotuloPerfilCampo(): String {
        val user = _authUser.value ?: return ProfileTypes.TST
        val types = user.effectiveProfileTypes
        val hasTst = ProfileTypes.TST in types
        val hasAdm = ProfileTypes.ADM in types
        if (hasTst != hasAdm) return if (hasAdm) ProfileTypes.ADM else ProfileTypes.TST
        val acesso = _appConfig.value.acessoDoForm(_formTipoAtivo.value)
        return if (acesso.tst || !acesso.adm) ProfileTypes.TST else ProfileTypes.ADM
    }

    private val tiposAlojamento = setOf(
        FormTipo.RELATORIO_FOTO_ALOJAMENTO,
        FormTipo.CHECKLIST_ALOJAMENTO,
        FormTipo.CHECKLIST_VETORES,
        FormTipo.RELATORIO_ALOJAMENTO
    )

    /** Ação de saída aguardando o "tem certeza?" do usuário (null = sem diálogo). */
    private val _saidaPendente = MutableStateFlow<(() -> Unit)?>(null)
    val saidaPendente: StateFlow<(() -> Unit)?> = _saidaPendente.asStateFlow()

    /** true quando a saída pendente é de uma edição (sem rascunho: alterações se perdem). */
    val saidaPendenteEhEdicao: Boolean get() = _idEdicao.value != null

    private fun alojamentoAtivoComDados(): Boolean {
        if (_tab.value != AppTab.FORM) return false
        return when (_formTipoAtivo.value) {
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> _relatorioForm.value.temConteudoRascunho()
            FormTipo.CHECKLIST_ALOJAMENTO,
            FormTipo.CHECKLIST_VETORES -> _checklistForm.value.temConteudoRascunho()
            FormTipo.RELATORIO_ALOJAMENTO ->
                _relatorioForm.value.temConteudoRascunho() || _checklistForm.value.temConteudoRascunho()
            else -> false
        }
    }

    /** Botões que tiram o usuário do formulário passam por aqui (Voltar, Menu, Histórico, Sair...). */
    fun solicitarSaidaDoFormulario(acao: () -> Unit) {
        if (!alojamentoAtivoComDados()) {
            acao()
            return
        }
        persistirRascunhoAlojamentoImediato()
        _saidaPendente.value = acao
    }

    fun confirmarSaidaDoFormulario(descartar: Boolean) {
        val acao = _saidaPendente.value ?: return
        _saidaPendente.value = null
        if (descartar && _idEdicao.value == null) {
            runCatching { draftStore.limparAlojamento() }
        }
        acao()
    }

    fun cancelarSaidaDoFormulario() {
        _saidaPendente.value = null
    }

    private fun persistirRascunhoAlojamentoImediato() {
        val tipo = _formTipoAtivo.value
        if (tipo !in tiposAlojamento || _tab.value != AppTab.FORM || _idEdicao.value != null) return
        val relatorio = _relatorioForm.value
        val checklist = _checklistForm.value
        val temDados = when (tipo) {
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> relatorio.temConteudoRascunho()
            FormTipo.CHECKLIST_ALOJAMENTO,
            FormTipo.CHECKLIST_VETORES -> checklist.temConteudoRascunho()
            else -> relatorio.temConteudoRascunho() || checklist.temConteudoRascunho()
        }
        if (!temDados) return
        runCatching {
            draftStore.salvarAlojamento(
                formTipo = tipo.name,
                username = _authUser.value?.username.orEmpty(),
                relatorio = relatorio,
                checklist = checklist
            )
        }
    }

    /** Recupera o rascunho do mesmo formulário e usuário; false = começar em branco. */
    private fun restaurarRascunhoAlojamento(tipo: FormTipo): Boolean {
        val r = runCatching { draftStore.carregarAlojamento() }.getOrNull() ?: return false
        if (r.formTipo != tipo.name) return false
        if (!r.username.equals(_authUser.value?.username.orEmpty(), ignoreCase = true)) return false
        val temDados = r.relatorio.temConteudoRascunho() || r.checklist.temConteudoRascunho()
        if (!temDados) return false
        _relatorioForm.value = r.relatorio
        _checklistForm.value = r.checklist
        _rascunhoRestaurado.value = true
        return true
    }

    /** Módulo da tela aberta, para exportações que não informam o próprio contexto. */
    private fun contextoBackupAtual(): br.com.htms.inspeccaocampo.platform.BackupSharePoint.Contexto {
        fun ctx(modulo: String, formulario: String = "") = br.com.htms.inspeccaocampo.platform.BackupSharePoint.Contexto(modulo, formulario)
        return when (_tab.value) {
            AppTab.FORM -> ctx(MODULO_FORMULARIOS, _formTipoAtivo.value.rotulo)
            AppTab.HUB, AppTab.HISTORICO -> ctx(MODULO_FORMULARIOS)
            AppTab.CONFIG -> ctx("Configurações")
            AppTab.ORDEM_SERVICO -> ctx(MODULO_DOCUMENTOS, "Ordem de Serviço")
            AppTab.FUNCIONARIOS -> ctx(MODULO_DOCUMENTOS, "Funcionários")
            AppTab.FICHA_EPI -> ctx(MODULO_DOCUMENTOS, "Ficha de EPI")
            AppTab.CERTIFICADO -> ctx(MODULO_DOCUMENTOS, "Certificados")
            AppTab.APR -> ctx(MODULO_DOCUMENTOS, "APR")
            AppTab.ATIVOS -> ctx("Controle de Ativos")
            AppTab.COLABORADORES -> ctx("Colaboradores QSMS")
            AppTab.EFETIVO -> ctx("Efetivo")
            AppTab.OCORRENCIAS -> ctx("Ocorrências")
            AppTab.DASHBOARDS -> ctx("Dashboards")
            AppTab.ESTOQUE -> ctx("Estoque")
        }
    }

    init {
        br.com.htms.inspeccaocampo.platform.BackupSharePoint.contextoPadrao = { contextoBackupAtual() }
        scope.launch {
            combine(_relatorioForm, _checklistForm) { _, _ -> Unit }.collectLatest {
                delay(800)
                persistirRascunhoAlojamentoImediato()
            }
        }
        scope.launch {
            if (AuthApi.isLoginRequired()) {
                // Nunca prender a UI em "Verificando sessão..." — timeout curto.
                val restored = withTimeoutOrNull(10_000) {
                    try {
                        AuthApi.restoreSession()
                    } catch (_: Throwable) {
                        null
                    }
                }
                _authUser.value = restored?.user
                _authReady.value = true
                if (restored != null) {
                    scope.launch {
                        while (_authUser.value != null) {
                            val atual = runCatching { AuthApi.refreshSession() }.getOrNull()?.user
                            if (atual != null && atual != _authUser.value) _authUser.value = atual
                            delay(25_000)
                        }
                    }
                    try {
                        iniciarAposLogin()
                    } catch (_: Throwable) {
                    }
                }
            } else {
                _authReady.value = true
                try {
                    iniciarAposLogin()
                } catch (_: Throwable) {
                }
            }
        }
    }

    private suspend fun iniciarAposLogin() {
        // 1) Config local + hub imediato — não espera rede/sync.
        val local = withContext(Dispatchers.Default) {
            runCatching { configStore.carregar() }.getOrDefault(AppConfig.padrao())
        }.comFormAcessosCompletos()
        _appConfig.value = local
        InspecaoCatalog.recarregar(local)
        runCatching {
            val epi = epiRelacaoStore.carregar()
            _epiRelacao.value = epi
            EpiCatalog.definirRelacao(epi)
        }
        carregarObrasAtivas()
        recarregarHistorico()
        _tab.value = telaInicial(local)

        // Sync / reenvio em paralelo — nunca bloqueia o hub.
        scope.launch {
            runCatching { sincronizarPendentesInterno() }
            val temPendenciaLocal = withContext(Dispatchers.Default) {
                runCatching { store.listar().any { !it.enviadoRemoto } }.getOrDefault(false)
            }
            if (temPendenciaLocal || PlatformServices.consumeUploadInflightFlag()) {
                agendarReenvioPendentes()
            }
            // JSON pode ter ido sem PDF/Excel — completa anexos se ainda houver cópia local.
            runCatching { completarAnexosRemotosIncompletos() }
        }
        PlatformServices.setBackgroundFlush {
            persistirRascunhoImediato()
            persistirRascunhoChecklistDiarioImediato()
            persistirRascunhoAlojamentoImediato()
        }
        PlatformServices.setForegroundResume {
            scope.launch {
                val temPendencia = withContext(Dispatchers.Default) {
                    runCatching { store.listar().any { !it.enviadoRemoto } }.getOrDefault(false)
                }
                if (temPendencia || PlatformServices.consumeUploadInflightFlag()) {
                    runCatching { sincronizarPendentesInterno() }
                    agendarReenvioPendentes()
                }
                // JSON pode ter ido sem PDF/Excel — completa anexos se ainda houver cópia local.
                runCatching { completarAnexosRemotosIncompletos() }
            }
        }

        // 2) Config remota + rascunhos em paralelo — falhas isoladas (não derrubam o hub).
        scope.launch {
            try {
                coroutineScope {
                    val remoteDeferred = async {
                        runCatching {
                            withTimeoutOrNull(8_000) {
                                AuthApi.fetchAppConfigJson().getOrNull()
                            }
                        }.getOrNull()
                    }
                    val draftsDeferred = async(Dispatchers.Default) {
                        runCatching {
                            Triple(
                                draftStore.carregar(),
                                draftStore.carregarChecklistDiario(),
                                draftStore.carregarFormularioAtivo()
                            )
                        }.getOrElse { Triple(null, null, null) }
                    }

                    val (rascunho, rascunhoChecklist, formAtivo) = draftsDeferred.await()
                    val photoInterrupted = PlatformServices.consumePhotoPickerInterrupted()
                    val preferChecklist = formAtivo == FormTipo.CHECKLIST_DIARIO_HTMS.name ||
                        formAtivo == FormTipo.CHECKLIST_DIARIO_AXIA.name ||
                        (photoInterrupted && rascunhoChecklist != null)
                    when {
                        preferChecklist && rascunhoChecklist != null -> {
                            _checklistDiarioForm.value = rascunhoChecklist.first
                            rascunhoChecklistId = rascunhoChecklist.second
                            rascunhoChecklistPronto = true
                            if (photoInterrupted) {
                                abrirRascunhoNaHora(
                                    rascunhoChecklist.first.marcaEnum().formTipo(),
                                    rascunhoChecklist.second
                                )
                            }
                        }
                        rascunho != null -> {
                            _form.value = rascunho.first
                            rascunhoInspecaoId = rascunho.second
                            rascunhoInspecaoPronto = true
                            if (photoInterrupted) {
                                abrirRascunhoNaHora(FormTipo.INSPECAO_CAMPO, rascunho.second)
                            }
                        }
                        rascunhoChecklist != null -> {
                            _checklistDiarioForm.value = rascunhoChecklist.first
                            rascunhoChecklistId = rascunhoChecklist.second
                            rascunhoChecklistPronto = true
                            if (photoInterrupted) {
                                abrirRascunhoNaHora(
                                    rascunhoChecklist.first.marcaEnum().formTipo(),
                                    rascunhoChecklist.second
                                )
                            }
                        }
                    }
                    if (photoInterrupted) {
                        _mensagem.value =
                            "O celular recarregou ao abrir a câmera. O preenchimento foi recuperado — toque em Foto de novo."
                    }

                    val remoteJson = remoteDeferred.await()
                    if (!remoteJson.isNullOrBlank()) {
                        val cfg = runCatching { FormJson.configFromJson(remoteJson) }
                            .getOrDefault(local)
                            .comFormAcessosCompletos()
                            .mesclarComBannerLocal(local.bannerPath)
                        _appConfig.value = cfg
                        InspecaoCatalog.recarregar(cfg)
                        // A liberação do módulo vem da config remota (aparelho novo não tem local).
                        if (_tab.value == AppTab.HUB && _hubSecao.value == HubSecao.RAIZ) {
                            _tab.value = telaInicial(cfg)
                        }
                        withContext(Dispatchers.Default) {
                            runCatching { configStore.salvar(cfg) }
                        }
                    }
                }
            } catch (_: Throwable) {
                // Hub já está visível; rascunho/config remota são best-effort.
            }
        }
    }

    /** Carrega obras ativas da API; fallback para seed embutido. */
    fun carregarObrasAtivas() {
        scope.launch {
            AuthApi.listObrasAtivas()
                .onSuccess { lista ->
                    if (lista.isNotEmpty()) _obrasAtivas.value = lista
                    else _obrasAtivas.value = ObraCatalog.seedAtivas()
                }
                .onFailure {
                    _obrasAtivas.value = ObraCatalog.seedAtivas()
                }
        }
    }

    fun onLoginSuccess(session: AuthSession) {
        _authUser.value = session.user
        _hubSecao.value = HubSecao.RAIZ
        _tab.value = AppTab.HUB
        scope.launch { iniciarAposLogin() }
    }

    fun logout() {
        AuthApi.logout()
        _authUser.value = null
        _remoteInspections.value = emptyList()
        _inspecoes.value = emptyList()
        _hubSecao.value = HubSecao.RAIZ
        _tab.value = AppTab.HUB
        _formTipoAtivo.value = FormTipo.INSPECAO_CAMPO
    }

    fun irPara(tab: AppTab) {
        _tab.value = tab
    }

    fun abrirFormulario(tipo: FormTipo) {
        if (tipo == FormTipo.ANALISE_VISUAL_NR && !FormTipo.ANALISE_VISUAL_NR_ATIVA) {
            _mensagem.value = "Analise visual (IA) esta pausada por enquanto."
            _tab.value = AppTab.HUB
            return
        }
        val user = _authUser.value
        if (user != null && !user.canAccessForm(tipo, _appConfig.value)) {
            _mensagem.value = "Seu perfil não tem acesso a este formulário."
            _tab.value = AppTab.HUB
            return
        }
        _formTipoAtivo.value = tipo
        _erros.value = emptyList()
        val retomarInspecao = tipo == FormTipo.INSPECAO_CAMPO && rascunhoInspecaoPronto
        val retomarChecklist = (tipo == FormTipo.CHECKLIST_DIARIO_HTMS || tipo == FormTipo.CHECKLIST_DIARIO_AXIA) &&
            rascunhoChecklistPronto &&
            _checklistDiarioForm.value.marcaEnum().formTipo() == tipo
        if (!retomarInspecao && !retomarChecklist) _idEdicao.value = null
        val nomePadrao = user?.displayName.orEmpty()
        when (tipo) {
            FormTipo.INSPECAO_CAMPO -> {
                if (retomarInspecao) {
                    rascunhoInspecaoPronto = false
                    _idEdicao.value = rascunhoInspecaoId
                    _rascunhoRestaurado.value = true
                } else {
                    _form.value = FormInspecao(
                        dataHorarioMs = currentTimeMillis(),
                        tstResponsavel = nomePadrao
                    )
                    capturarGps()
                }
            }
            FormTipo.CHECKLIST_DIARIO_HTMS -> {
                if (retomarChecklist) {
                    rascunhoChecklistPronto = false
                    _idEdicao.value = rascunhoChecklistId
                    _rascunhoRestaurado.value = true
                } else {
                    _checklistDiarioForm.value = FormChecklistDiario.novo(ChecklistDiarioMarca.HTMS)
                        .copy(preenchidoPor = nomePadrao)
                    capturarGpsChecklistDiario()
                }
            }
            FormTipo.CHECKLIST_DIARIO_AXIA -> {
                if (retomarChecklist) {
                    rascunhoChecklistPronto = false
                    _idEdicao.value = rascunhoChecklistId
                    _rascunhoRestaurado.value = true
                } else {
                    _checklistDiarioForm.value = FormChecklistDiario.novo(ChecklistDiarioMarca.AXIA)
                        .copy(preenchidoPor = nomePadrao)
                    capturarGpsChecklistDiario()
                }
            }
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> {
                if (!restaurarRascunhoAlojamento(tipo)) {
                    _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
                    capturarGpsRelatorio()
                }
            }
            FormTipo.CHECKLIST_ALOJAMENTO -> {
                if (!restaurarRascunhoAlojamento(tipo)) {
                    _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
                    capturarGpsChecklist()
                }
            }
            FormTipo.CHECKLIST_VETORES -> {
                if (!restaurarRascunhoAlojamento(tipo)) {
                    _checklistForm.value = ChecklistVetoresCatalog.novo()
                    capturarGpsChecklist()
                }
            }
            FormTipo.RELATORIO_ALOJAMENTO -> {
                if (!restaurarRascunhoAlojamento(tipo)) {
                    val ms = currentTimeMillis()
                    _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = ms)
                    _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = ms)
                    capturarGpsRelatorioAlojamento()
                }
            }
            FormTipo.COMUNICACAO_OCORRENCIAS -> {
                _ocorrenciasForm.value = FormComunicacaoOcorrencias(
                    dataHorarioMs = currentTimeMillis(),
                    quemReportando = nomePadrao
                )
                capturarGpsOcorrencias()
            }
            FormTipo.REM_SEGURANCA_OBRAS -> {
                _remForm.value = FormRemSeguranca(ano = yearOf(currentTimeMillis()))
                carregarRascunhoRemLocal()
            }
            FormTipo.RELATORIO_SEGURANCA -> {
                val y = yearOf(currentTimeMillis())
                val m = monthOf(currentTimeMillis())
                _relSegForm.value = br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca(ano = y, mes = m)
                carregarRascunhoRelSegLocal()
            }
            FormTipo.ACOMPANHAMENTO_AMBIENTAL -> {
                _acompAmbForm.value = FormAcompanhamentoAmbiental(ano = yearOf(currentTimeMillis()))
            }
            FormTipo.EVIDENCIA_TREINAMENTO -> Unit
            FormTipo.ANALISE_VISUAL_NR -> {
                _analiseVisualNrForm.value =
                    br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr(
                        dataHorarioMs = currentTimeMillis(),
                        tstResponsavel = nomePadrao
                    )
                capturarGpsAnaliseVisualNr()
            }
        }
        _tab.value = AppTab.FORM
        registrarAberturaFormulario(tipo, editando = false)
    }

    fun voltarAoHub() {
        _erros.value = emptyList()
        _tab.value = AppTab.HUB
    }

    /** Recarregamento da câmera: volta direto ao formulário que estava aberto. */
    private fun abrirRascunhoNaHora(tipo: FormTipo, id: Long?) {
        _formTipoAtivo.value = tipo
        _idEdicao.value = id
        _rascunhoRestaurado.value = true
        _tab.value = AppTab.FORM
        if (tipo == FormTipo.INSPECAO_CAMPO) rascunhoInspecaoPronto = false
        else rascunhoChecklistPronto = false
    }

    /** Voltar da config: hub (formulários + histórico disponíveis para todos). */
    fun voltarDaConfig() {
        _tab.value = AppTab.HUB
    }

    private val _hubSecao = MutableStateFlow(HubSecao.RAIZ)
    val hubSecao: StateFlow<HubSecao> = _hubSecao.asStateFlow()

    fun abrirHubSecao(secao: HubSecao) {
        _hubSecao.value = secao
        _tab.value = AppTab.HUB
    }

    /** Emissão de Documentos: Master ou admin liberado pelo Master (Config → Usuários). */
    val podeEmitirDocumentos: Boolean
        get() = _authUser.value?.podeEmitirDocumentos(_appConfig.value) == true

    private fun recusaAbaColab(chave: String): Boolean {
        if (ColabEscopo.mostra(_authUser.value, _appConfig.value, chave)) return false
        _mensagem.value = "Esta aba não está liberada para a sua TAG."
        return true
    }

    private fun recusaAlterarColab(): Boolean {
        val visao = ColabEscopo.visao(_authUser.value, _appConfig.value) ?: return false
        if (!visao.somenteVer) return false
        _mensagem.value = "Sua TAG não pode editar o cadastro dos colaboradores."
        return true
    }

    private val _gerandoOrdemServico = MutableStateFlow(false)
    val gerandoOrdemServico: StateFlow<Boolean> = _gerandoOrdemServico.asStateFlow()

    /** Incrementa a cada documento salvo — telas recarregam a lista do funcionário. */
    private val _documentosVersao = MutableStateFlow(0)
    val documentosVersao: StateFlow<Int> = _documentosVersao.asStateFlow()

    private val _abrindoDocumentoId = MutableStateFlow<String?>(null)
    val abrindoDocumentoId: StateFlow<String?> = _abrindoDocumentoId.asStateFlow()

    fun abrirOrdemServico() {
        if (!podeEmitirDocumentos) {
            _mensagem.value = "Seu usuário não está liberado para Colaboradores QSMS (emissão de documentos)."
            return
        }
        if (recusaAbaColab(ColabEscopo.DOC_OS)) return
        _erros.value = emptyList()
        _tab.value = AppTab.ORDEM_SERVICO
        registrarAcesso("OS_OPEN", null)
    }

    /** Subaba de Funcionários: CADASTRO | DASHBOARD | IMPORTAR (menu lateral de Documentos). */
    private val _funcionariosSubAba = MutableStateFlow("CADASTRO")
    val funcionariosSubAba: StateFlow<String> = _funcionariosSubAba.asStateFlow()

    fun abrirFuncionarios(subAba: String = "CADASTRO") {
        if (!podeEmitirDocumentos) {
            _mensagem.value = "Seu usuário não está liberado para Colaboradores QSMS (emissão de documentos)."
            return
        }
        val chave = when (subAba.uppercase()) {
            "DASHBOARD" -> ColabEscopo.DOC_DASHBOARD
            "IMPORTAR" -> ColabEscopo.DOC_IMPORTAR
            else -> ColabEscopo.DOC_FUNCIONARIOS
        }
        if (recusaAbaColab(chave) || recusaAlterarColab()) return
        _erros.value = emptyList()
        _funcionariosSubAba.value = when (subAba.uppercase()) {
            "DASHBOARD" -> "DASHBOARD"
            "IMPORTAR" -> "IMPORTAR"
            else -> "CADASTRO"
        }
        _tab.value = AppTab.FUNCIONARIOS
    }

    val podeAcessarAtivos: Boolean
        get() = _authUser.value?.podeAcessarAtivos(_appConfig.value) == true

    fun abrirAtivos() {
        if (!podeAcessarAtivos) {
            _mensagem.value = "Seu usuário não está liberado para o Controle de Ativos."
            return
        }
        _erros.value = emptyList()
        _tab.value = AppTab.ATIVOS
        registrarAcesso("ATIVO_OPEN", null)
    }

    /** Subaba da matriz QSMS (nome de [ColabAba]); usada ao voltar do menu de documentos. */
    private val _colaboradoresSubAba = MutableStateFlow("PAINEL")
    val colaboradoresSubAba: StateFlow<String> = _colaboradoresSubAba.asStateFlow()

    fun abrirColaboradores(subAba: String = "PAINEL") {
        if (_authUser.value?.podeAcessarColaboradores != true) {
            _mensagem.value = "Seu usuário não está liberado para o módulo Colaboradores QSMS."
            return
        }
        val pedida = subAba.ifBlank { "PAINEL" }
        val aba = if (ColabEscopo.mostra(_authUser.value, _appConfig.value, pedida)) {
            pedida
        } else {
            ColabEscopo.abasMatriz.firstOrNull { ColabEscopo.mostra(_authUser.value, _appConfig.value, it.first) }?.first
        }
        if (aba == null) {
            _mensagem.value = "Nenhuma aba de Colaboradores está liberada para a sua TAG."
            return
        }
        _erros.value = emptyList()
        _colaboradoresSubAba.value = aba
        _tab.value = AppTab.COLABORADORES
        registrarAcesso("COLABORADOR_OPEN", null)
    }

    fun abrirEfetivo() {
        if (_authUser.value?.podeAcessarEfetivo != true) {
            _mensagem.value = "Seu usuário não está liberado para o módulo Controle de Efetivo."
            return
        }
        _erros.value = emptyList()
        _tab.value = AppTab.EFETIVO
        registrarAcesso("EFETIVO_OPEN", null)
    }

    fun abrirEstoque() {
        if (_authUser.value?.podeAcessarEstoque != true) {
            _mensagem.value = "Seu usuário não está liberado para o módulo Estoque."
            return
        }
        _erros.value = emptyList()
        _tab.value = AppTab.ESTOQUE
        registrarAcesso("ESTOQUE_OPEN", null)
    }

    fun abrirOcorrencias() {
        if (_authUser.value?.podeAcessarOcorrencias != true) {
            _mensagem.value = "Seu usuário não está liberado para o Gestão de Ocorrências."
            return
        }
        _erros.value = emptyList()
        _tab.value = AppTab.OCORRENCIAS
        registrarAcesso("OCORRENCIA_OPEN", null)
    }

    fun abrirDashboards() {
        if (_authUser.value?.podeAcessarDashboards != true) {
            _mensagem.value = "Seu usuário não está liberado para o módulo Dashboards."
            return
        }
        _erros.value = emptyList()
        _tab.value = AppTab.DASHBOARDS
        registrarAcesso("DASHBOARD_OPEN", null)
    }

    /** Funcionário a pré-preencher na próxima abertura da OS (consumido pela tela). */
    private val _osFuncionarioInicial = MutableStateFlow<Funcionario?>(null)
    val osFuncionarioInicial: StateFlow<Funcionario?> = _osFuncionarioInicial.asStateFlow()

    fun emitirOrdemServicoPara(funcionario: Funcionario) {
        _osFuncionarioInicial.value = funcionario
        abrirOrdemServico()
    }

    /** Preenche a OS sem sair da tela atual (modal da ficha). */
    fun preencherOs(funcionario: Funcionario) {
        _osFuncionarioInicial.value = funcionario
    }

    fun consumirOsFuncionarioInicial() {
        _osFuncionarioInicial.value = null
    }

    fun notificarDocumentosAlterados() {
        _documentosVersao.value += 1
    }

    /**
     * Gera o PDF, abre/compartilha e — com CPF válido — grava o funcionário e anexa a OS ao cadastro.
     */
    fun gerarOrdemServicoPdf(
        dados: OrdemServicoDados,
        cpf: String = "",
        cargoId: String = ""
    ) {
        if (!podeEmitirDocumentos || recusaAbaColab(ColabEscopo.DOC_OS) || _gerandoOrdemServico.value) return
        _gerandoOrdemServico.value = true
        scope.launch {
            try {
                val bytes = OrdemServicoPdfBuilder.build(dados)
                compartilharESalvarDocumento(
                    bytes = bytes,
                    prefixoArquivo = "OS",
                    rotulo = "Ordem de Serviço",
                    nome = dados.nome,
                    cpf = cpf,
                    admissao = dados.admissao,
                    cargoId = cargoId,
                    cargoNome = dados.funcao,
                    setorGhe = dados.setorGhe,
                    tipo = "OS",
                    titulo = "Ordem de Serviço - ${dados.funcao}"
                )
            } catch (t: Throwable) {
                registrarAcesso("OS_FAIL", dados.nome, "error=${encodeLogValue(t.message)}")
                _mensagem.value = "Erro ao gerar a Ordem de Serviço: ${t.message}"
            } finally {
                _gerandoOrdemServico.value = false
            }
        }
    }

    fun abrirFichaEpi() {
        if (!podeEmitirDocumentos) {
            _mensagem.value = "Seu usuário não está liberado para Colaboradores QSMS (emissão de documentos)."
            return
        }
        if (recusaAbaColab(ColabEscopo.DOC_EPI)) return
        _erros.value = emptyList()
        _tab.value = AppTab.FICHA_EPI
        registrarAcesso("FICHA_EPI_OPEN", null)
    }

    private val _fichaEpiFuncionarioInicial = MutableStateFlow<Funcionario?>(null)
    val fichaEpiFuncionarioInicial: StateFlow<Funcionario?> = _fichaEpiFuncionarioInicial.asStateFlow()

    fun emitirFichaEpiPara(funcionario: Funcionario) {
        _fichaEpiFuncionarioInicial.value = funcionario
        abrirFichaEpi()
    }

    fun preencherFichaEpi(funcionario: Funcionario) {
        _fichaEpiFuncionarioInicial.value = funcionario
    }

    fun consumirFichaEpiFuncionarioInicial() {
        _fichaEpiFuncionarioInicial.value = null
    }

    private val _gerandoFichaEpi = MutableStateFlow(false)
    val gerandoFichaEpi: StateFlow<Boolean> = _gerandoFichaEpi.asStateFlow()

    fun gerarFichaEpiPdf(dados: FichaEpiDados, cargoId: String, setorGhe: String) {
        if (!podeEmitirDocumentos || recusaAbaColab(ColabEscopo.DOC_EPI) || _gerandoFichaEpi.value) return
        _gerandoFichaEpi.value = true
        scope.launch {
            try {
                val bytes = FichaEpiPdfBuilder.build(dados)
                compartilharESalvarDocumento(
                    bytes = bytes,
                    prefixoArquivo = "FICHA_EPI",
                    rotulo = "Ficha de EPI",
                    nome = dados.nome,
                    cpf = dados.cpf,
                    admissao = dados.admissao,
                    cargoId = cargoId,
                    cargoNome = dados.funcao,
                    setorGhe = setorGhe,
                    tipo = "FICHA_EPI",
                    titulo = "Ficha de EPI - entrega ${dados.dataEntrega}",
                    matricula = dados.matricula.trim().ifBlank { null }
                )
            } catch (t: Throwable) {
                registrarAcesso("FICHA_EPI_FAIL", dados.nome, "error=${encodeLogValue(t.message)}")
                _mensagem.value = "Erro ao gerar a Ficha de EPI: ${t.message}"
            } finally {
                _gerandoFichaEpi.value = false
            }
        }
    }

    fun salvarRelacaoEpi(lista: List<EpiRelacaoItem>) {
        if (!podeEmitirDocumentos || recusaAbaColab(ColabEscopo.DOC_EPI)) return
        scope.launch {
            runCatching {
                epiRelacaoStore.salvar(lista)
                _epiRelacao.value = lista
                EpiCatalog.definirRelacao(lista)
                _mensagem.value = "Catálogo de EPI / C.A atualizado."
            }.onFailure {
                _mensagem.value = "Não foi possível salvar o catálogo de EPI: ${it.message}"
            }
        }
    }

    fun restaurarRelacaoEpiPadrao() {
        salvarRelacaoEpi(EpiCatalog.seedRelacao())
    }

    fun abrirCertificados() {
        if (!podeEmitirDocumentos) {
            _mensagem.value = "Seu usuário não está liberado para Colaboradores QSMS (emissão de documentos)."
            return
        }
        if (recusaAbaColab(ColabEscopo.DOC_CERTIFICADO)) return
        _erros.value = emptyList()
        _tab.value = AppTab.CERTIFICADO
        registrarAcesso("CERTIFICADO_OPEN", null)
    }

    fun abrirApr() {
        if (!podeEmitirDocumentos) {
            _mensagem.value = "Seu usuário não está liberado para Colaboradores QSMS (emissão de documentos)."
            return
        }
        if (recusaAbaColab(ColabEscopo.DOC_APR)) return
        _erros.value = emptyList()
        _tab.value = AppTab.APR
        registrarAcesso("APR_OPEN", null)
    }

    private fun aprNova(): br.com.htms.inspeccaocampo.data.apr.AprDados {
        val agora = br.com.htms.inspeccaocampo.platform.currentTimeMillis()
        return br.com.htms.inspeccaocampo.data.apr.AprDados(
            emissao = br.com.htms.inspeccaocampo.platform.formatDateBr(agora).substringBefore(' '),
            vigencia = br.com.htms.inspeccaocampo.platform.formatDateBr(agora + 14L * 86_400_000L).substringBefore(' ')
        )
    }

    private val _aprRascunho = MutableStateFlow(aprNova())
    val aprRascunho: StateFlow<br.com.htms.inspeccaocampo.data.apr.AprDados> = _aprRascunho.asStateFlow()

    fun atualizarApr(f: (br.com.htms.inspeccaocampo.data.apr.AprDados) -> br.com.htms.inspeccaocampo.data.apr.AprDados) {
        _aprRascunho.value = f(_aprRascunho.value)
    }

    fun limparApr() {
        _aprRascunho.value = aprNova()
    }

    private val _gerandoApr = MutableStateFlow(false)
    val gerandoApr: StateFlow<Boolean> = _gerandoApr.asStateFlow()

    /** Gera a APR do rascunho em PDF (paisagem) ou Excel e abre/compartilha o arquivo. */
    fun gerarApr(excel: Boolean) {
        if (!podeEmitirDocumentos || recusaAbaColab(ColabEscopo.DOC_APR) || _gerandoApr.value) return
        _gerandoApr.value = true
        val d = _aprRascunho.value
        scope.launch {
            try {
                val bytes = if (excel) br.com.htms.inspeccaocampo.export.AprXlsxBuilder.build(d)
                else br.com.htms.inspeccaocampo.export.AprPdfBuilder.build(d)
                val num = d.numeroApr.trim().map { if (it.isLetterOrDigit() && it.code < 128) it else '_' }
                    .joinToString("").trim('_').ifBlank { "SN" }
                val data = d.emissao.replace('/', '-').ifBlank { "sem-data" }
                val fileName = "APR_${num}_$data." + if (excel) "xlsx" else "pdf"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), fileName)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_DOCUMENTOS, "APR") {
                    PlatformFiles.shareFile(
                        path,
                        if (excel) br.com.htms.inspeccaocampo.export.AprXlsxBuilder.MIME else "application/pdf",
                        "APR ${d.numeroApr}"
                    )
                }
                _mensagem.value = "APR gerada em ${if (excel) "Excel" else "PDF"}: $fileName"
                registrarAcesso(
                    "APR_EMITIDO",
                    d.numeroApr.trim().ifBlank { null },
                    "formato=${if (excel) "excel" else "pdf"};emissao=${encodeLogValue(d.emissao)};arquivo=${encodeLogValue(fileName)}"
                )
            } catch (t: Throwable) {
                registrarAcesso("APR_FAIL", d.numeroApr.trim().ifBlank { null }, "error=${encodeLogValue(t.message)}")
                _mensagem.value = "Erro ao gerar a APR: ${t.message}"
            } finally {
                _gerandoApr.value = false
            }
        }
    }

    private val _certificadoFuncionarioInicial = MutableStateFlow<Funcionario?>(null)
    val certificadoFuncionarioInicial: StateFlow<Funcionario?> = _certificadoFuncionarioInicial.asStateFlow()

    fun emitirCertificadoPara(funcionario: Funcionario) {
        _certificadoFuncionarioInicial.value = funcionario
        abrirCertificados()
    }

    fun preencherCertificado(funcionario: Funcionario) {
        _certificadoFuncionarioInicial.value = funcionario
    }

    fun consumirCertificadoFuncionarioInicial() {
        _certificadoFuncionarioInicial.value = null
    }

    private val _gerandoCertificado = MutableStateFlow(false)
    val gerandoCertificado: StateFlow<Boolean> = _gerandoCertificado.asStateFlow()

    /** Gera o certificado, abre/compartilha e anexa ao cadastro do funcionário (sem alterar os dados dele). */
    fun gerarCertificadoPdf(dados: CertificadoDados, funcionario: Funcionario) {
        if (!podeEmitirDocumentos || recusaAbaColab(ColabEscopo.DOC_CERTIFICADO) || _gerandoCertificado.value) return
        _gerandoCertificado.value = true
        scope.launch {
            try {
                val bytes = CertificadoPdfBuilder.build(dados)
                val slug = dados.nome.trim().uppercase()
                    .map { if (it.isLetterOrDigit() && it.code < 128) it else '_' }
                    .joinToString("").replace(Regex("_+"), "_").trim('_').ifBlank { "FUNCIONARIO" }
                val fileName = "CERTIFICADO_${dados.modelo.chave.uppercase()}_$slug.pdf"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), fileName)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_DOCUMENTOS, "Certificados", colaborador = funcionario.nome.ifBlank { dados.nome }) {
                    PlatformFiles.shareFile(path, "application/pdf", "Certificado ${dados.modelo.rotulo}")
                }
                val periodo = if (dados.inicio == dados.fim) dados.inicio else "${dados.inicio} a ${dados.fim}"
                FuncionariosApi.enviarDocumento(
                    funcionarioId = funcionario.id,
                    bytes = bytes,
                    tipo = "CERTIFICADO",
                    titulo = "Certificado ${dados.modelo.rotulo} ($periodo)",
                    fileName = fileName,
                    emitido = true
                ).onSuccess {
                    notificarDocumentosAlterados()
                    _mensagem.value = "Certificado ${dados.modelo.rotulo} gerado e salvo no cadastro de ${funcionario.nome}."
                }.onFailure {
                    registrarAcesso(
                        "CERTIFICADO_EMITIDO",
                        funcionario.nome,
                        "modelo=${encodeLogValue(dados.modelo.rotulo)};salvo=nao;error=${encodeLogValue(it.message)}"
                    )
                    _mensagem.value = "Certificado gerado, mas não salvou no cadastro: ${it.message}"
                }
            } catch (t: Throwable) {
                registrarAcesso("CERTIFICADO_FAIL", funcionario.nome, "error=${encodeLogValue(t.message)}")
                _mensagem.value = "Erro ao gerar o certificado: ${t.message}"
            } finally {
                _gerandoCertificado.value = false
            }
        }
    }

    /** Abre/compartilha o PDF e — com CPF válido — grava o funcionário e anexa o documento ao cadastro. */
    private suspend fun compartilharESalvarDocumento(
        bytes: ByteArray,
        prefixoArquivo: String,
        rotulo: String,
        nome: String,
        cpf: String,
        admissao: String,
        cargoId: String,
        cargoNome: String,
        setorGhe: String,
        tipo: String,
        titulo: String,
        matricula: String? = null
    ) {
        val slug = nome.trim().uppercase()
            .map { if (it.isLetterOrDigit() && it.code < 128) it else '_' }
            .joinToString("").replace(Regex("_+"), "_").trim('_').ifBlank { "FUNCIONARIO" }
        val fileName = "${prefixoArquivo}_$slug.pdf"
        val path = PlatformFiles.join(PlatformFiles.cacheDir(), fileName)
        PlatformFiles.writeBytes(path, bytes)
        br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_DOCUMENTOS, rotulo, colaborador = nome) {
            PlatformFiles.shareFile(path, "application/pdf", rotulo)
        }
        val acaoLog = "${tipo}_EMITIDO"
        if (!Cpf.valido(cpf)) {
            registrarAcesso(acaoLog, nome, "titulo=${encodeLogValue(titulo)};salvo=nao;motivo=sem-cpf")
            _mensagem.value = "PDF ($rotulo) gerado — sem CPF, não foi salvo no cadastro do funcionário."
            return
        }
        FuncionariosApi.salvar(
            nome = nome,
            cpf = cpf,
            admissao = admissao,
            cargoId = cargoId,
            cargoNome = cargoNome,
            setorGhe = setorGhe,
            matricula = matricula
        ).mapCatching { func ->
            FuncionariosApi.enviarDocumento(
                funcionarioId = func.id,
                bytes = bytes,
                tipo = tipo,
                titulo = titulo,
                fileName = fileName,
                emitido = true
            ).getOrThrow()
        }.onSuccess {
            notificarDocumentosAlterados()
            _mensagem.value = "PDF ($rotulo) gerado e salvo no cadastro de $nome."
        }.onFailure {
            registrarAcesso(acaoLog, nome, "titulo=${encodeLogValue(titulo)};salvo=nao;error=${encodeLogValue(it.message)}")
            _mensagem.value = "PDF gerado, mas não salvou no cadastro: ${it.message}"
        }
    }

    /** Baixa um documento do cadastro e abre/compartilha no aparelho. */
    fun abrirDocumentoFuncionario(doc: FuncionarioDocumento) {
        if (_abrindoDocumentoId.value != null) return
        _abrindoDocumentoId.value = doc.id
        scope.launch {
            FuncionariosApi.baixar(doc.id)
                .onSuccess { bytes ->
                    val path = PlatformFiles.join(PlatformFiles.cacheDir(), doc.fileName.ifBlank { "documento" })
                    PlatformFiles.writeBytes(path, bytes)
                    br.com.htms.inspeccaocampo.platform.BackupSharePoint.semBackup {
                        PlatformFiles.viewFile(path, doc.contentType.ifBlank { "application/pdf" }, doc.titulo.ifBlank { doc.fileName })
                    }
                }
                .onFailure { _mensagem.value = "Não foi possível abrir o documento: ${it.message}" }
            _abrindoDocumentoId.value = null
        }
    }

    /** Usuário cujo único módulo é o Controle de Ativos vai direto para ele. */
    private fun telaInicial(config: AppConfig): AppTab {
        val user = _authUser.value ?: return AppTab.HUB
        if (user.isMaster || !user.podeAcessarAtivos(config) || user.podeEmitirDocumentos(config)) return AppTab.HUB
        val temFormulario = FormTipo.hubEntries.any { tipo ->
            (tipo != FormTipo.ANALISE_VISUAL_NR || FormTipo.ANALISE_VISUAL_NR_ATIVA) && user.canAccessForm(tipo, config)
        }
        return if (temFormulario) AppTab.HUB else AppTab.ATIVOS
    }

    fun consumirMensagem() {
        _mensagem.value = null
    }

    private val _planilhaGerando = MutableStateFlow<br.com.htms.inspeccaocampo.export.PlanilhaModulo?>(null)
    val planilhaGerando: StateFlow<br.com.htms.inspeccaocampo.export.PlanilhaModulo?> = _planilhaGerando.asStateFlow()

    /** Planilha completa do módulo (abas de dados + dashboard); a cópia vai para a pasta "Planilhas" do módulo no SharePoint. */
    fun baixarPlanilhaModulo(m: br.com.htms.inspeccaocampo.export.PlanilhaModulo) {
        if (_planilhaGerando.value != null) return
        _planilhaGerando.value = m
        scope.launch {
            runCatching {
                val bytes = gerarPlanilhaModulo(m)
                val data = br.com.htms.inspeccaocampo.data.colaboradores.DatasColab.run { isoDeDias(hoje()) }
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), "Planilha_${m.arquivo}_$data.xlsx")
                PlatformFiles.writeBytes(path, bytes)
                val (modulo, formulario, obra) = when (m) {
                    br.com.htms.inspeccaocampo.export.PlanilhaModulo.FUNCIONARIOS -> Triple(MODULO_DOCUMENTOS, "Planilhas", "")
                    br.com.htms.inspeccaocampo.export.PlanilhaModulo.RELATORIO_SEGURANCA ->
                        Triple(MODULO_FORMULARIOS, FormTipo.RELATORIO_SEGURANCA.rotulo, "Planilhas")
                    else -> Triple(m.rotulo, "Planilhas", "")
                }
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(modulo, formulario, obra) {
                    PlatformFiles.shareFile(path, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "Planilha ${m.rotulo}")
                }
            }.onSuccess {
                _mensagem.value = "Planilha de ${m.rotulo} gerada."
            }.onFailure {
                if (it is CancellationException) throw it
                _mensagem.value = "Não foi possível gerar a planilha de ${m.rotulo}: ${it.message}"
            }
            _planilhaGerando.value = null
        }
    }

    private suspend fun gerarPlanilhaModulo(m: br.com.htms.inspeccaocampo.export.PlanilhaModulo): ByteArray {
        return when (m) {
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.ATIVOS -> {
                val d = br.com.htms.inspeccaocampo.data.ativos.AtivosApi.dados().getOrThrow() ?: error("sem dados do Controle de Ativos")
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaAtivos.build(d) }
            }
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.OCORRENCIAS -> {
                val d = br.com.htms.inspeccaocampo.data.ocorrencias.OcorrenciasApi.dados().getOrThrow()
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaOcorrencias.build(d) }
            }
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.COLABORADORES -> {
                val d = br.com.htms.inspeccaocampo.data.colaboradores.ColaboradoresApi.dados().getOrThrow()
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaColaboradores.build(d) }
            }
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.EFETIVO -> {
                val d = br.com.htms.inspeccaocampo.data.efetivo.EfetivoApi.dados().getOrThrow()
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaEfetivo.build(d) }
            }
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.FUNCIONARIOS -> {
                val lista = FuncionariosApi.listar().getOrThrow()
                val docs = FuncionariosApi.resumoDocumentos().getOrElse { emptyList() }
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaFuncionarios.build(lista, docs) }
            }
            br.com.htms.inspeccaocampo.export.PlanilhaModulo.RELATORIO_SEGURANCA -> {
                val d = AuthApi.listRelSegDossiers(all = isAdmin).getOrThrow()
                withContext(Dispatchers.Default) { br.com.htms.inspeccaocampo.export.PlanilhaRelSeg.build(d) }
            }
        }
    }

    fun consumirAvisoRascunho() {
        _rascunhoRestaurado.value = false
    }

    fun limparMensagemHistorico() {
        _historico.value = _historico.value.copy(mensagem = null)
    }

    fun atualizar(block: (FormInspecao) -> FormInspecao) {
        _form.value = block(_form.value)
        persistirRascunhoDebounced()
    }

    fun atualizarItem(itemId: String, block: (ItemVerificacao) -> ItemVerificacao) {
        _form.value = _form.value.copy(
            itens = _form.value.itens.map { if (it.id == itemId) block(it) else it }
        )
        persistirRascunhoDebounced()
    }

    fun definirResposta(itemId: String, resposta: RespostaTernaria) {
        atualizarItem(itemId) { it.copy(resposta = resposta) }
    }

    private suspend fun obterFotoCapturada(fromGallery: Boolean): CapturedPhoto? {
        // Grava rascunho ANTES da câmera (Safari iOS pode recarregar a página).
        persistirRascunhoImediato()
        persistirRascunhoChecklistDiarioImediato()
        persistirRascunhoAlojamentoImediato()
        runCatching { draftStore.marcarFormularioAtivo(_formTipoAtivo.value.name) }
        val captured = if (fromGallery) {
            PlatformServices.pickImage()
        } else {
            PlatformServices.capturePhoto()
        }
        if (captured == null) {
            _mensagem.value = when {
                PlatformServices.consumeLastPhotoBlockedInAppBrowser() ->
                    "Câmera indisponível neste navegador. No iPhone: toque em ⋯ → Abrir no Safari."
                PlatformServices.consumeLastPhotoPickCancelled() ->
                    if (fromGallery) "Seleção da galeria cancelada."
                    else "Captura de foto cancelada ou indisponível."
                fromGallery ->
                    "Não foi possível abrir a galeria ou processar a imagem."
                else ->
                    "Não foi possível capturar ou processar a foto. Tente de novo."
            }
        }
        return captured
    }

    fun adicionarFotoItem(itemId: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val item = _form.value.itens.find { it.id == itemId }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _form.value.tstResponsavel,
                        pergunta = item?.titulo ?: itemId,
                        resposta = item?.resposta?.rotulo ?: "Sim",
                        responsavelFrente = _form.value.responsavelFrente,
                        localTexto = _form.value.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _form.value.latitude,
                        longitude = captured.longitude ?: _form.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value =
                        "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                            "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    conteudoBase64 = embedded
                )
                atualizarItem(itemId) {
                    it.copy(fotos = it.fotos + foto, resposta = RespostaTernaria.SIM)
                }
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    /** Compat com UI antiga. */
    fun adicionarFotoPlaceholder(itemId: String, fromGallery: Boolean = false) =
        adicionarFotoItem(itemId, fromGallery)

    fun removerUltimaFotoItem(itemId: String) {
        atualizarItem(itemId) { item ->
            if (item.fotos.isEmpty()) item else item.copy(fotos = item.fotos.dropLast(1))
        }
    }

    fun removerFotoItem(itemId: String, foto: FotoAnexo) {
        atualizarItem(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
    }

    fun definirRespostaSecao(campo: String, resposta: RespostaSimNao) {
        atualizarSecao(campo) { it.copy(resposta = resposta) }
    }

    fun atualizarDescricaoSecao(campo: String, descricao: String) {
        atualizarSecao(campo) { it.copy(descricao = descricao) }
    }

    fun adicionarFotoSecao(campo: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _form.value.tstResponsavel,
                        pergunta = if (campo == "acoesCorretivas") "Ações Corretivas" else campo,
                        resposta = "Sim",
                        responsavelFrente = _form.value.responsavelFrente,
                        localTexto = _form.value.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _form.value.latitude,
                        longitude = captured.longitude ?: _form.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value =
                        "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                            "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    conteudoBase64 = embedded
                )
                atualizarSecao(campo) { it.copy(fotos = it.fotos + foto, resposta = RespostaSimNao.SIM) }
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun adicionarFotoSecaoPlaceholder(campo: String, fromGallery: Boolean = false) =
        adicionarFotoSecao(campo, fromGallery)

    fun removerUltimaFotoSecao(campo: String) {
        atualizarSecao(campo) { secao ->
            if (secao.fotos.isEmpty()) secao else secao.copy(fotos = secao.fotos.dropLast(1))
        }
    }

    fun removerFotoSecao(campo: String, foto: FotoAnexo) {
        atualizarSecao(campo) { secao ->
            secao.copy(fotos = secao.fotos.filter { it.id != foto.id })
        }
    }

    fun adicionarFotoInformacoesAdicionais(fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _form.value.tstResponsavel,
                        pergunta = "Informações adicionais",
                        resposta = "OBS",
                        responsavelFrente = _form.value.responsavelFrente,
                        localTexto = _form.value.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _form.value.latitude,
                        longitude = captured.longitude ?: _form.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value =
                        "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                            "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    conteudoBase64 = embedded
                )
                _form.value = _form.value.copy(
                    informacoesAdicionaisFotos = _form.value.informacoesAdicionaisFotos + foto
                )
                persistirRascunhoDebounced()
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoInformacoesAdicionais(foto: FotoAnexo) {
        _form.value = _form.value.copy(
            informacoesAdicionaisFotos = _form.value.informacoesAdicionaisFotos.filter { it.id != foto.id }
        )
        persistirRascunhoDebounced()
    }

    fun atualizarItemExtra(itemId: String, block: (ItemCampoPersonalizado) -> ItemCampoPersonalizado) {
        atualizar { form ->
            form.copy(
                itensExtra = form.itensExtra.map { item ->
                    if (item.id == itemId) block(item) else item
                }
            )
        }
    }

    fun adicionarItemExtra() {
        atualizar { it.copy(itensExtra = it.itensExtra + ItemCampoPersonalizado()) }
    }

    fun removerItemExtra(itemId: String) {
        atualizar { form ->
            val restantes = form.itensExtra.filter { it.id != itemId }
            form.copy(
                itensExtra = restantes.ifEmpty { listOf(ItemCampoPersonalizado()) }
            )
        }
    }

    fun definirRespostaItemExtra(itemId: String, resposta: RespostaTernaria?) {
        atualizarItemExtra(itemId) { it.copy(resposta = resposta) }
    }

    fun adicionarFotoItemExtra(itemId: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val idx = _form.value.itensExtra.indexOfFirst { it.id == itemId }
                val item = _form.value.itensExtra.getOrNull(idx) ?: return@launchFoto
                val pergunta = item.titulo.ifBlank {
                    if (idx >= 0) item.rotuloSequencia(idx) else "Item extra"
                }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _form.value.tstResponsavel,
                        pergunta = pergunta,
                        resposta = item.resposta?.rotulo ?: "OBS",
                        responsavelFrente = _form.value.responsavelFrente,
                        localTexto = _form.value.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _form.value.latitude,
                        longitude = captured.longitude ?: _form.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value =
                        "Não foi possível carimbar a foto. No iPhone, use a câmera do app " +
                            "(JPEG) — fotos HEIC da galeria não são suportadas no navegador."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _form.value.latitude,
                    longitude = captured.longitude ?: _form.value.longitude,
                    conteudoBase64 = embedded
                )
                atualizarItemExtra(itemId) { it.copy(fotos = it.fotos + foto) }
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoItemExtra(itemId: String, foto: FotoAnexo) {
        atualizarItemExtra(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
    }

    private fun atualizarSecao(campo: String, block: (SecaoSimNao) -> SecaoSimNao) {
        _form.value = when (campo) {
            "desvios" -> _form.value.copy(desviosEncontrados = block(_form.value.desviosEncontrados))
            "acoesCorretivas" -> _form.value.copy(acoesCorretivas = block(_form.value.acoesCorretivas))
            else -> _form.value
        }
        persistirRascunhoDebounced()
    }

    fun capturarGps() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _form.value = _form.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                persistirRascunhoDebounced()
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun iniciarNovaInspecao() {
        draftStore.limpar()
        _modoTreinamento.value = false
        _erros.value = emptyList()
        _idEdicao.value = null
        _form.value = FormInspecao(dataHorarioMs = currentTimeMillis())
        capturarGps()
        _mensagem.value = "Nova inspeção iniciada."
    }

    fun ativarTreinamento() {
        draftStore.limpar()
        _modoTreinamento.value = true
        _erros.value = emptyList()
        _idEdicao.value = null
        _form.value = TreinamentoDados.formularioExemplo()
        _mensagem.value = "Modo treinamento ativo (não persiste no histórico)."
    }

    fun desativarTreinamento() {
        _modoTreinamento.value = false
        iniciarNovaInspecao()
    }

    fun abrirAssinatura(campo: String) {
        _assinaturaEditando.value = campo
    }

    fun fecharAssinatura() {
        _assinaturaEditando.value = null
    }

    fun salvarAssinatura(campo: String, dados: String) {
        _form.value = when (campo) {
            "supervisor" -> _form.value.copy(assinaturaSupervisor = dados)
            "sesmt" -> _form.value.copy(assinaturaSesmt = dados)
            else -> _form.value
        }
        _assinaturaEditando.value = null
        persistirRascunhoDebounced()
    }

    fun erroNoCampo(campo: String): String? =
        _erros.value.find { it.campo == campo }?.mensagem

    fun validarESalvar() {
        val atual = _form.value.copy(dataHorarioMs = currentTimeMillis())
        _form.value = atual
        val erros = InspecaoValidacao.validar(atual)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(FormTipo.INSPECAO_CAMPO, erros)
            return
        }
        if (_modoTreinamento.value) {
            _mensagem.value = "Treinamento validado com sucesso (não salvo no histórico)."
            _form.value = TreinamentoDados.formularioExemplo()
            return
        }
        scope.launch {
            val result = withContext(Dispatchers.Default) {
                store.salvar(atual, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                // Memória tem a inspeção nesta sessão, mas fechar o browser perde tudo.
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache do navegador. Não feche o app — " +
                        "exporte o PDF agora ou toque em Salvar de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            withContext(Dispatchers.Default) { draftStore.limpar() }
            _idEdicao.value = null
            _form.value = FormInspecao(dataHorarioMs = currentTimeMillis())
            capturarGps()

            val baseMsg = if (result.usouJsonEnxuto) {
                "Inspeção salva (lista + refs das fotos)."
            } else {
                "Inspeção salva no aparelho."
            }
            iniciarUploadAposSalvar(result.inspecao, baseMsg)
            _tab.value = AppTab.HUB
        }
    }

    fun carregarParaEdicao(inspecao: InspecaoCompleta) {
        if (inspecao.formTipo == FormTipo.ANALISE_VISUAL_NR && !FormTipo.ANALISE_VISUAL_NR_ATIVA) {
            _mensagem.value = "Analise visual (IA) esta pausada por enquanto."
            _tab.value = AppTab.HUB
            return
        }
        _modoTreinamento.value = false
        _formTipoAtivo.value = inspecao.formTipo
        _erros.value = emptyList()
        _idEdicao.value = inspecao.id
        when (inspecao.formTipo) {
            FormTipo.INSPECAO_CAMPO -> {
                _form.value = inspecao.form
            }
            FormTipo.CHECKLIST_DIARIO_HTMS,
            FormTipo.CHECKLIST_DIARIO_AXIA -> {
                _checklistDiarioForm.value = inspecao.checklistDiario
                    ?: FormChecklistDiario.novo(ChecklistDiarioMarca.fromFormTipo(inspecao.formTipo))
            }
            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> {
                _relatorioForm.value = inspecao.relatorioFoto
                    ?: FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.CHECKLIST_ALOJAMENTO -> {
                _checklistForm.value = inspecao.checklistAlojamento
                    ?: FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.CHECKLIST_VETORES -> {
                _checklistForm.value = inspecao.checklistAlojamento
                    ?: ChecklistVetoresCatalog.novo()
            }
            FormTipo.RELATORIO_ALOJAMENTO -> {
                _relatorioForm.value = inspecao.relatorioFoto
                    ?: FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
                _checklistForm.value = inspecao.checklistAlojamento
                    ?: FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.COMUNICACAO_OCORRENCIAS -> {
                _ocorrenciasForm.value = inspecao.comunicacaoOcorrencias
                    ?: FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis())
            }
            FormTipo.REM_SEGURANCA_OBRAS -> {
                _remForm.value = FormRemSeguranca(ano = yearOf(currentTimeMillis()))
            }
            FormTipo.RELATORIO_SEGURANCA -> {
                val y = yearOf(currentTimeMillis())
                val m = monthOf(currentTimeMillis())
                _relSegForm.value = br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca(ano = y, mes = m)
            }
            FormTipo.ACOMPANHAMENTO_AMBIENTAL -> {
                _acompAmbForm.value = FormAcompanhamentoAmbiental(ano = yearOf(currentTimeMillis()))
            }
            FormTipo.EVIDENCIA_TREINAMENTO -> Unit
            FormTipo.ANALISE_VISUAL_NR -> {
                _analiseVisualNrForm.value = inspecao.analiseVisualNr
                    ?: br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr(
                        dataHorarioMs = currentTimeMillis()
                    )
            }
        }
        _tab.value = AppTab.FORM
        _mensagem.value = "Editando ${inspecao.formTipo.rotuloCurto} #${inspecao.id}"
        registrarAberturaFormulario(inspecao.formTipo, editando = true, localId = inspecao.id)
    }

    /**
     * Aplica e persiste a configuração (espera gravação durável).
     * @return null se ok; mensagem de erro se falhar.
     */
    suspend fun aplicarConfiguracao(config: AppConfig): String? {
        // Com login remoto: só o Master altera config do app. Sem sessão (modo local/senha): livre.
        val user = _authUser.value
        if (user != null && !user.podeEditarCamposMaster) {
            return "Sem permissão para alterar a configuração. Somente o admin master altera esses campos."
        }
        if (config.camposAtivos().isEmpty()) {
            return "Mantenha ao menos um campo de verificação ativo na Inspeção de Campo."
        }
        if (config.camposAlojamentoChecklistAtivos().isEmpty() &&
            config.camposAlojamentoFotoAtivos().isEmpty()
        ) {
            return "Mantenha ao menos um item ativo no Relatório Alojamento."
        }
        if (config.camposOcorrencias.none { it.ativo }) {
            return "Mantenha ao menos um bloco ativo em Comunicação Prévia de ocorrências."
        }
        val aplicado = config.comFormAcessosCompletos()
        return try {
            val salvo = withContext(Dispatchers.Default) { configStore.salvar(aplicado) }
            var syncWarning: String? = null
            // Portal multi-usuário: sincroniza no D1 (sem path de banner local).
            if (AuthApi.isLoginRequired() && _authUser.value != null) {
                val remoteJson = FormJson.configToJson(salvo.semBannerLocal())
                AuthApi.pushAppConfigJson(remoteJson).onFailure { err ->
                    syncWarning = err.message?.takeIf { it.isNotBlank() }
                        ?: "Falha ao sincronizar no servidor"
                }
            }
            _appConfig.value = salvo
            InspecaoCatalog.recarregar(salvo)
            _form.value = remanejarItens(_form.value)
            _relatorioForm.value = remanejarItensRelatorio(_relatorioForm.value)
            _checklistForm.value = remanejarItensChecklist(_checklistForm.value)
            _erros.value = emptyList()
            if (syncWarning != null) {
                val msg =
                    "Salvo neste aparelho, mas não sincronizou no servidor ($syncWarning). " +
                        "Tente Salvar / Aplicar de novo."
                _mensagem.value = msg
                return msg
            }
            _mensagem.value = "Configuração salva e aplicada."
            null
        } catch (t: Throwable) {
            val msg = t.message?.takeIf { it.isNotBlank() }
                ?: "Não foi possível salvar a configuração."
            _mensagem.value = msg
            msg
        }
    }

    fun definirBannerDaGaleria() {
        launchFoto {
            val picked = PlatformServices.pickImage()
            if (picked == null) {
                _mensagem.value = if (PlatformServices.consumeLastPhotoPickCancelled()) {
                    "Seleção de banner cancelada."
                } else {
                    "Não foi possível processar a imagem do banner."
                }
                return@launchFoto
            }
            val bytes = PlatformServices.loadImageBytes(picked.path)
            if (bytes == null) {
                _mensagem.value = "Não foi possível ler a imagem."
                return@launchFoto
            }
            val path = PlatformServices.saveBannerImage(bytes)
            if (path == null) {
                _mensagem.value = "Falha ao salvar banner."
                return@launchFoto
            }
            val atual = withContext(Dispatchers.Default) {
                configStore.salvar(_appConfig.value.copy(bannerPath = path))
            }
            _appConfig.value = atual
            _mensagem.value = "Banner atualizado."
        }
    }

    fun restaurarBannerPadrao() {
        scope.launch {
            val atual = withContext(Dispatchers.Default) {
                configStore.salvar(_appConfig.value.copy(bannerPath = null))
            }
            _appConfig.value = atual
            _mensagem.value = "Banner padrão restaurado."
        }
    }

    fun exportarConfig() {
        scope.launch {
            val path = withContext(Dispatchers.Default) { configStore.exportarJsonPath() }
            PlatformFiles.shareFile(path, "application/json", "Compartilhar configuração")
        }
    }

    fun importarConfigTexto(json: String) {
        scope.launch {
            runCatching {
                val cfg = withContext(Dispatchers.Default) { configStore.importarJson(json) }
                _appConfig.value = cfg
                _form.value = remanejarItens(_form.value)
                _relatorioForm.value = remanejarItensRelatorio(_relatorioForm.value)
                _checklistForm.value = remanejarItensChecklist(_checklistForm.value)
                _mensagem.value = "Configuração importada."
            }.onFailure {
                _mensagem.value = "Falha ao importar: ${it.message}"
            }
        }
    }

    fun exportarPdf(inspecao: InspecaoCompleta) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoId = inspecao.id, mensagem = "Gerando PDF...")
            runCatching {
                // Main: na Web, IDB/canvas do loadImageBytes/toJpegBytes precisam do event loop da UI.
                val path = SharedExporter.exportarPdf(inspecao)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, inspecao.rotuloTipo, inspecao.obraResumo()) {
                    PlatformFiles.shareFile(path, "application/pdf", "Compartilhar PDF")
                }
                _historico.value = HistoricoUiState(mensagem = "PDF gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro PDF: ${it.message}")
            }
        }
    }

    fun exportarExcel(inspecao: InspecaoCompleta) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoId = inspecao.id, mensagem = "Gerando Excel...")
            runCatching {
                val path = SharedExporter.exportarExcel(inspecao)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, inspecao.rotuloTipo, inspecao.obraResumo()) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Compartilhar Excel"
                    )
                }
                _historico.value = HistoricoUiState(mensagem = "Excel gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro Excel: ${it.message}")
            }
        }
    }

    fun exportarMes(ano: Int, mes: Int) {
        scope.launch {
            _historico.value = HistoricoUiState(exportandoLote = true, mensagem = "Gerando ZIP do mês...")
            runCatching {
                val lista = _inspecoes.value.filter {
                    yearOf(it.criadoEm) == ano && monthOf(it.criadoEm) == mes
                }
                if (lista.isEmpty()) error("Nenhuma inspeção neste mês.")
                val path = withContext(Dispatchers.Default) {
                    SharedExporter.exportarMesZip(lista, ano, mes)
                }
                PlatformFiles.shareFile(path, "application/zip", "Compartilhar mês")
                _historico.value = HistoricoUiState(mensagem = "ZIP do mês gerado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro ZIP: ${it.message}")
            }
        }
    }

    /**
     * Excel gerencial completo: Resumo / Respostas / Ações / Dashboard (tabelas).
     * Busca no servidor os dados do consolidado (inclui inspeções arquivadas >60 dias).
     */
    fun exportarConsolidado(
        remotas: List<br.com.htms.inspeccaocampo.auth.RemoteInspection>,
        locais: List<br.com.htms.inspeccaocampo.data.InspecaoCompleta>,
        deLabel: String,
        ateLabel: String,
        tiposPermitidos: Set<br.com.htms.inspeccaocampo.data.FormTipo>? = null,
        fromMs: Long? = null,
        toMs: Long? = null,
        filtroRemota: ((br.com.htms.inspeccaocampo.auth.RemoteInspection) -> Boolean)? = null
    ) {
        scope.launch {
            _historico.value = HistoricoUiState(
                exportandoConsolidado = true,
                mensagem = "Preparando Excel consolidado..."
            )
            runCatching {
                val user = _authUser.value
                if (user?.isAdmin != true) {
                    error("Apenas administradores podem baixar o Excel consolidado.")
                }
                val tiposOk = tiposPermitidos?.ifEmpty { null }
                    ?: user.allowedFormTipos(_appConfig.value).toSet()
                _historico.value = HistoricoUiState(
                    exportandoConsolidado = true,
                    mensagem = "Buscando dados no servidor (inclui arquivo após 60 dias)..."
                )
                val remotasServidor = AuthApi.listInspectionsForConsolidado(fromMs, toMs)
                    .getOrElse { remotas }
                val remotasAcl = remotasServidor.filter {
                    (filtroRemota == null || filtroRemota(it)) &&
                        FormTipo.fromId(it.formType) in tiposOk &&
                        user.canExportForm(FormTipo.fromId(it.formType), _appConfig.value)
                }
                val locaisAcl = locais.filter {
                    it.formTipo in tiposOk && user.canExportForm(it.formTipo, _appConfig.value)
                }
                if (remotasAcl.isEmpty() && locaisAcl.isEmpty()) {
                    error("Nenhuma inspeção no período filtrado para os tipos selecionados.")
                }
                val items = mutableListOf<br.com.htms.inspeccaocampo.export.ConsolidadoInspecao>()
                var semJson = 0
                var falhas = 0
                val remotasComJson = remotasAcl.filter { it.hasJson }
                semJson = remotasAcl.size - remotasComJson.size
                val remoteById = remotasComJson.associateBy { it.id }
                val ids = remotasComJson.map { it.id }
                // Lotes de 60 com até 3 requisições em paralelo (antes: 1 GET por inspeção).
                val chunks = ids.chunked(60)
                val payloads = mutableListOf<br.com.htms.inspeccaocampo.auth.ConsolidadoPayloadRow>()
                coroutineScope {
                    for ((waveIdx, wave) in chunks.chunked(3).withIndex()) {
                        val done = waveIdx * 3 * 60
                        _historico.value = HistoricoUiState(
                            exportandoConsolidado = true,
                            mensagem = "Baixando dados ${minOf(done + 1, ids.size)}/${ids.size} (lote)..."
                        )
                        val pages = wave.map { chunk ->
                            async {
                                chunk to AuthApi.fetchConsolidadoPayloads(chunk)
                            }
                        }.awaitAll()
                        for ((_, page) in pages) {
                            page.onSuccess { payloads += it }
                        }
                    }
                }
                val gotIds = payloads.map { it.id }.toHashSet()
                val missing = remotasComJson.filter { it.id !in gotIds }
                if (missing.isNotEmpty()) {
                    _historico.value = HistoricoUiState(
                        exportandoConsolidado = true,
                        mensagem = "Completando ${missing.size} pendente(s)..."
                    )
                    coroutineScope {
                        for (lote in missing.chunked(8)) {
                            val extras = lote.map { remote ->
                                async {
                                    runCatching {
                                        val bytes = AuthApi.downloadInspectionBytes(remote.id, "json")
                                            .getOrThrow()
                                        br.com.htms.inspeccaocampo.auth.ConsolidadoPayloadRow(
                                            id = remote.id,
                                            username = remote.username.orEmpty(),
                                            json = bytes.decodeToString()
                                        )
                                    }.onFailure { falhas++ }.getOrNull()
                                }
                            }.awaitAll()
                            payloads += extras.filterNotNull()
                        }
                    }
                }
                for (row in payloads) {
                    runCatching {
                        val insp = br.com.htms.inspeccaocampo.data.FormJson.inspecaoFromJson(row.json)
                        if (!user.canExportForm(insp.formTipo, _appConfig.value)) return@runCatching
                        val remote = remoteById[row.id]
                        items += br.com.htms.inspeccaocampo.export.ConsolidadoInspecao(
                            username = row.username.ifBlank {
                                remote?.username.orEmpty().ifBlank { user.username }
                            },
                            remoteId = row.id,
                            inspecao = insp
                        )
                    }.onFailure {
                        falhas++
                    }
                }
                val userName = user.username
                locaisAcl.forEach { insp ->
                    items += br.com.htms.inspeccaocampo.export.ConsolidadoInspecao(
                        username = userName,
                        remoteId = null,
                        inspecao = insp
                    )
                }
                if (items.isEmpty()) {
                    error(
                        when {
                            semJson > 0 && falhas == 0 ->
                                "Nenhuma inspeção com JSON completo no período ($semJson sem dados detalhados)."
                            falhas > 0 ->
                                "Não foi possível baixar os dados detalhados ($falhas falha(s))."
                            else -> "Nenhuma inspeção com dados para consolidar."
                        }
                    )
                }
                _historico.value = HistoricoUiState(
                    exportandoConsolidado = true,
                    mensagem = "Gerando Excel (${items.size} inspeções)..."
                )
                val path = withContext(Dispatchers.Default) {
                    SharedExporter.exportarConsolidado(items, deLabel, ateLabel)
                }
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, "Excel consolidado") {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Excel consolidado"
                    )
                }
                val aviso = buildString {
                    if (semJson > 0) append(" $semJson sem JSON.")
                    if (falhas > 0) append(" $falhas falha(s) no download.")
                }
                _historico.value = HistoricoUiState(
                    mensagem = "Excel completo gerado (${items.size} inspeções).$aviso"
                )
            }.onFailure {
                _historico.value = HistoricoUiState(
                    mensagem = "Erro Excel consolidado: ${it.message}"
                )
            }
        }
    }

    fun openNrVigente() {
        PlatformServices.openUrl(
            "https://www.gov.br/trabalho-e-emprego/pt-br/acesso-a-informacao/participacao-social/conselhos-e-orgaos-colegiados/comissao-tripartite-partitaria-permanente/normas-regulamentadora/normas-regulamentadoras-vigentes"
        )
    }

    fun tentarAbrirConfig(senha: String): Boolean {
        if (!AdminSenha.validar(senha)) return false
        _tab.value = AppTab.CONFIG
        return true
    }

    /** Admin master abre Config sem PIN local (já autenticado no login). */
    fun abrirConfigComoAdmin(): Boolean {
        if (!isMaster) return false
        _tab.value = AppTab.CONFIG
        return true
    }

    private fun remanejarItens(form: FormInspecao): FormInspecao {
        val atuais = InspecaoCatalog.itensPadrao()
        val porTitulo = form.itens.associateBy { it.titulo }
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id] ?: porTitulo[novo.titulo]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa
            )
        }
        return form.copy(itens = itens)
    }

    private fun remanejarItensRelatorio(form: FormRelatorioFoto): FormRelatorioFoto {
        val atuais = RelatorioFotoCatalog.itensPadrao()
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa,
                valorExtra = antigo.valorExtra
            )
        }
        return form.copy(itens = itens)
    }

    private fun remanejarItensChecklist(form: FormChecklistAlojamento): FormChecklistAlojamento {
        val atuais = ChecklistAlojamentoCatalog.itensPadrao()
        val porId = form.itens.associateBy { it.id }
        val itens = atuais.map { novo ->
            val antigo = porId[novo.id]
            if (antigo == null) novo
            else novo.copy(
                resposta = antigo.resposta,
                fotos = antigo.fotos,
                justificativa = antigo.justificativa,
                valorExtra = antigo.valorExtra
            )
        }
        return form.copy(itens = itens)
    }

    fun baixarRemoto(remoteId: String, kind: String, fileName: String) {
        if (_historico.value.gerandoAnexosRemoteId != null || _envioProgresso.value.ativo) {
            _historico.value = HistoricoUiState(
                mensagem = "Aguarde a geração/envio terminar antes de baixar."
            )
            return
        }
        scope.launch {
            _historico.value = HistoricoUiState(
                exportandoRemoteId = remoteId,
                baixandoRemotoKind = kind,
                mensagem = "Baixando ${kind.uppercase()}..."
            )
            runCatching {
                val bytes = AuthApi.downloadInspectionBytes(remoteId, kind).getOrThrow()
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), fileName)
                PlatformFiles.writeBytes(path, bytes)
                val mime = when (kind) {
                    "pdf" -> "application/pdf"
                    "excel" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    else -> "application/json"
                }
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.semBackup { PlatformFiles.shareFile(path, mime, "Baixar ${kind.uppercase()}") }
                _historico.value = HistoricoUiState(mensagem = "${kind.uppercase()} baixado.")
            }.onFailure {
                _historico.value = HistoricoUiState(mensagem = "Erro ao baixar: ${it.message}")
            }
        }
    }

    /**
     * Admin: gera PDF/Excel a partir do JSON no servidor e reenvia (corrige envio incompleto
     * ou PDF sem assinaturas). Usa o mesmo gerador do app (Canvas/Web ou Android).
     */
    fun forcarGerarAnexosRemoto(remoteId: String) {
        if (_historico.value.gerandoAnexosRemoteId != null ||
            _historico.value.exportandoRemoteId != null ||
            _envioProgresso.value.ativo
        ) {
            return
        }
        scope.launch {
            _historico.value = HistoricoUiState(
                gerandoAnexosRemoteId = remoteId,
                mensagem = "Gerando PDF/Excel a partir dos dados do servidor..."
            )
            _envioProgresso.value = EnvioProgresso(
                ativo = true,
                percent = 5,
                etapa = "Baixando dados do servidor..."
            )
            yield()
            delay(32)
            runCatching {
                if (AuthApi.currentSession() == null) error("Faça login como admin.")
                if (!PlatformServices.isNetworkAvailable()) error("Sem conexão.")
                val remota = _remoteInspections.value.firstOrNull { it.id == remoteId }
                    ?: error("Inspeção não está na lista. Atualize o histórico.")
                val jsonBytes = AuthApi.downloadInspectionBytes(remoteId, "json").getOrThrow()
                val jsonText = jsonBytes.decodeToString()
                var insp = FormJson.inspecaoFromJson(jsonText)
                val lid = remota.localId?.takeIf { it > 0 }
                    ?: insp.id.takeIf { it > 0 }
                    ?: error("Inspeção sem localId — não é possível anexar PDF/Excel.")
                insp = insp.copy(id = lid, enviadoRemoto = true)
                when (insp.formTipo) {
                    FormTipo.REM_SEGURANCA_OBRAS,
                    FormTipo.RELATORIO_SEGURANCA,
                    FormTipo.ACOMPANHAMENTO_AMBIENTAL ->
                        error("Este tipo usa Excel/PPTX no módulo próprio, não PDF de inspeção.")
                    else -> Unit
                }
                if (insp.formTipo == FormTipo.INSPECAO_CAMPO) {
                    val temAssinatura =
                        insp.form.assinaturaSupervisor.isNotBlank() ||
                            insp.form.assinaturaSesmt.isNotBlank()
                    if (!temAssinatura) {
                        error(
                            "JSON no servidor sem assinaturas — não dá para recolocá-las no PDF. " +
                                "A inspeção precisa ser reenviada com as assinaturas."
                        )
                    }
                }
                progressoEnvio(25, "Gerando PDF (layout padrão + assinaturas)...")
                yield()
                delay(50)
                val pdfBytes = withTimeout(180_000) {
                    withContext(Dispatchers.Default) {
                        when (insp.formTipo) {
                            FormTipo.INSPECAO_CAMPO -> JpegPdfBuilder.build(insp)
                            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> JpegPdfBuilder.buildRelatorio(insp)
                            FormTipo.CHECKLIST_ALOJAMENTO,
                            FormTipo.CHECKLIST_VETORES -> JpegPdfBuilder.buildChecklist(insp)
                            FormTipo.RELATORIO_ALOJAMENTO -> JpegPdfBuilder.buildRelatorioAlojamento(insp)
                            FormTipo.COMUNICACAO_OCORRENCIAS -> JpegPdfBuilder.buildComunicacao(insp)
                            FormTipo.ANALISE_VISUAL_NR -> JpegPdfBuilder.buildAnaliseVisualNr(insp)
                            FormTipo.CHECKLIST_DIARIO_HTMS,
                            FormTipo.CHECKLIST_DIARIO_AXIA -> JpegPdfBuilder.buildChecklistDiario(insp)
                            else -> error("Tipo sem gerador de PDF.")
                        }
                    }
                }
                if (pdfBytes.isEmpty()) error("PDF gerado vazio.")
                progressoEnvio(55, "Gerando Excel...")
                yield()
                delay(50)
                val excelBytes = withTimeout(120_000) {
                    withContext(Dispatchers.Default) {
                        SharedExcelBuilder.build(insp)
                    }
                }
                progressoEnvio(80, "Enviando PDF e Excel...")
                val slimJson = FormJson.inspecaoToJson(
                    when (insp.formTipo) {
                        FormTipo.INSPECAO_CAMPO -> insp.copy(form = insp.form.semConteudoBase64())
                        FormTipo.RELATORIO_FOTO_ALOJAMENTO,
                        FormTipo.RELATORIO_ALOJAMENTO ->
                            insp.copy(relatorioFoto = insp.relatorioFoto?.semConteudoBase64())
                        FormTipo.COMUNICACAO_OCORRENCIAS ->
                            insp.copy(
                                comunicacaoOcorrencias =
                                    insp.comunicacaoOcorrencias?.semConteudoBase64()
                            )
                        FormTipo.CHECKLIST_DIARIO_HTMS,
                        FormTipo.CHECKLIST_DIARIO_AXIA ->
                            insp.copy(
                                checklistDiario = insp.checklistDiario?.checklistDiarioSemBase64()
                            )
                        FormTipo.ANALISE_VISUAL_NR ->
                            insp.copy(analiseVisualNr = insp.analiseVisualNr?.semConteudoBase64())
                        else -> insp
                    }
                )
                // Anexa na mesma inspeção remota (preserva usuário dono; remove clone admin).
                AuthApi.attachInspectionAttachments(
                    remoteId = remoteId,
                    pdfBytes = pdfBytes,
                    excelBytes = excelBytes,
                    pdfFileName = ExportNames.pdf(insp),
                    excelFileName = ExportNames.excel(insp),
                    jsonText = slimJson
                ).getOrThrow()
                recarregarHistoricoRemoto()
                finalizarEnvioProgresso(
                    ok = true,
                    etapa = "PDF/Excel gerados e enviados",
                    detalhe = "Pode baixar os anexos atualizados no Histórico."
                )
                _historico.value = HistoricoUiState(
                    mensagem = "PDF/Excel gerados na inspeção original (usuário preservado)."
                )
            }.onFailure {
                val detalhe = when (it) {
                    is TimeoutCancellationException ->
                        "Tempo esgotado ao gerar. Atualize a página (Ctrl+F5) e tente de novo."
                    else -> it.message
                }
                finalizarEnvioProgresso(
                    ok = false,
                    etapa = "Falha ao gerar anexos",
                    detalhe = detalhe
                )
                _historico.value = HistoricoUiState(
                    mensagem = "Falha ao gerar anexos: $detalhe"
                )
            }
        }
    }

    /** Admin: exclui vistoria remota e atualiza a lista. */
    fun excluirRemoto(remoteId: String) {
        scope.launch {
            _historico.value = _historico.value.copy(
                exportandoRemoteId = remoteId,
                mensagem = "Excluindo inspeção..."
            )
            AuthApi.deleteInspection(remoteId)
                .onSuccess {
                    _remoteInspections.value =
                        _remoteInspections.value.filterNot { it.id == remoteId }
                    _historico.value = HistoricoUiState(mensagem = "Inspeção movida para a lixeira (7 dias).")
                    recarregarHistoricoRemoto()
                }
                .onFailure {
                    _historico.value = HistoricoUiState(
                        mensagem = "Erro ao excluir: ${it.message}"
                    )
                }
        }
    }

    private fun recarregarHistorico() {
        val lista = store.listar()
        _inspecoes.value = lista
        _pendentesCount.value = lista.count { !it.enviadoRemoto }
        if (AuthApi.currentSession() != null) {
            scope.launch {
                coroutineScope {
                    launch { recarregarHistoricoRemoto() }
                    launch { recarregarRemDossiers() }
                    launch { recarregarRelSegDossiers() }
                    launch { recarregarAcompAmbDossiers() }
                }
            }
        }
    }

    private suspend fun recarregarHistoricoRemoto() {
        AuthApi.listInspections()
            .onSuccess { _remoteInspections.value = it }
            .onFailure {
                // Mantém local; avisa só se admin/histórico remoto esperado
                if (_remoteInspections.value.isEmpty()) {
                    _historico.value = _historico.value.copy(
                        mensagem = "Histórico remoto indisponível: ${it.message}"
                    )
                }
            }
    }

    /** O servidor recusa (403) listas de formulários sem acesso; nem pede. */
    private fun temAcessoForm(tipo: FormTipo): Boolean =
        _authUser.value?.canAccessForm(tipo, _appConfig.value) == true

    private suspend fun recarregarRemDossiers() {
        if (!temAcessoForm(FormTipo.REM_SEGURANCA_OBRAS)) {
            _remDossiers.value = emptyList()
            return
        }
        AuthApi.listRemDossiers(all = false)
            .onSuccess { _remDossiers.value = it }
            .onFailure {
                // REM é complementar; não bloqueia o histórico de inspeções
            }
    }

    private fun remMesJaSalvo(abr: RemAbrangencia, mes: Int, cache: List<RemMonthRow>): Boolean =
        cache.any { it.abrangencia == abr && it.mes == mes }

    private fun remReadOnlyFor(abr: RemAbrangencia, mes: Int, cache: List<RemMonthRow>): Boolean =
        !isAdmin && remMesJaSalvo(abr, mes, cache)

    private fun remFormWithReadOnly(cur: FormRemSeguranca): FormRemSeguranca =
        cur.copy(readOnly = remReadOnlyFor(cur.abrangencia, cur.mes, cur.monthsCache))

    private fun relSegPayloadEffectivelyEmpty(p: br.com.htms.inspeccaocampo.data.RelSegPayload): Boolean {
        val dg = p.dadosGerais
        val sms = p.gestaoSms
        val empresaVazia = dg.empresa.isBlank() || dg.empresa.equals("Htms Energia", ignoreCase = true)
        if (!empresaVazia || dg.cnpj.isNotBlank() || dg.grauRisco.isNotBlank() ||
            dg.obra.isNotBlank() || dg.contrato.isNotBlank() || dg.vigencia.isNotBlank() ||
            dg.cliente.isNotBlank() || dg.efetivoHtms.isNotBlank() || dg.efetivoTerceiro.isNotBlank()
        ) return false
        if (sms.desviosGerais != null || sms.apr.isNotBlank() || sms.pt.isNotBlank() ||
            sms.dds.isNotBlank() || sms.treinamentos.isNotBlank() || sms.checklist.isNotBlank() ||
            sms.acidentesFatais != null || sms.acidentes != null || sms.lesoes != null ||
            sms.quaseAcidentes != null
        ) return false
        if (p.dds.any { it.temaData.isNotBlank() || it.fotoRef.isNotBlank() }) return false
        if (p.treinamentos.any {
                it.treinamento.isNotBlank() || it.nomes.isNotBlank() || it.data.isNotBlank() ||
                    it.numPessoas.isNotBlank() || it.descricao.isNotBlank() ||
                    it.fotos.any { f -> f.isNotBlank() }
            }
        ) return false
        return true
    }

    private fun relSegNeverSaved(d: br.com.htms.inspeccaocampo.data.RelSegDossier): Boolean {
        val created = d.createdAt ?: 0L
        val updated = d.updatedAt ?: 0L
        if (updated > created + 5000L) return false
        return relSegPayloadEffectivelyEmpty(d.payload)
    }

    private fun relSegReadOnlyFrom(d: br.com.htms.inspeccaocampo.data.RelSegDossier): Boolean =
        !isAdmin && !relSegNeverSaved(d)

    fun atualizarHistoricoRemoto() {
        scope.launch {
            recarregarHistoricoRemoto()
            recarregarRemDossiers()
            recarregarRelSegDossiers()
            recarregarAcompAmbDossiers()
            sincronizarPendentesInterno()
        }
    }

    /** Reenvia inspeções locais ainda não confirmadas no servidor (ação manual do usuário/admin). */
    fun sincronizarPendentes() {
        scope.launch { sincronizarPendentesInterno(forcadoPeloUsuario = true) }
    }

    private fun persistirRascunhoDebounced() {
        if (_modoTreinamento.value) return
        persistirRascunhoImediato()
        val form = _form.value
        val id = _idEdicao.value
        scope.launch(Dispatchers.Default) {
            if (form.temConteudoRascunho()) draftStore.salvar(form, id)
            else draftStore.limpar()
        }
    }

    private fun persistirRascunhoImediato() {
        if (_modoTreinamento.value) return
        val form = _form.value
        val id = _idEdicao.value
        if (form.temConteudoRascunho()) {
            runCatching { draftStore.salvarInspecaoImediato(form, id) }
        }
    }

    private fun persistirRascunhoChecklistDiario() {
        persistirRascunhoChecklistDiarioImediato()
        val form = _checklistDiarioForm.value
        val id = _idEdicao.value
        scope.launch(Dispatchers.Default) {
            val temConteudo = form.tipoId.isNotBlank() ||
                form.preenchidoPor.isNotBlank() ||
                form.obra.isNotBlank() ||
                form.itens.any { it.resposta != null || it.fotos.isNotEmpty() || it.justificativa.isNotBlank() }
            if (temConteudo) draftStore.salvarChecklistDiario(form, id)
            else draftStore.limparChecklistDiario()
        }
    }

    private fun persistirRascunhoChecklistDiarioImediato() {
        val form = _checklistDiarioForm.value
        val id = _idEdicao.value
        val temConteudo = form.tipoId.isNotBlank() ||
            form.preenchidoPor.isNotBlank() ||
            form.obra.isNotBlank() ||
            form.itens.any { it.resposta != null || it.fotos.isNotEmpty() || it.justificativa.isNotBlank() }
        if (temConteudo) {
            runCatching { draftStore.salvarChecklistDiarioImediato(form, id) }
        }
    }

    fun salvarAssinaturaChecklist(campo: String, dados: String) {
        val f = _checklistForm.value
        _checklistForm.value = when (campo) {
            "inspecionadoPor" -> f.copy(
                inspecionadoPor = f.inspecionadoPor.copy(assinatura = dados)
            )
            "acompanhadoPor" -> f.copy(
                acompanhadoPor = f.acompanhadoPor.copy(assinatura = dados)
            )
            "engenheiroResidente" -> f.copy(
                engenheiroResidente = f.engenheiroResidente.copy(assinatura = dados)
            )
            else -> f
        }
        _assinaturaEditando.value = null
    }

    fun atualizarRelatorio(block: (FormRelatorioFoto) -> FormRelatorioFoto) {
        _relatorioForm.value = block(_relatorioForm.value)
        if (_formTipoAtivo.value == FormTipo.RELATORIO_ALOJAMENTO) {
            syncCamposCompartilhadosAlojamento()
        }
    }

    fun atualizarItemRelatorio(itemId: String, block: (ItemConformidade) -> ItemConformidade) {
        _relatorioForm.value = _relatorioForm.value.copy(
            itens = _relatorioForm.value.itens.map { if (it.id == itemId) block(it) else it }
        )
    }

    fun definirRespostaRelatorio(itemId: String, resposta: RespostaConformidade) {
        atualizarItemRelatorio(itemId) { it.copy(resposta = resposta) }
    }

    fun capturarGpsRelatorio() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _relatorioForm.value = _relatorioForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                if (_formTipoAtivo.value == FormTipo.RELATORIO_ALOJAMENTO) {
                    syncCamposCompartilhadosAlojamento()
                }
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    fun capturarGpsRelatorioAlojamento() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _relatorioForm.value = _relatorioForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                syncCamposCompartilhadosAlojamento()
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    /** Espelha obra/endereço/GPS da Parte 1 (fotográfico) na Parte 2 (checklist). */
    fun syncCamposCompartilhadosAlojamento() {
        val r = _relatorioForm.value
        _checklistForm.value = _checklistForm.value.copy(
            endereco = r.endereco.ifBlank { _checklistForm.value.endereco },
            obra = r.obra.ifBlank { _checklistForm.value.obra },
            latitude = r.latitude ?: _checklistForm.value.latitude,
            longitude = r.longitude ?: _checklistForm.value.longitude,
            localTexto = r.localTexto.ifBlank { _checklistForm.value.localTexto }
        )
    }

    fun atualizarRelatorioCombinado(block: (FormRelatorioFoto) -> FormRelatorioFoto) {
        _relatorioForm.value = block(_relatorioForm.value)
        syncCamposCompartilhadosAlojamento()
    }

    fun capturarGpsChecklist() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _checklistForm.value = _checklistForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoRelatorio(itemId: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val item = _relatorioForm.value.itens.find { it.id == itemId }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _authUser.value?.displayName.orEmpty()
                            .ifBlank { _relatorioForm.value.responsavelAlojamento },
                        pergunta = item?.tituloNumerado ?: itemId,
                        resposta = item?.resposta?.rotuloSimNao ?: "Sim",
                        responsavelFrente = _relatorioForm.value.responsavelAlojamento,
                        localTexto = _relatorioForm.value.endereco.ifBlank {
                            _relatorioForm.value.localTexto
                        },
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _relatorioForm.value.latitude,
                        longitude = captured.longitude ?: _relatorioForm.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _relatorioForm.value.latitude,
                    longitude = captured.longitude ?: _relatorioForm.value.longitude,
                    conteudoBase64 = embedded
                )
                atualizarItemRelatorio(itemId) {
                    it.copy(
                        fotos = it.fotos + foto,
                        resposta = it.resposta ?: RespostaConformidade.C
                    )
                }
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoRelatorio(itemId: String, foto: FotoAnexo) {
        atualizarItemRelatorio(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
    }

    fun adicionarFotoObservacoesRelatorio(fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = _authUser.value?.displayName.orEmpty()
                            .ifBlank { _relatorioForm.value.responsavelAlojamento },
                        pergunta = RelatorioFotoCatalog.SECAO_OBSERVACOES,
                        resposta = "OBS",
                        responsavelFrente = _relatorioForm.value.responsavelAlojamento,
                        localTexto = _relatorioForm.value.endereco.ifBlank {
                            _relatorioForm.value.localTexto
                        },
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: _relatorioForm.value.latitude,
                        longitude = captured.longitude ?: _relatorioForm.value.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: _relatorioForm.value.latitude,
                    longitude = captured.longitude ?: _relatorioForm.value.longitude,
                    conteudoBase64 = embedded
                )
                _relatorioForm.value = _relatorioForm.value.copy(
                    observacoesFotos = _relatorioForm.value.observacoesFotos + foto
                )
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoObservacoesRelatorio(foto: FotoAnexo) {
        _relatorioForm.value = _relatorioForm.value.copy(
            observacoesFotos = _relatorioForm.value.observacoesFotos.filter { it.id != foto.id }
        )
    }

    fun validarESalvarRelatorio() {
        val atual = _relatorioForm.value.copy(dataHorarioMs = currentTimeMillis())
        _relatorioForm.value = atual
        val erros = AlojamentoValidacao.validarRelatorio(atual)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(FormTipo.RELATORIO_FOTO_ALOJAMENTO, erros)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.RELATORIO_FOTO_ALOJAMENTO,
                form = FormInspecao(
                    tstResponsavel = atual.responsavelAlojamento,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.endereco.ifBlank { atual.localTexto },
                    obra = atual.obra
                ),
                relatorioFoto = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            if (_idEdicao.value == null) runCatching { draftStore.limparAlojamento() }
            _idEdicao.value = null
            _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            iniciarUploadAposSalvar(result.inspecao, "Relatório fotográfico salvo.")
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarChecklist(block: (FormChecklistAlojamento) -> FormChecklistAlojamento) {
        _checklistForm.value = block(_checklistForm.value)
    }

    fun atualizarItemChecklist(itemId: String, block: (ItemConformidade) -> ItemConformidade) {
        _checklistForm.value = _checklistForm.value.copy(
            itens = _checklistForm.value.itens.map { if (it.id == itemId) block(it) else it }
        )
    }

    fun definirRespostaChecklist(itemId: String, resposta: RespostaConformidade) {
        atualizarItemChecklist(itemId) { it.copy(resposta = resposta) }
    }

    fun validarESalvarChecklist() {
        val ms = currentTimeMillis()
        val formatado = formatDateBr(ms)
        val partes = formatado.split(' ', limit = 2)
        val atual = _checklistForm.value.copy(
            dataHorarioMs = ms,
            dataInspecao = partes.getOrElse(0) { formatado },
            horaInspecao = partes.getOrElse(1) { "" }
        )
        _checklistForm.value = atual
        val tipoSalvo = if (_formTipoAtivo.value == FormTipo.CHECKLIST_VETORES) {
            FormTipo.CHECKLIST_VETORES
        } else {
            FormTipo.CHECKLIST_ALOJAMENTO
        }
        val erros = if (tipoSalvo == FormTipo.CHECKLIST_VETORES) {
            AlojamentoValidacao.validarVetores(atual)
        } else {
            AlojamentoValidacao.validarChecklist(atual)
        }
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(tipoSalvo, erros)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = tipoSalvo,
                form = FormInspecao(
                    tstResponsavel = atual.inspecionadoPor.nome,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.endereco.ifBlank { atual.localTexto },
                    obra = atual.obra
                ),
                checklistAlojamento = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            if (_idEdicao.value == null) runCatching { draftStore.limparAlojamento() }
            _idEdicao.value = null
            _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            iniciarUploadAposSalvar(result.inspecao, "Checklist de alojamento salvo.")
            _tab.value = AppTab.HUB
        }
    }

    fun validarESalvarRelatorioAlojamento() {
        val ms = currentTimeMillis()
        val formatado = formatDateBr(ms)
        val partes = formatado.split(' ', limit = 2)
        syncCamposCompartilhadosAlojamento()
        val part1 = _relatorioForm.value.copy(dataHorarioMs = ms)
        val part2 = _checklistForm.value.copy(
            dataHorarioMs = ms,
            dataInspecao = partes.getOrElse(0) { formatado },
            horaInspecao = partes.getOrElse(1) { "" },
            endereco = part1.endereco.ifBlank { _checklistForm.value.endereco },
            obra = part1.obra.ifBlank { _checklistForm.value.obra },
            latitude = part1.latitude ?: _checklistForm.value.latitude,
            longitude = part1.longitude ?: _checklistForm.value.longitude,
            localTexto = part1.localTexto.ifBlank { _checklistForm.value.localTexto }
        )
        _relatorioForm.value = part1
        _checklistForm.value = part2
        val erros = AlojamentoValidacao.validarRelatorio(part1) +
            AlojamentoValidacao.validarChecklist(part2)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value =
                "Há ${erros.size} pendência(s) nas Partes 1 e/ou 2. Verifique os campos marcados."
            registrarFalhaValidacao(FormTipo.RELATORIO_ALOJAMENTO, erros)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.RELATORIO_ALOJAMENTO,
                form = FormInspecao(
                    tstResponsavel = part1.responsavelAlojamento
                        .ifBlank { part2.inspecionadoPor.nome },
                    dataHorarioMs = ms,
                    latitude = part1.latitude,
                    longitude = part1.longitude,
                    localTexto = part1.endereco.ifBlank { part1.localTexto },
                    obra = part1.obra
                ),
                relatorioFoto = part1,
                checklistAlojamento = part2
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            if (_idEdicao.value == null) runCatching { draftStore.limparAlojamento() }
            _idEdicao.value = null
            _relatorioForm.value = FormRelatorioFoto(dataHorarioMs = currentTimeMillis())
            _checklistForm.value = FormChecklistAlojamento(dataHorarioMs = currentTimeMillis())
            iniciarUploadAposSalvar(result.inspecao, "Relatório Alojamento salvo.")
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarChecklistDiario(block: (FormChecklistDiario) -> FormChecklistDiario) {
        _checklistDiarioForm.value = block(_checklistDiarioForm.value)
        persistirRascunhoChecklistDiario()
    }

    fun selecionarTipoChecklistDiario(tipo: ChecklistTipo) {
        _checklistDiarioForm.value = _checklistDiarioForm.value.comTipo(tipo)
        _erros.value = emptyList()
        persistirRascunhoChecklistDiario()
    }

    fun limparTipoChecklistDiario() {
        val atual = _checklistDiarioForm.value
        val marca = atual.marcaEnum()
        _checklistDiarioForm.value = FormChecklistDiario.novo(marca).copy(
            latitude = atual.latitude,
            longitude = atual.longitude,
            localTexto = atual.localTexto,
            fotosPlanoManutencao = atual.fotosPlanoManutencao,
            fotosEvidenciasManutencao = atual.fotosEvidenciasManutencao,
            fotosCrlv = atual.fotosCrlv
        )
        _erros.value = emptyList()
        persistirRascunhoChecklistDiario()
    }

    fun atualizarItemChecklistDiario(itemId: String, block: (ItemConformidade) -> ItemConformidade) {
        _checklistDiarioForm.value = _checklistDiarioForm.value.copy(
            itens = _checklistDiarioForm.value.itens.map { if (it.id == itemId) block(it) else it }
        )
        persistirRascunhoChecklistDiarioImediato()
    }

    fun definirRespostaChecklistDiario(itemId: String, resposta: RespostaConformidade) {
        atualizarItemChecklistDiario(itemId) { it.copy(resposta = resposta) }
    }

    fun capturarGpsChecklistDiario() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _checklistDiarioForm.value = _checklistDiarioForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
                persistirRascunhoChecklistDiario()
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoChecklistDiario(itemId: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val form = _checklistDiarioForm.value
                val item = form.itens.find { it.id == itemId }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = form.preenchidoPor,
                        pergunta = item?.tituloNumerado ?: itemId,
                        resposta = item?.resposta?.codigo ?: "C",
                        responsavelFrente = form.motoristaNome,
                        localTexto = form.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: form.latitude,
                        longitude = captured.longitude ?: form.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: form.latitude,
                    longitude = captured.longitude ?: form.longitude,
                    conteudoBase64 = embedded
                )
                atualizarItemChecklistDiario(itemId) {
                    it.copy(
                        fotos = it.fotos + foto,
                        resposta = it.resposta ?: RespostaConformidade.C
                    )
                }
                persistirRascunhoChecklistDiario()
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun adicionarFotoChecklistItem(itemId: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val form = _checklistForm.value
                val item = form.itens.find { it.id == itemId }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = form.inspecionadoPor.nome,
                        pergunta = item?.tituloNumerado ?: itemId,
                        resposta = item?.resposta?.rotulo ?: "Conforme",
                        responsavelFrente = form.acompanhadoPor.nome,
                        localTexto = form.endereco.ifBlank { form.localTexto },
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: form.latitude,
                        longitude = captured.longitude ?: form.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: form.latitude,
                    longitude = captured.longitude ?: form.longitude,
                    conteudoBase64 = embedded
                )
                atualizarItemChecklist(itemId) { it.copy(fotos = it.fotos + foto) }
                persistirRascunhoAlojamentoImediato()
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoChecklistItem(itemId: String, foto: FotoAnexo) {
        atualizarItemChecklist(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
        persistirRascunhoAlojamentoImediato()
    }

    /**
     * Anexa foto/documento de requisitos Axia (plano, evidências ou CRLV).
     * @param campo `"plano"`, `"evidencias"` ou `"crlv"`
     */
    fun adicionarFotoDocumentoAxia(campo: String, fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val form = _checklistDiarioForm.value
                val rotulo = when (campo) {
                    "plano" -> "Plano de manutenção"
                    "evidencias" -> "Evidências de manutenção"
                    "crlv" -> AxiaRequisitosMev.DOC_CRLV_ROTULO
                    else -> "Documento Axia"
                }
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = form.preenchidoPor,
                        pergunta = rotulo,
                        resposta = "DOC",
                        responsavelFrente = form.motoristaNome,
                        localTexto = form.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: form.latitude,
                        longitude = captured.longitude ?: form.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: form.latitude,
                    longitude = captured.longitude ?: form.longitude,
                    conteudoBase64 = embedded
                )
                _checklistDiarioForm.value = when (campo) {
                    "plano" -> form.copy(fotosPlanoManutencao = form.fotosPlanoManutencao + foto)
                    "evidencias" -> form.copy(
                        fotosEvidenciasManutencao = form.fotosEvidenciasManutencao + foto
                    )
                    "crlv" -> form.copy(fotosCrlv = form.fotosCrlv + foto)
                    else -> form
                }
                persistirRascunhoChecklistDiario()
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoDocumentoAxia(campo: String, foto: FotoAnexo) {
        val form = _checklistDiarioForm.value
        _checklistDiarioForm.value = when (campo) {
            "plano" -> form.copy(
                fotosPlanoManutencao = form.fotosPlanoManutencao.filter { it.id != foto.id }
            )
            "evidencias" -> form.copy(
                fotosEvidenciasManutencao = form.fotosEvidenciasManutencao.filter { it.id != foto.id }
            )
            "crlv" -> form.copy(
                fotosCrlv = form.fotosCrlv.filter { it.id != foto.id }
            )
            else -> form
        }
        persistirRascunhoChecklistDiario()
    }

    fun removerFotoChecklistDiario(itemId: String, foto: FotoAnexo) {
        atualizarItemChecklistDiario(itemId) { item ->
            item.copy(fotos = item.fotos.filter { it.id != foto.id })
        }
        persistirRascunhoChecklistDiario()
    }

    fun salvarAssinaturaChecklistDiario(campo: String, dados: String) {
        _checklistDiarioForm.value = when (campo) {
            "motorista" -> _checklistDiarioForm.value.copy(assinaturaMotorista = dados)
            "encarregado" -> _checklistDiarioForm.value.copy(assinaturaEncarregado = dados)
            "sesmt" -> _checklistDiarioForm.value.copy(assinaturaSesmt = dados)
            else -> _checklistDiarioForm.value
        }
        _assinaturaEditando.value = null
        persistirRascunhoChecklistDiario()
    }

    fun validarESalvarChecklistDiario() {
        val atual = _checklistDiarioForm.value.copy(dataHorarioMs = currentTimeMillis())
        _checklistDiarioForm.value = atual
        val erros = ChecklistDiarioValidacao.validar(atual)
        _erros.value = erros
        val formTipo = atual.marcaEnum().formTipo()
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(formTipo, erros)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = formTipo,
                form = FormInspecao(
                    tstResponsavel = atual.preenchidoPor,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.localTexto,
                    obra = atual.obra,
                    responsavelFrente = atual.motoristaNome
                ),
                checklistDiario = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            withContext(Dispatchers.Default) { draftStore.limparChecklistDiario() }
            _checklistDiarioForm.value = FormChecklistDiario.novo(atual.marcaEnum())
            iniciarUploadAposSalvar(result.inspecao, "${formTipo.rotulo} salvo.")
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarOcorrencias(block: (FormComunicacaoOcorrencias) -> FormComunicacaoOcorrencias) {
        _ocorrenciasForm.value = block(_ocorrenciasForm.value)
    }

    fun capturarGpsOcorrencias() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _ocorrenciasForm.value = _ocorrenciasForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador " +
                        "(ícone do cadeado na barra de endereço) e, no Windows, ative " +
                        "Configurações → Privacidade → Localização."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoOcorrencias(fromGallery: Boolean = false) {
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val atual = _ocorrenciasForm.value
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = atual.quemReportando,
                        pergunta = "Comunicação Prévia de ocorrências",
                        resposta = atual.caracterizacao?.rotulo ?: "Foto",
                        responsavelFrente = atual.responsavelAtividade,
                        localTexto = atual.localExato.ifBlank {
                            atual.localAcidente.ifBlank { atual.localTexto }
                        },
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: atual.latitude,
                        longitude = captured.longitude ?: atual.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val embedded = embedPhotoBase64(stampedBytes)
                val path = PlatformServices.publishPhoto(captured.path)
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: atual.latitude,
                    longitude = captured.longitude ?: atual.longitude,
                    conteudoBase64 = embedded
                )
                _ocorrenciasForm.value = atual.copy(fotos = atual.fotos + foto)
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoOcorrencias(foto: FotoAnexo) {
        _ocorrenciasForm.value = _ocorrenciasForm.value.copy(
            fotos = _ocorrenciasForm.value.fotos.filter { it.id != foto.id }
        )
    }

    fun validarESalvarOcorrencias() {
        val atual = _ocorrenciasForm.value.copy(dataHorarioMs = currentTimeMillis())
        _ocorrenciasForm.value = atual
        val erros = ComunicacaoOcorrenciasValidacao.validar(atual, _appConfig.value)
        _erros.value = erros
        if (erros.isNotEmpty()) {
            _mensagem.value = "Há ${erros.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(FormTipo.COMUNICACAO_OCORRENCIAS, erros)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.COMUNICACAO_OCORRENCIAS,
                form = FormInspecao(
                    tstResponsavel = atual.quemReportando,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.localExato.ifBlank { atual.localTexto },
                    obra = atual.obra,
                    responsavelFrente = atual.responsavelAtividade,
                    descricaoAtividade = atual.descricaoEvento
                ),
                comunicacaoOcorrencias = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _ocorrenciasForm.value = FormComunicacaoOcorrencias(dataHorarioMs = currentTimeMillis())
            iniciarUploadAposSalvar(result.inspecao, "Comunicação Prévia de ocorrências salva.")
            _tab.value = AppTab.HUB
        }
    }

    fun atualizarAnaliseVisualNr(
        block: (br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr) ->
            br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr
    ) {
        _analiseVisualNrForm.value = block(_analiseVisualNrForm.value)
    }

    fun capturarGpsAnaliseVisualNr() {
        scope.launch {
            _capturandoGps.value = true
            val fix = PlatformServices.captureGps()
            if (fix != null) {
                _analiseVisualNrForm.value = _analiseVisualNrForm.value.copy(
                    latitude = fix.latitude,
                    longitude = fix.longitude,
                    localTexto = fix.textoLocal
                )
            } else {
                _mensagem.value =
                    "Não foi possível obter o GPS. Permita a localização no navegador."
            }
            _capturandoGps.value = false
        }
    }

    fun adicionarFotoAnaliseVisualNr(fromGallery: Boolean = false) {
        launchFoto {
            try {
                val atual = _analiseVisualNrForm.value
                if (atual.fotos.size >= 8) {
                    _mensagem.value = "Máximo de 8 fotos por análise."
                    return@launchFoto
                }
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = atual.tstResponsavel,
                        pergunta = "Analise visual NR — ${atual.cenaTipo.rotulo}",
                        resposta = "Cena",
                        responsavelFrente = "",
                        localTexto = atual.localTexto,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude ?: atual.latitude,
                        longitude = captured.longitude ?: atual.longitude,
                        numeroInspecao = _idEdicao.value
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val path = PlatformServices.publishPhoto(captured.path)
                val embedded = PlatformServices.encodeBase64(stampedBytes).takeIf { it.isNotBlank() }
                    ?: PlatformFiles.readBytes(path)?.let { PlatformServices.encodeBase64(it) }
                val foto = FotoAnexo(
                    path = path,
                    capturadoEm = currentTimeMillis(),
                    latitude = captured.latitude ?: atual.latitude,
                    longitude = captured.longitude ?: atual.longitude,
                    conteudoBase64 = embedded
                )
                _analiseVisualNrForm.value = atual.copy(fotos = atual.fotos + foto)
                analisarCenaVisualNr(aoVivo = true)
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun abrirCameraAoVivoNr() {
        if (!LiveNrCamera.isSupported()) {
            _mensagem.value = "Camera ao vivo neste teste so no Android."
            return
        }
        LiveNrCamera.open { jpeg ->
            scope.launch {
                incorporarJpegAoVivo(jpeg)
            }
        }
    }

    private suspend fun incorporarJpegAoVivo(jpeg: ByteArray) {
        if (jpeg.isEmpty()) return
        val atual = _analiseVisualNrForm.value
        if (atual.fotos.size >= 8) {
            _mensagem.value = "Máximo de 8 fotos por análise."
            return
        }
        val path = PlatformFiles.join(PlatformFiles.cacheDir(), "nr-vivo-${currentTimeMillis()}.jpg")
        PlatformFiles.writeBytes(path, jpeg)
        val stampedBytes = aplicarCarimbo(
            path,
            PhotoStampData(
                tstResponsavel = atual.tstResponsavel,
                pergunta = "Analise visual NR ao vivo",
                resposta = "Cena",
                responsavelFrente = "",
                localTexto = atual.localTexto,
                dataHoraMs = currentTimeMillis(),
                latitude = atual.latitude,
                longitude = atual.longitude,
                numeroInspecao = _idEdicao.value
            )
        )
        if (stampedBytes == null || stampedBytes.isEmpty()) {
            _mensagem.value = "Não foi possível gravar a foto da câmera ao vivo."
            return
        }
        val embedded = PlatformServices.encodeBase64(stampedBytes).takeIf { it.isNotBlank() }
        val foto = FotoAnexo(
            path = path,
            capturadoEm = currentTimeMillis(),
            latitude = atual.latitude,
            longitude = atual.longitude,
            conteudoBase64 = embedded
        )
        _analiseVisualNrForm.value = atual.copy(fotos = atual.fotos + foto)
        _mensagem.value = "Foto confirmada. A conferencia na nuvem comeca quando a captura parar."
        analisarCenaVisualNr(aoVivo = true)
    }

    fun removerFotoAnaliseVisualNr(foto: FotoAnexo) {
        cacheVisaoNr.remove(foto.id)
        _analiseVisualNrForm.value = _analiseVisualNrForm.value.copy(
            fotos = _analiseVisualNrForm.value.fotos.filter { it.id != foto.id },
            descricoesFotos = _analiseVisualNrForm.value.descricoesFotos.filter { it.fotoId != foto.id }
        )
    }

    fun reanalisarFotoVisualNr(fotoId: String) {
        cacheVisaoNr.remove(fotoId)
        analisarCenaVisualNr(soFotoId = fotoId)
    }

    fun responderPerguntaVisualNr(perguntaId: String, resposta: String) {
        val form = _analiseVisualNrForm.value
        val pergunta = form.perguntas.find { it.id == perguntaId } ?: return
        val atualizada = pergunta.copy(resposta = resposta)
        val perguntas = form.perguntas.map { if (it.id == perguntaId) atualizada else it }
        val semEsta = form.achados.filter { it.notaTst != "pergunta:$perguntaId" }
        val achados = if (resposta == "nao") semEsta + achadoDaPergunta(atualizada) else semEsta
        _analiseVisualNrForm.value = form.copy(perguntas = perguntas, achados = achados)
    }

    private fun achadoDaPergunta(
        pergunta: br.com.htms.inspeccaocampo.data.nrvisual.PerguntaVisualNr
    ): br.com.htms.inspeccaocampo.data.nrvisual.NrAchado {
        val modelo = br.com.htms.inspeccaocampo.data.nrvisual.PerguntasNrVisual
            .para(pergunta.objeto)
            .find { it.texto == pergunta.texto }
        val catalogId = modelo?.catalogId ?: "GERAL_ordem_limpeza"
        val cat = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.porId(catalogId)
        return br.com.htms.inspeccaocampo.data.nrvisual.NrAchado(
            catalogId = catalogId,
            titulo = "Foto ${pergunta.fotoNumero} — ${modelo?.titulo ?: pergunta.texto}",
            nr = cat?.nr ?: "NR",
            citar = cat?.citar ?: (cat?.nr ?: ""),
            gravidade = cat?.gravidadePadrao
                ?: br.com.htms.inspeccaocampo.data.nrvisual.NrGravidade.MEDIA,
            oQueViu = "Foto ${pergunta.fotoNumero}. O TST marcou nao: ${pergunta.texto}",
            acaoSugerida = cat?.acao ?: "Validar no local",
            confianca = 0.8,
            fotoId = pergunta.fotoId,
            parecer = br.com.htms.inspeccaocampo.data.nrvisual.NrParecer.POSSIVEL_NC,
            objetoDetectado = pergunta.objeto,
            notaTst = "pergunta:${pergunta.id}"
        )
    }

    private fun sincronizarPerguntas(
        descricoes: List<br.com.htms.inspeccaocampo.data.nrvisual.DescricaoFotoNr>,
        atuais: List<br.com.htms.inspeccaocampo.data.nrvisual.PerguntaVisualNr>
    ): List<br.com.htms.inspeccaocampo.data.nrvisual.PerguntaVisualNr> {
        val prev = atuais.associateBy { it.fotoId + "|" + it.texto }
        return descricoes.flatMap { descricao ->
            descricao.objetos.distinct().flatMap { objeto ->
                br.com.htms.inspeccaocampo.data.nrvisual.PerguntasNrVisual.para(objeto).map { modelo ->
                    val antiga = prev[descricao.fotoId + "|" + modelo.texto]
                    if (antiga != null) {
                        antiga.copy(fotoNumero = descricao.numero, objeto = objeto)
                    } else {
                        br.com.htms.inspeccaocampo.data.nrvisual.PerguntaVisualNr(
                            fotoId = descricao.fotoId,
                            fotoNumero = descricao.numero,
                            objeto = objeto,
                            texto = modelo.texto
                        )
                    }
                }
            }
        }
    }

    fun analisarCenaVisualNr(aoVivo: Boolean = false, soFotoId: String? = null) {
        if (aoVivo && soFotoId == null) {
            nrVisualDebounceJob?.cancel()
            nrVisualDebounceJob = scope.launch {
                delay(1400)
                if (_analiseVisualNrAnalisando.value) {
                    nrVisualReanalisarApos = true
                } else {
                    executarAnaliseVisualNr(aoVivo = true, soFotoId = null)
                }
            }
            return
        }
        nrVisualDebounceJob?.cancel()
        if (_analiseVisualNrAnalisando.value) {
            nrVisualReanalisarApos = true
            if (soFotoId != null) nrVisualReanalisarSoFotoId = soFotoId
            return
        }
        scope.launch {
            executarAnaliseVisualNr(aoVivo, soFotoId)
        }
    }

    private suspend fun consultarVisaoFoto(
        numero: Int,
        fotoId: String,
        b64: String,
        observacao: String,
        fotoCount: Int,
        forcar: Boolean
    ): ResultadoVisaoFoto {
        val emCache = if (forcar) null else cacheVisaoNr[fotoId]
        if (emCache != null) {
            return ResultadoVisaoFoto(
                numero, fotoId, emCache.texto, emCache.objetos, emCache.cena, emCache.modo,
                emptyList(), falhou = false, doCache = true
            )
        }
        val remote = AuthApi.analyzeNrVisual(
            cenaTipo = "geral",
            descricaoCena = observacao,
            fotoCount = fotoCount,
            fotosBase64 = listOf(b64)
        )
        if (remote.isFailure) {
            return ResultadoVisaoFoto(
                numero, fotoId, "Nao foi possivel identificar esta foto.", emptyList(),
                "", "falha_visao_rede", emptyList(), falhou = true, doCache = false
            )
        }
        val result = remote.getOrThrow()
        val texto = result.resumoCena.ifBlank { "Nenhum objeto listado nesta foto." }
        val nomes = result.objetosDetectados.filter { it.isNotBlank() }
        val falhas = result.findings
            .filter { it.parecer == br.com.htms.inspeccaocampo.data.nrvisual.NrParecer.POSSIVEL_NC }
            .take(2)
            .map { achado ->
                achado.copy(
                    titulo = "Foto $numero — ${achado.titulo}",
                    oQueViu = "Foto $numero. ${achado.oQueViu}",
                    fotoId = fotoId
                )
            }
        cacheVisaoNr[fotoId] = CacheVisaoNr(texto, nomes, result.cenaSugerida, result.modo)
        return ResultadoVisaoFoto(
            numero, fotoId, texto, nomes, result.cenaSugerida, result.modo,
            falhas, falhou = false, doCache = false
        )
    }

    private suspend fun executarAnaliseVisualNr(aoVivo: Boolean, soFotoId: String?) {
            var atual = _analiseVisualNrForm.value
            if (atual.fotos.isEmpty()) {
                _mensagem.value = "Tire uma foto da cena para a IA identificar."
                return
            }
            // Observacao do TST e opcional; identificacao primaria vem das fotos (Workers AI).
            val observacaoOpcional = atual.descricaoCena.trim()
            _analiseVisualNrAnalisando.value = true
            try {
                val todas = atual.fotos.mapIndexedNotNull { index, foto ->
                    fotoBase64ParaAnalise(foto)?.let { Triple(index + 1, foto.id, it) }
                }
                if (todas.isEmpty()) {
                    _analiseVisualNrForm.value = atual.copy(
                        achados = emptyList(),
                        objetosDetectados = emptyList(),
                        resumoCena = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualAnaliseLocal.MSG_FALHA_VISAO,
                        analisadoEm = currentTimeMillis(),
                        modoAnalise = "sem_foto_base64",
                        normaVersao = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO,
                        normaVersaoData = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO_DATA
                    )
                    _mensagem.value =
                        "A foto foi anexada, mas os bytes nao foram lidos. Tire a foto de novo."
                    return
                }
                val soEsta = soFotoId?.let { id -> todas.filter { it.second == id } }.orEmpty()
                val preservar = soEsta.isNotEmpty() || aoVivo
                val fila = when {
                    soEsta.isNotEmpty() -> soEsta
                    aoVivo -> todas.filter { cacheVisaoNr[it.second] == null }
                    else -> todas
                }
                if (fila.isEmpty()) {
                    _mensagem.value = "Fotos ja analisadas. Descricao reaproveitada, sem novo envio."
                    return
                }
                val descricoes = if (preservar) atual.descricoesFotos.toMutableList() else mutableListOf()
                val objetos = if (preservar) atual.objetosDetectados.toMutableList() else mutableListOf()
                val achadosIa = if (preservar) {
                    atual.achados.filter { !it.notaTst.startsWith("pergunta:") }.toMutableList()
                } else {
                    mutableListOf()
                }
                var cenaFinal = atual.cenaTipo
                var modo = atual.modoAnalise
                var falhas = 0
                var reusadas = 0
                val resultados = mutableListOf<ResultadoVisaoFoto>()
                coroutineScope {
                    for (lote in fila.chunked(2)) {
                        val faltam = lote.filter { soFotoId == it.second || cacheVisaoNr[it.second] == null }
                        if (faltam.isNotEmpty()) {
                            _analiseVisualNrForm.value = _analiseVisualNrForm.value.copy(
                                resumoCena = "Analisando fotos " + faltam.joinToString(" e ") { it.first.toString() } + "..."
                            )
                        }
                        val prontos = lote.map { (numero, fotoId, b64) ->
                            async {
                                consultarVisaoFoto(
                                    numero, fotoId, b64, observacaoOpcional, atual.fotos.size,
                                    forcar = soFotoId == fotoId
                                )
                            }
                        }.awaitAll()
                        resultados += prontos
                    }
                }
                for (item in resultados) {
                    if (item.doCache) reusadas++
                    if (item.falhou) falhas++
                    descricoes.removeAll { it.fotoId == item.fotoId }
                    descricoes += br.com.htms.inspeccaocampo.data.nrvisual.DescricaoFotoNr(
                        fotoId = item.fotoId,
                        numero = item.numero,
                        texto = item.texto,
                        objetos = item.nomes
                    )
                    achadosIa.removeAll { it.fotoId == item.fotoId && !it.notaTst.startsWith("pergunta:") }
                    achadosIa += item.falhasFoto
                    for (nome in item.nomes) {
                        if (nome !in objetos) objetos += nome
                    }
                    if (item.cenaSug.isNotBlank()) {
                        cenaFinal = br.com.htms.inspeccaocampo.data.nrvisual.NrCenaTipo.fromId(item.cenaSug)
                    }
                    if (item.modoFoto.isNotBlank()) modo = item.modoFoto
                }
                descricoes.sortBy { it.numero }
                val perguntas = sincronizarPerguntas(descricoes, atual.perguntas)
                val achadosPergunta = atual.achados.filter { it.notaTst.startsWith("pergunta:") }
                val resumo = descricoes.joinToString("\n\n") { "Foto ${it.numero}\n${it.texto}" }
                _analiseVisualNrForm.value = atual.copy(
                    cenaTipo = cenaFinal,
                    achados = achadosIa + achadosPergunta,
                    objetosDetectados = objetos,
                    resumoCena = resumo,
                    descricoesFotos = descricoes,
                    perguntas = perguntas,
                    analisadoEm = currentTimeMillis(),
                    modoAnalise = modo.ifBlank { "worker_ai_visao_objeto" },
                    normaVersao = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO,
                    normaVersaoData = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO_DATA
                )
                _mensagem.value = when {
                    falhas == fila.size && reusadas == 0 ->
                        br.com.htms.inspeccaocampo.data.nrvisual.NrVisualAnaliseLocal.MSG_FALHA_VISAO
                    reusadas == fila.size ->
                        "Fotos ja analisadas. Descricao reaproveitada, sem novo envio."
                    else ->
                        "Descricao pronta para ${descricoes.size} foto(s). As perguntas nao bloqueiam o salvamento."
                }
            } catch (t: Throwable) {
                _analiseVisualNrForm.value = atual.copy(
                    achados = emptyList(),
                    objetosDetectados = emptyList(),
                    resumoCena = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualAnaliseLocal.MSG_FALHA_VISAO,
                    analisadoEm = currentTimeMillis(),
                    modoAnalise = "falha_visao_excecao",
                    normaVersao = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO,
                    normaVersaoData = br.com.htms.inspeccaocampo.data.nrvisual.NrVisualCatalog.NORMA_VERSAO_DATA
                )
                _mensagem.value =
                    "Falha na analise: ${t.message ?: "rede ou IA"}"
            } finally {
                _analiseVisualNrAnalisando.value = false
                if (nrVisualReanalisarApos) {
                    nrVisualReanalisarApos = false
                    val fotoPendente = nrVisualReanalisarSoFotoId
                    nrVisualReanalisarSoFotoId = null
                    analisarCenaVisualNr(aoVivo = fotoPendente == null, soFotoId = fotoPendente)
                }
            }
    }

    fun atualizarStatusAchadoNr(
        achadoId: String,
        status: br.com.htms.inspeccaocampo.data.nrvisual.NrAchadoStatus,
        nota: String? = null
    ) {
        _analiseVisualNrForm.value = _analiseVisualNrForm.value.copy(
            achados = _analiseVisualNrForm.value.achados.map { a ->
                if (a.id != achadoId) a
                else a.copy(status = status, notaTst = nota ?: a.notaTst)
            }
        )
    }

    fun validarESalvarAnaliseVisualNr() {
        val atual = _analiseVisualNrForm.value.copy(dataHorarioMs = currentTimeMillis())
        _analiseVisualNrForm.value = atual
        val msgs = br.com.htms.inspeccaocampo.data.nrvisual.AnaliseVisualNrValidacao.validar(atual)
        _erros.value = msgs.map { br.com.htms.inspeccaocampo.data.ErroCampo("geral", it) }
        if (msgs.isNotEmpty()) {
            _mensagem.value = "Há ${msgs.size} pendência(s). Verifique os campos marcados."
            registrarFalhaValidacao(FormTipo.ANALISE_VISUAL_NR, _erros.value)
            return
        }
        scope.launch {
            val completa = InspecaoCompleta(
                id = _idEdicao.value ?: 0L,
                formTipo = FormTipo.ANALISE_VISUAL_NR,
                form = FormInspecao(
                    tstResponsavel = atual.tstResponsavel,
                    dataHorarioMs = atual.dataHorarioMs,
                    latitude = atual.latitude,
                    longitude = atual.longitude,
                    localTexto = atual.localTexto,
                    obra = atual.obra,
                    descricaoAtividade = atual.descricaoCena
                ),
                analiseVisualNr = atual
            )
            val result = withContext(Dispatchers.Default) {
                store.salvarCompleta(completa, _idEdicao.value)
            }
            recarregarHistorico()
            if (!result.gravouCache) {
                _mensagem.value =
                    "ATENÇÃO: não gravou no cache. Exporte agora ou salve de novo. " +
                        (result.erro ?: "")
                _tab.value = AppTab.HISTORICO
                return@launch
            }
            _idEdicao.value = null
            _analiseVisualNrForm.value =
                br.com.htms.inspeccaocampo.data.nrvisual.FormAnaliseVisualNr(
                    dataHorarioMs = currentTimeMillis()
                )
            iniciarUploadAposSalvar(result.inspecao, "Analise visual NR salva.")
            _tab.value = AppTab.HUB
        }
    }

    /**
     * Salva local já concluído: libera a UI e envia em segundo plano.
     * Evita fechar a aba no meio do PDF/upload sem registrar o resultado.
     */
    private fun iniciarUploadAposSalvar(insp: InspecaoCompleta, mensagemBase: String) {
        if (AuthApi.currentSession() == null) {
            _mensagem.value = mensagemBase
            return
        }
        _mensagem.value = "$mensagemBase Enviando ao servidor..."
        _envioProgresso.value = EnvioProgresso(
            ativo = true,
            percent = 8,
            etapa = "Salvo neste aparelho"
        )
        scope.launch {
            uploadsEmAndamento++
            PlatformServices.setUnloadGuard(uploadsEmAndamento > 0)
            try {
                val uploadMsg = aposSalvarTentarUpload(insp)
                _mensagem.value = "$mensagemBase$uploadMsg"
            } finally {
                uploadsEmAndamento = (uploadsEmAndamento - 1).coerceAtLeast(0)
                PlatformServices.setUnloadGuard(uploadsEmAndamento > 0)
                finalizarEnvioProgresso(
                    ok = false,
                    etapa = "Envio interrompido",
                    detalhe = "Toque em Sincronizar no histórico para concluir."
                )
            }
        }
    }

    /** Atualiza o progresso só quando há um envio bloqueando a tela. */
    private fun progressoEnvio(percent: Int, etapa: String) {
        val atual = _envioProgresso.value
        if (!atual.ativo || atual.concluido) return
        _envioProgresso.value = atual.copy(
            percent = percent.coerceIn(0, 100),
            etapa = etapa
        )
    }

    /** Fecha o progresso; ignorado se outro resultado já foi registrado. */
    private fun finalizarEnvioProgresso(ok: Boolean, etapa: String, detalhe: String? = null) {
        val atual = _envioProgresso.value
        if (!atual.ativo || atual.concluido) return
        _envioProgresso.value = atual.copy(
            percent = 100,
            etapa = etapa,
            concluido = true,
            falhou = !ok,
            detalhe = detalhe
        )
    }

    fun fecharEnvioProgresso() {
        _envioProgresso.value = EnvioProgresso()
    }

    private suspend fun aposSalvarTentarUpload(insp: InspecaoCompleta): String {
        registrarAcesso(
            "FORM_SAVE",
            insp.formTipo.id,
            detalheInspecao(insp, "salvar")
        )
        registrarAcesso(
            "FORM_SEND",
            insp.formTipo.id,
            detalheInspecao(insp, "enviar", mapOf("result" to "start"))
        )
        return try {
            withTimeout(UPLOAD_TIMEOUT_MS) {
                val upload = enviarInspecaoComRetry(insp)
                upload.fold(
                    onSuccess = { remoteId ->
                        store.atualizar(insp.copy(enviadoRemoto = true))
                        recarregarHistorico()
                        recarregarHistoricoRemoto()
                        registrarAcessoGarantido(
                            "FORM_SEND",
                            insp.formTipo.id,
                            detalheInspecao(insp, "enviar", mapOf("result" to "ok", "remoteId" to remoteId))
                        )
                        if (ultimoEnvioComAnexos) {
                            finalizarEnvioProgresso(ok = true, etapa = "Envio concluído")
                        } else {
                            finalizarEnvioProgresso(
                                ok = true,
                                etapa = "Dados enviados",
                                detalhe = "PDF/Excel serão anexados automaticamente."
                            )
                        }
                        " Disponível para o admin (60 dias)."
                    },
                    onFailure = { err ->
                        // Safari às vezes aborta o fetch depois que o Worker já gravou (e-mail lento).
                        val jaNoServidor = remotoPorLocalId(insp.id)
                        if (jaNoServidor != null) {
                            store.atualizar(insp.copy(enviadoRemoto = true))
                            recarregarHistorico()
                            recarregarHistoricoRemoto()
                            registrarAcessoGarantido(
                                "FORM_SEND",
                                insp.formTipo.id,
                                detalheInspecao(
                                    insp,
                                    "enviar",
                                    mapOf(
                                        "result" to "ok",
                                        "remoteId" to jaNoServidor,
                                        "recovered" to "1"
                                    )
                                )
                            )
                            finalizarEnvioProgresso(ok = true, etapa = "Envio concluído")
                            " Disponível para o admin (60 dias)."
                        } else {
                            agendarReenvioPendentes()
                            val msg = err.message ?: "erro"
                            finalizarEnvioProgresso(
                                ok = false,
                                etapa = "Não foi possível enviar agora",
                                detalhe = "Salvo no aparelho. Reenvio automático quando a rede melhorar."
                            )
                            registrarAcessoGarantido(
                                "FORM_SEND",
                                insp.formTipo.id,
                                detalheInspecao(
                                    insp,
                                    "enviar",
                                    mapOf("result" to "fail", "error" to msg)
                                )
                            )
                            MSG_SALVO_REENVIAR
                        }
                    }
                )
            }
        } catch (e: TimeoutCancellationException) {
            val jaNoServidor = remotoPorLocalId(insp.id)
            if (jaNoServidor != null) {
                store.atualizar(insp.copy(enviadoRemoto = true))
                recarregarHistorico()
                recarregarHistoricoRemoto()
                registrarAcessoGarantido(
                    "FORM_SEND",
                    insp.formTipo.id,
                    detalheInspecao(
                        insp,
                        "enviar",
                        mapOf(
                            "result" to "ok",
                            "remoteId" to jaNoServidor,
                            "recovered" to "timeout"
                        )
                    )
                )
                finalizarEnvioProgresso(ok = true, etapa = "Envio concluído")
                " Disponível para o admin (60 dias)."
            } else {
                agendarReenvioPendentes()
                finalizarEnvioProgresso(
                    ok = false,
                    etapa = "Tempo excedido no envio",
                    detalhe = "Salvo no aparelho. Reenvio automático quando a rede melhorar."
                )
                registrarAcessoGarantido(
                    "FORM_SEND",
                    insp.formTipo.id,
                    detalheInspecao(
                        insp,
                        "enviar",
                        mapOf("result" to "fail", "error" to "timeout_${UPLOAD_TIMEOUT_MS / 1000}s")
                    )
                )
                MSG_SALVO_REENVIAR
            }
        } catch (e: CancellationException) {
            agendarReenvioPendentes()
            registrarAcessoGarantido(
                "FORM_SEND",
                insp.formTipo.id,
                detalheInspecao(insp, "enviar", mapOf("result" to "fail", "error" to "cancelled"))
            )
            throw e
        } catch (t: Throwable) {
            agendarReenvioPendentes()
            val msg = t.message ?: t::class.simpleName ?: "erro"
            registrarAcessoGarantido(
                "FORM_SEND",
                insp.formTipo.id,
                detalheInspecao(insp, "enviar", mapOf("result" to "fail", "error" to msg))
            )
            MSG_SALVO_REENVIAR
        }
    }

    /** Auditoria de acesso — fire-and-forget; não bloqueia o fluxo. */
    private fun registrarAcesso(action: String, target: String?, detail: String? = null) {
        if (AuthApi.currentSession() == null) return
        scope.launch {
            runCatching { AuthApi.logAccessEvent(action, target, detail) }
        }
    }

    /** Resultado final do envio: não pode ser cancelado junto com o upload. */
    private suspend fun registrarAcessoGarantido(action: String, target: String?, detail: String? = null) {
        if (AuthApi.currentSession() == null) return
        withContext(NonCancellable) {
            runCatching { AuthApi.logAccessEvent(action, target, detail) }
        }
    }

    private fun encodeLogValue(raw: String?): String {
        if (raw.isNullOrBlank()) return ""
        return raw.replace(';', ',')
            .replace('\n', ' ')
            .replace('\r', ' ')
            .trim()
            .take(500)
    }

    /** Detalhe de auditoria: key=value;key=value (valores sem ';'). */
    private fun detalheFormulario(
        tipo: FormTipo,
        command: String,
        localId: Long? = null,
        obra: String? = null,
        local: String? = null,
        tst: String? = null,
        extra: Map<String, String?> = emptyMap()
    ): String {
        val sessao = AuthApi.currentSession()?.user
        return buildList {
            add("command=${encodeLogValue(command)}")
            add("form=${encodeLogValue(tipo.rotulo)}")
            add("formId=${tipo.id}")
            localId?.takeIf { it > 0L }?.let { add("localId=$it") }
            obra?.takeIf { it.isNotBlank() }?.let { add("obra=${encodeLogValue(it)}") }
            local?.takeIf { it.isNotBlank() }?.let { add("local=${encodeLogValue(it)}") }
            tst?.takeIf { it.isNotBlank() }?.let { add("tst=${encodeLogValue(it)}") }
            sessao?.role?.takeIf { it.isNotBlank() }?.let { add("role=${encodeLogValue(it)}") }
            sessao?.nome?.takeIf { it.isNotBlank() }?.let { add("nome=${encodeLogValue(it)}") }
            extra.forEach { (chave, valor) ->
                val enc = encodeLogValue(valor)
                if (enc.isNotEmpty()) add("$chave=$enc")
            }
        }.joinToString(";")
    }

    private fun detalheInspecao(
        insp: InspecaoCompleta,
        command: String,
        extra: Map<String, String?> = emptyMap()
    ): String = detalheFormulario(
        tipo = insp.formTipo,
        command = command,
        localId = insp.id,
        obra = insp.obraResumo(),
        local = insp.localResumo(),
        tst = insp.responsavelResumo(),
        extra = extra
    )

    private fun contextoFormularioAtual(tipo: FormTipo): Triple<String, String, String> = when (tipo) {
        FormTipo.INSPECAO_CAMPO -> Triple(
            _form.value.obra,
            _form.value.localTexto,
            _form.value.tstResponsavel
        )
        FormTipo.CHECKLIST_DIARIO_HTMS,
        FormTipo.CHECKLIST_DIARIO_AXIA -> Triple(
            _checklistDiarioForm.value.obra,
            _checklistDiarioForm.value.localTexto,
            _checklistDiarioForm.value.preenchidoPor
        )
        FormTipo.RELATORIO_FOTO_ALOJAMENTO -> Triple(
            _relatorioForm.value.obra,
            _relatorioForm.value.endereco.ifBlank { _relatorioForm.value.localTexto },
            _relatorioForm.value.responsavelAlojamento
        )
        FormTipo.CHECKLIST_ALOJAMENTO,
        FormTipo.CHECKLIST_VETORES -> Triple(
            _checklistForm.value.obra,
            _checklistForm.value.endereco.ifBlank { _checklistForm.value.localTexto },
            _checklistForm.value.inspecionadoPor.nome
        )
        FormTipo.RELATORIO_ALOJAMENTO -> Triple(
            _relatorioForm.value.obra.ifBlank { _checklistForm.value.obra },
            _relatorioForm.value.endereco.ifBlank { _relatorioForm.value.localTexto }
                .ifBlank { _checklistForm.value.endereco.ifBlank { _checklistForm.value.localTexto } },
            _relatorioForm.value.responsavelAlojamento.ifBlank { _checklistForm.value.inspecionadoPor.nome }
        )
        FormTipo.COMUNICACAO_OCORRENCIAS -> Triple(
            _ocorrenciasForm.value.obra,
            _ocorrenciasForm.value.localExato
                .ifBlank { _ocorrenciasForm.value.localAcidente }
                .ifBlank { _ocorrenciasForm.value.localTexto },
            _ocorrenciasForm.value.quemReportando
        )
        FormTipo.REM_SEGURANCA_OBRAS -> Triple(
            _remForm.value.obra,
            "REM ${_remForm.value.ano}",
            _authUser.value?.displayName.orEmpty()
        )
        FormTipo.RELATORIO_SEGURANCA -> Triple(
            _relSegForm.value.obra,
            "Rel.Seg. ${br.com.htms.inspeccaocampo.data.RelSegMeses.rotulo(_relSegForm.value.mes)}/${_relSegForm.value.ano}",
            _authUser.value?.displayName.orEmpty()
        )
        FormTipo.ACOMPANHAMENTO_AMBIENTAL -> Triple(
            _acompAmbForm.value.obra,
            "Acomp.Amb. ${_acompAmbForm.value.ano}",
            _authUser.value?.displayName.orEmpty()
        )
        FormTipo.EVIDENCIA_TREINAMENTO -> Triple("", "Evidência de Treinamento", _authUser.value?.displayName.orEmpty())
        FormTipo.ANALISE_VISUAL_NR -> Triple(
            _analiseVisualNrForm.value.obra,
            _analiseVisualNrForm.value.localTexto,
            _analiseVisualNrForm.value.tstResponsavel
        )
    }

    private fun detalheFormularioAtual(
        tipo: FormTipo = _formTipoAtivo.value,
        command: String,
        localId: Long? = _idEdicao.value,
        extra: Map<String, String?> = emptyMap()
    ): String {
        val (obra, local, tst) = contextoFormularioAtual(tipo)
        return detalheFormulario(
            tipo = tipo,
            command = command,
            localId = localId,
            obra = obra,
            local = local,
            tst = tst,
            extra = extra
        )
    }


    fun atualizarRemObra(obra: String) {
        _remForm.value = _remForm.value.copy(obra = obra, dossierId = null, monthsCache = emptyList(), dirty = true)
        persistirRascunhoRemLocal()
    }

    fun atualizarRemAno(ano: Int) {
        _remForm.value = _remForm.value.copy(ano = ano, dossierId = null, monthsCache = emptyList(), dirty = true)
        persistirRascunhoRemLocal()
    }

    fun atualizarRemPayload(payload: RemMonthPayload) {
        val cur = _remForm.value
        if (cur.readOnly) return
        val synced =
            if (cur.abrangencia == RemAbrangencia.SUBCONTRATADOS) {
                val idx = cur.empresaTabIndex
                val existing = payload.blocoAt(idx)
                payload.withBlocoAt(
                    idx,
                    existing.copy(
                        numeroColaboradores = payload.numeroColaboradores,
                        hher = payload.hher,
                        homemHoraTreinamento = payload.homemHoraTreinamento,
                        horaAbsenteismoMedico = payload.horaAbsenteismoMedico,
                        numeroCat = payload.numeroCat,
                        ocorrenciasComLesao = payload.ocorrenciasComLesao,
                        ocorrenciasTrajeto = payload.ocorrenciasTrajeto,
                        danosPropriedade = payload.danosPropriedade,
                        nomesColaboradores = payload.nomesColaboradores,
                        ausencias = payload.ausencias
                    )
                )
            } else payload
        _remForm.value = cur.copy(payload = synced, dirty = true)
        persistirRascunhoRemLocal()
    }

    /** Atualiza so o nome da empresa da aba ativa (SUB). */
    fun atualizarRemEmpresaNome(nome: String) {
        val cur = _remForm.value
        if (cur.abrangencia != RemAbrangencia.SUBCONTRATADOS) return
        val idx = cur.empresaTabIndex
        val next = cur.payload.withBlocoAt(
            idx,
            cur.payload.blocoAt(idx).copy(
                nome = nome,
                numeroColaboradores = cur.payload.numeroColaboradores,
                hher = cur.payload.hher,
                homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                numeroCat = cur.payload.numeroCat,
                ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                danosPropriedade = cur.payload.danosPropriedade,
                nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
            )
        )
        _remForm.value = cur.copy(payload = next, dirty = true)
        persistirRascunhoRemLocal()
    }

    /** Troca a aba de empresa subcontratada (flush da atual + carrega a nova). */
    fun selecionarRemEmpresaTab(idx: Int) {
        val cur = _remForm.value
        if (cur.abrangencia != RemAbrangencia.SUBCONTRATADOS) return
        val blocs = cur.payload.empresasBlocosNormalizados()
        if (blocs.isEmpty()) return
        val from = cur.empresaTabIndex.coerceIn(0, blocs.lastIndex)
        val flushed = cur.payload.withBlocoAt(from, cur.payload.blocoAt(from).copy(
            numeroColaboradores = cur.payload.numeroColaboradores,
            hher = cur.payload.hher,
            homemHoraTreinamento = cur.payload.homemHoraTreinamento,
            horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
            numeroCat = cur.payload.numeroCat,
            ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
            ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
            danosPropriedade = cur.payload.danosPropriedade,
            nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
        ))
        val to = idx.coerceIn(0, flushed.empresasBlocosNormalizados().lastIndex)
        _remForm.value = cur.copy(
            payload = flushed.espelharBlocoNosCamposFlat(to),
            empresaTabIndex = to,
            dirty = true
        )
        persistirRascunhoRemLocal()
    }

    fun adicionarRemEmpresaTab() {
        val cur = _remForm.value
        if (cur.abrangencia != RemAbrangencia.SUBCONTRATADOS) return
        val from = cur.empresaTabIndex
        val flushed = cur.payload.withBlocoAt(
            from,
            cur.payload.blocoAt(from).copy(
                nome = cur.payload.blocoAt(from).nome,
                numeroColaboradores = cur.payload.numeroColaboradores,
                hher = cur.payload.hher,
                homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                numeroCat = cur.payload.numeroCat,
                ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                danosPropriedade = cur.payload.danosPropriedade,
                nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
            )
        ).adicionarEmpresaBloco()
        val newIdx = flushed.empresasBlocosNormalizados().lastIndex
        _remForm.value = cur.copy(
            payload = flushed.espelharBlocoNosCamposFlat(newIdx),
            empresaTabIndex = newIdx,
            dirty = true
        )
        persistirRascunhoRemLocal()
    }

    fun removerRemEmpresaTab(idx: Int) {
        val cur = _remForm.value
        if (cur.abrangencia != RemAbrangencia.SUBCONTRATADOS) return
        val blocs = cur.payload.empresasBlocosNormalizados()
        if (blocs.size <= 1) return
        val from = cur.empresaTabIndex.coerceIn(0, blocs.lastIndex)
        val flushed = cur.payload.withBlocoAt(
            from,
            cur.payload.blocoAt(from).copy(
                numeroColaboradores = cur.payload.numeroColaboradores,
                hher = cur.payload.hher,
                homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                numeroCat = cur.payload.numeroCat,
                ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                danosPropriedade = cur.payload.danosPropriedade,
                nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
            )
        )
        val next = flushed.removerEmpresaBloco(idx)
        val newIdx = cur.empresaTabIndex
            .let { if (idx < it) it - 1 else if (idx == it) it.coerceAtMost(next.empresasBlocosNormalizados().lastIndex) else it }
            .coerceIn(0, next.empresasBlocosNormalizados().lastIndex)
        _remForm.value = cur.copy(
            payload = next.espelharBlocoNosCamposFlat(newIdx),
            empresaTabIndex = newIdx,
            dirty = true
        )
        persistirRascunhoRemLocal()
    }

    fun selecionarRemAbrangencia(abr: RemAbrangencia) {
        val cur = _remForm.value
        val payloadToCache =
            if (cur.abrangencia == RemAbrangencia.SUBCONTRATADOS) {
                cur.payload.withBlocoAt(
                    cur.empresaTabIndex,
                    cur.payload.blocoAt(cur.empresaTabIndex).copy(
                        numeroColaboradores = cur.payload.numeroColaboradores,
                        hher = cur.payload.hher,
                        homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                        horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                        numeroCat = cur.payload.numeroCat,
                        ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                        ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                        danosPropriedade = cur.payload.danosPropriedade,
                        nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
                    )
                )
            } else cur.payload
        val cache = upsertRemCache(cur.monthsCache, cur.abrangencia, cur.mes, payloadToCache)
        var nextPayload = cache.find { it.abrangencia == abr && it.mes == cur.mes }?.payload
            ?: RemMonthPayload()
        var tabIdx = 0
        if (abr == RemAbrangencia.SUBCONTRATADOS) {
            nextPayload = nextPayload.espelharBlocoNosCamposFlat(0)
            tabIdx = 0
        }
        _remForm.value = remFormWithReadOnly(
            cur.copy(
                abrangencia = abr,
                payload = nextPayload,
                empresaTabIndex = tabIdx,
                monthsCache = cache
            )
        )
        persistirRascunhoRemLocal()
    }

    fun selecionarRemMes(mes: Int) {
        val cur = _remForm.value
        val payloadToCache =
            if (cur.abrangencia == RemAbrangencia.SUBCONTRATADOS) {
                cur.payload.withBlocoAt(
                    cur.empresaTabIndex,
                    cur.payload.blocoAt(cur.empresaTabIndex).copy(
                        numeroColaboradores = cur.payload.numeroColaboradores,
                        hher = cur.payload.hher,
                        homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                        horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                        numeroCat = cur.payload.numeroCat,
                        ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                        ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                        danosPropriedade = cur.payload.danosPropriedade,
                        nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
                    )
                )
            } else cur.payload
        val cache = upsertRemCache(cur.monthsCache, cur.abrangencia, cur.mes, payloadToCache)
        var nextPayload = cache.find { it.abrangencia == cur.abrangencia && it.mes == mes }?.payload
            ?: RemMonthPayload()
        var tabIdx = 0
        if (cur.abrangencia == RemAbrangencia.SUBCONTRATADOS) {
            nextPayload = nextPayload.espelharBlocoNosCamposFlat(0)
        }
        _remForm.value = remFormWithReadOnly(
            cur.copy(
                mes = mes.coerceIn(1, 12),
                payload = nextPayload,
                empresaTabIndex = tabIdx,
                monthsCache = cache
            )
        )
        persistirRascunhoRemLocal()
    }

    private fun upsertRemCache(
        cache: List<RemMonthRow>,
        abr: RemAbrangencia,
        mes: Int,
        payload: RemMonthPayload
    ): List<RemMonthRow> {
        val filtered = cache.filterNot { it.abrangencia == abr && it.mes == mes }
        return filtered + RemMonthRow(abrangencia = abr, mes = mes, payload = payload)
    }

    fun abrirOuCriarRemDossier() {
        val cur = _remForm.value
        if (cur.obra.isBlank()) {
            _mensagem.value = "Selecione a obra."
            return
        }
        scope.launch {
            _remSalvando.value = true
            try {
                val created = AuthApi.createRemDossier(cur.obra, cur.ano).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao abrir dossiê REM"
                    return@launch
                }
                val full = AuthApi.getRemDossier(created.id).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao carregar dossiê REM"
                    return@launch
                }
                val rawPayload = full.months
                    .find { it.abrangencia == cur.abrangencia && it.mes == cur.mes }
                    ?.payload
                    ?: RemMonthPayload()
                val payload =
                    if (cur.abrangencia == RemAbrangencia.SUBCONTRATADOS)
                        rawPayload.espelharBlocoNosCamposFlat(0)
                    else rawPayload
                _remForm.value = remFormWithReadOnly(
                    cur.copy(
                        dossierId = full.id,
                        obra = full.obra,
                        ano = full.ano,
                        monthsCache = full.months,
                        payload = payload,
                        empresaTabIndex = 0,
                        dirty = false,
                        lastSyncedAt = currentTimeMillis()
                    )
                )
                persistirRascunhoRemLocal()
                val ro = _remForm.value.readOnly
                _mensagem.value = if (ro) {
                    "Dossiê REM aberto (${full.obra} / ${full.ano}). Este mês já foi salvo — somente leitura."
                } else {
                    "Dossiê REM pronto (${full.obra} / ${full.ano})."
                }
                recarregarRemDossiers()
                recarregarRelSegDossiers()
                recarregarAcompAmbDossiers()
            } finally {
                _remSalvando.value = false
            }
        }
    }

    fun salvarRemMesAtual() {
        val cur0 = _remForm.value
        if (cur0.readOnly) {
            _mensagem.value = "Este mês já foi salvo. Somente admin pode alterar."
            return
        }
        val dossierId = cur0.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra ou crie o dossiê antes de salvar."
            return
        }
        scope.launch {
            _remSalvando.value = true
            try {
                val cur = flushRemEmpresaAtiva(cur0)
                val cache = upsertRemCache(cur.monthsCache, cur.abrangencia, cur.mes, cur.payload)
                _remForm.value = cur.copy(monthsCache = cache, dirty = true)
                persistirRascunhoRemLocal()
                val payloadJson = RemJson.payloadToJson(cur.payload)
                val emailTo = _appConfig.value.emailsParaForm(FormTipo.REM_SEGURANCA_OBRAS).joinToString(",")
                val saved = AuthApi.upsertRemMonth(
                    dossierId = dossierId,
                    abrangencia = cur.abrangencia.id,
                    mes = cur.mes,
                    payloadJson = payloadJson,
                    emailTo = emailTo
                ).getOrElse {
                    _mensagem.value = "Rascunho local ok. Sync: ${it.message ?: "falha"}"
                    return@launch
                }
                val cache2 = cache.filterNot {
                    it.abrangencia == saved.abrangencia && it.mes == saved.mes
                } + saved
                _remForm.value = remFormWithReadOnly(
                    _remForm.value.copy(
                        monthsCache = cache2,
                        dirty = false,
                        lastSyncedAt = currentTimeMillis()
                    )
                )
                persistirRascunhoRemLocal()
                _mensagem.value =
                    "REM salvo. Disponível em Histórico (obra ${cur.obra} / ${cur.ano})."
                recarregarRemDossiers()
                recarregarRelSegDossiers()
                recarregarAcompAmbDossiers()
            } finally {
                _remSalvando.value = false
            }
        }
    }

    private fun flushRemEmpresaAtiva(cur: FormRemSeguranca): FormRemSeguranca {
        if (cur.abrangencia != RemAbrangencia.SUBCONTRATADOS) return cur
        val idx = cur.empresaTabIndex
        val next = cur.payload.withBlocoAt(
            idx,
            cur.payload.blocoAt(idx).copy(
                numeroColaboradores = cur.payload.numeroColaboradores,
                hher = cur.payload.hher,
                homemHoraTreinamento = cur.payload.homemHoraTreinamento,
                horaAbsenteismoMedico = cur.payload.horaAbsenteismoMedico,
                numeroCat = cur.payload.numeroCat,
                ocorrenciasComLesao = cur.payload.ocorrenciasComLesao,
                ocorrenciasTrajeto = cur.payload.ocorrenciasTrajeto,
                danosPropriedade = cur.payload.danosPropriedade,
                nomesColaboradores = cur.payload.nomesColaboradores,
                        ausencias = cur.payload.ausencias
            )
        )
        return cur.copy(payload = next)
    }

    fun abrirRemDossierDoHistorico(dossierId: String) {
        if (!isAdmin) {
            _historico.value = HistoricoUiState(
                mensagem = "Somente admin pode editar REM pelo Histórico. Use o formulário para preencher meses novos."
            )
            return
        }
        scope.launch {
            _remSalvando.value = true
            try {
                val full = AuthApi.getRemDossier(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(
                        mensagem = it.message ?: "Falha ao abrir dossiê REM"
                    )
                    return@launch
                }
                val first = full.months.firstOrNull()
                _remForm.value = remFormWithReadOnly(
                    FormRemSeguranca(
                        dossierId = full.id,
                        obra = full.obra,
                        ano = full.ano,
                        monthsCache = full.months,
                        payload = first?.payload ?: RemMonthPayload(),
                        abrangencia = first?.abrangencia ?: RemAbrangencia.HTMS,
                        mes = first?.mes ?: 1,
                        dirty = false,
                        lastSyncedAt = currentTimeMillis()
                    )
                )
                persistirRascunhoRemLocal()
                _formTipoAtivo.value = FormTipo.REM_SEGURANCA_OBRAS
                _tab.value = AppTab.FORM
                _mensagem.value = "Editando REM ${full.obra} / ${full.ano}"
            } finally {
                _remSalvando.value = false
            }
        }
    }

    fun baixarRemExcelDoHistorico(dossierId: String, obra: String, ano: Int) {
        scope.launch {
            _remExportandoId.value = dossierId
            try {
                val bytes = AuthApi.downloadRemExcel(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(
                        mensagem = it.message ?: "Falha ao gerar Excel REM"
                    )
                    return@launch
                }
                val name = "REM_Seguranca_${obra.replace(' ', '_')}_$ano.xlsx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.REM_SEGURANCA_OBRAS.rotulo, obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Baixar Excel REM"
                    )
                }
                _historico.value = HistoricoUiState(mensagem = "Excel REM baixado.")
            } finally {
                _remExportandoId.value = null
            }
        }
    }

    fun baixarRemExcel() {
        val dossierId = _remForm.value.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra o dossiê antes de baixar o Excel."
            return
        }
        scope.launch {
            _remBaixando.value = true
            try {
                if (_remForm.value.dirty && !_remForm.value.readOnly) {
                    salvarRemMesAtualSync()
                }
                val bytes = AuthApi.downloadRemExcel(dossierId).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao gerar Excel REM"
                    return@launch
                }
                val name = "REM_Seguranca_${_remForm.value.obra.replace(' ', '_')}_${_remForm.value.ano}.xlsx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.REM_SEGURANCA_OBRAS.rotulo, _remForm.value.obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Baixar Excel REM"
                    )
                }
                _mensagem.value = "Excel REM gerado."
            } finally {
                _remBaixando.value = false
            }
        }
    }

    fun excluirRemDossier(dossierId: String) {
        scope.launch {
            AuthApi.deleteRemDossier(dossierId)
                .onSuccess {
                    _remDossiers.value = _remDossiers.value.filterNot { it.id == dossierId }
                    if (_remForm.value.dossierId == dossierId) {
                        _remForm.value = _remForm.value.copy(dossierId = null, monthsCache = emptyList())
                        persistirRascunhoRemLocal()
                    }
                    _historico.value = HistoricoUiState(mensagem = "Dossiê REM movido para a lixeira (7 dias).")
                }
                .onFailure {
                    _historico.value = HistoricoUiState(
                        mensagem = "Erro ao excluir REM: ${it.message}"
                    )
                }
        }
    }

    /**
     * Master only: zera REM no servidor.
     * @param resetScope `mes` | `obra_ano` | `geral`
     */
    fun zerarRemAdmin(resetScope: String) {
        if (!isMaster) {
            _mensagem.value = "Somente o admin master pode zerar o REM."
            return
        }
        val cur = _remForm.value
        if (resetScope != "geral" && cur.obra.isBlank()) {
            _mensagem.value = "Selecione a obra antes de zerar."
            return
        }
        scope.launch {
            _remSalvando.value = true
            try {
                val msg = AuthApi.resetRemAdmin(
                    scope = resetScope,
                    obra = if (resetScope == "geral") null else cur.obra.ifBlank { null },
                    ano = if (resetScope == "geral") null else cur.ano,
                    mes = if (resetScope == "mes") cur.mes else null
                ).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao zerar REM"
                    return@launch
                }
                when (resetScope) {
                    "geral" -> {
                        _remForm.value = FormRemSeguranca(
                            obra = cur.obra,
                            ano = cur.ano
                        )
                        _remDossiers.value = emptyList()
                    }
                    "obra_ano" -> {
                        _remForm.value = cur.copy(
                            dossierId = null,
                            monthsCache = emptyList(),
                            payload = RemMonthPayload(),
                            dirty = false
                        )
                        _remDossiers.value = _remDossiers.value.filterNot {
                            it.obra.equals(cur.obra, ignoreCase = true) && it.ano == cur.ano
                        }
                    }
                    "mes" -> {
                        val cache = cur.monthsCache.filterNot { it.mes == cur.mes }
                        _remForm.value = cur.copy(
                            monthsCache = cache,
                            payload = RemMonthPayload(),
                            dirty = false
                        )
                    }
                }
                persistirRascunhoRemLocal()
                recarregarRemDossiers()
                recarregarRelSegDossiers()
                recarregarAcompAmbDossiers()
                _mensagem.value = msg
            } finally {
                _remSalvando.value = false
            }
        }
    }

    private suspend fun salvarRemMesAtualSync() {
        val cur = flushRemEmpresaAtiva(_remForm.value)
        _remForm.value = cur
        val dossierId = cur.dossierId ?: return
        val payloadJson = RemJson.payloadToJson(cur.payload)
        val emailTo = _appConfig.value.emailsParaForm(FormTipo.REM_SEGURANCA_OBRAS).joinToString(",")
        AuthApi.upsertRemMonth(
            dossierId,
            cur.abrangencia.id,
            cur.mes,
            payloadJson,
            emailTo
        ).getOrNull()
    }

    private suspend fun recarregarAcompAmbDossiers() {
        if (!temAcessoForm(FormTipo.ACOMPANHAMENTO_AMBIENTAL)) {
            _acompAmbDossiers.value = emptyList()
            return
        }
        AuthApi.listAcompAmbDossiers(all = false)
            .onSuccess { _acompAmbDossiers.value = it }
            .onFailure { /* complementar */ }
    }

    private fun acompAmbMesJaSalvo(aba: AcompAmbAba, mes: Int, cache: List<AcompAmbMonthRow>): Boolean =
        cache.any { it.aba == aba && it.mes == mes }

    private fun acompAmbReadOnlyFor(aba: AcompAmbAba, mes: Int, cache: List<AcompAmbMonthRow>): Boolean =
        !isAdmin && acompAmbMesJaSalvo(aba, mes, cache)

    private fun acompAmbFormWithReadOnly(cur: FormAcompanhamentoAmbiental): FormAcompanhamentoAmbiental =
        cur.copy(readOnly = acompAmbReadOnlyFor(cur.aba, cur.effectiveMes(), cur.rowsCache))

    private fun upsertAcompAmbCache(
        cache: List<AcompAmbMonthRow>,
        aba: AcompAmbAba,
        mes: Int,
        payload: AcompAmbMonthPayload
    ): List<AcompAmbMonthRow> {
        val filtered = cache.filterNot { it.aba == aba && it.mes == mes }
        return filtered + AcompAmbMonthRow(aba = aba, mes = mes, payload = payload)
    }

    fun atualizarAcompAmbObra(obra: String) {
        _acompAmbForm.value = _acompAmbForm.value.copy(
            obra = obra,
            dossierId = null,
            rowsCache = emptyList(),
            dirty = true
        )
    }

    fun atualizarAcompAmbAno(ano: Int) {
        _acompAmbForm.value = _acompAmbForm.value.copy(
            ano = ano,
            dossierId = null,
            rowsCache = emptyList(),
            dirty = true
        )
    }

    fun atualizarAcompAmbPayload(payload: AcompAmbMonthPayload) {
        val cur = _acompAmbForm.value
        if (cur.readOnly) return
        _acompAmbForm.value = cur.copy(payload = payload, dirty = true)
    }

    fun atualizarAcompAmbValor(key: String, value: String) {
        atualizarAcompAmbPayload(_acompAmbForm.value.payload.withValue(key, value))
    }

    fun selecionarAcompAmbAba(aba: AcompAmbAba) {
        val cur = _acompAmbForm.value
        val effMes = if (AcompAmbSchema.monthly(cur.aba)) cur.effectiveMes() else 0
        val cache = upsertAcompAmbCache(cur.rowsCache, cur.aba, effMes, cur.payload)
        val nextMes = if (AcompAmbSchema.monthly(aba)) cur.mes else 0
        val nextPayload = cache.find { it.aba == aba && it.mes == nextMes }?.payload
            ?: AcompAmbMonthPayload()
        _acompAmbForm.value = acompAmbFormWithReadOnly(
            cur.copy(aba = aba, payload = nextPayload, rowsCache = cache)
        )
    }

    fun selecionarAcompAmbMes(mes: Int) {
        val cur = _acompAmbForm.value
        if (!AcompAmbSchema.monthly(cur.aba)) return
        val effMes = cur.effectiveMes()
        val cache = upsertAcompAmbCache(cur.rowsCache, cur.aba, effMes, cur.payload)
        val mesSel = mes.coerceIn(1, 12)
        val nextPayload = cache.find { it.aba == cur.aba && it.mes == mesSel }?.payload
            ?: AcompAmbMonthPayload()
        _acompAmbForm.value = acompAmbFormWithReadOnly(
            cur.copy(mes = mesSel, payload = nextPayload, rowsCache = cache)
        )
    }

    fun abrirOuCriarAcompAmbDossier() {
        val cur = _acompAmbForm.value
        if (cur.obra.isBlank()) {
            _mensagem.value = "Selecione a obra."
            return
        }
        scope.launch {
            _acompAmbSalvando.value = true
            try {
                val created = AuthApi.createAcompAmbDossier(cur.obra, cur.ano).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao abrir dossiê Acomp. Ambiental"
                    return@launch
                }
                val full = AuthApi.getAcompAmbDossier(created.id).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao carregar dossiê Acomp. Ambiental"
                    return@launch
                }
                val effMes = if (AcompAmbSchema.monthly(cur.aba)) cur.mes else 0
                val payload = full.months
                    .find { it.aba == cur.aba && it.mes == effMes }
                    ?.payload
                    ?: AcompAmbMonthPayload()
                _acompAmbForm.value = acompAmbFormWithReadOnly(
                    cur.copy(
                        dossierId = full.id,
                        obra = full.obra,
                        ano = full.ano,
                        rowsCache = full.months,
                        payload = payload,
                        dirty = false
                    )
                )
                val ro = _acompAmbForm.value.readOnly
                _mensagem.value = if (ro) {
                    "Dossiê aberto (${full.obra} / ${full.ano}). Esta aba/mês já foi salvo — somente leitura."
                } else {
                    "Dossiê pronto (${full.obra} / ${full.ano})."
                }
                recarregarAcompAmbDossiers()
            } finally {
                _acompAmbSalvando.value = false
            }
        }
    }

    fun salvarAcompAmbAtual() {
        val cur0 = _acompAmbForm.value
        if (cur0.readOnly) {
            _mensagem.value = "Esta aba/mês já foi salvo. Somente admin pode alterar."
            return
        }
        val dossierId = cur0.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra ou crie o dossiê antes de salvar."
            return
        }
        scope.launch {
            _acompAmbSalvando.value = true
            try {
                val cur = cur0
                val effMes = cur.effectiveMes()
                val cache = upsertAcompAmbCache(cur.rowsCache, cur.aba, effMes, cur.payload)
                _acompAmbForm.value = cur.copy(rowsCache = cache, dirty = true)
                val payloadJson = AcompAmbJson.payloadToJson(cur.payload)
                val emailTo = _appConfig.value.emailsParaForm(FormTipo.ACOMPANHAMENTO_AMBIENTAL).joinToString(",")
                val saved = AuthApi.upsertAcompAmbMonth(
                    dossierId = dossierId,
                    aba = cur.aba.id,
                    mes = effMes,
                    payloadJson = payloadJson,
                    emailTo = emailTo
                ).getOrElse {
                    _mensagem.value = "Sync: ${it.message ?: "falha"}"
                    return@launch
                }
                val cache2 = cache.filterNot { it.aba == saved.aba && it.mes == saved.mes } + saved
                _acompAmbForm.value = acompAmbFormWithReadOnly(
                    _acompAmbForm.value.copy(rowsCache = cache2, dirty = false)
                )
                _mensagem.value =
                    "Acompanhamento Ambiental salvo. Disponível em Histórico (obra ${cur.obra} / ${cur.ano})."
                recarregarAcompAmbDossiers()
            } finally {
                _acompAmbSalvando.value = false
            }
        }
    }

    fun abrirAcompAmbDossierDoHistorico(dossierId: String) {
        if (!isAdmin) {
            _historico.value = HistoricoUiState(
                mensagem = "Somente admin pode editar Acomp. Ambiental pelo Histórico."
            )
            return
        }
        scope.launch {
            _acompAmbSalvando.value = true
            try {
                val full = AuthApi.getAcompAmbDossier(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(
                        mensagem = it.message ?: "Falha ao abrir dossiê Acomp. Ambiental"
                    )
                    return@launch
                }
                val first = full.months.firstOrNull()
                _acompAmbForm.value = acompAmbFormWithReadOnly(
                    FormAcompanhamentoAmbiental(
                        dossierId = full.id,
                        obra = full.obra,
                        ano = full.ano,
                        rowsCache = full.months,
                        payload = first?.payload ?: AcompAmbMonthPayload(),
                        aba = first?.aba ?: AcompAmbAba.PROCEDIMENTOS_GERAIS,
                        mes = first?.mes?.takeIf { it in 1..12 } ?: 1,
                        dirty = false
                    )
                )
                _formTipoAtivo.value = FormTipo.ACOMPANHAMENTO_AMBIENTAL
                _tab.value = AppTab.FORM
                _mensagem.value = "Editando Acomp. Ambiental ${full.obra} / ${full.ano}"
            } finally {
                _acompAmbSalvando.value = false
            }
        }
    }

    fun baixarAcompAmbExcelDoHistorico(dossierId: String, obra: String, ano: Int) {
        scope.launch {
            _acompAmbExportandoId.value = dossierId
            try {
                val bytes = AuthApi.downloadAcompAmbExcel(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(
                        mensagem = it.message ?: "Falha ao gerar Excel Acomp. Ambiental"
                    )
                    return@launch
                }
                val name = "Acompanhamento_Ambiental_${obra.replace(' ', '_')}_$ano.xlsx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.ACOMPANHAMENTO_AMBIENTAL.rotulo, obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Baixar Excel Acomp. Ambiental"
                    )
                }
                _historico.value = HistoricoUiState(mensagem = "Excel Acomp. Ambiental baixado.")
            } finally {
                _acompAmbExportandoId.value = null
            }
        }
    }

    fun baixarAcompAmbExcel() {
        val dossierId = _acompAmbForm.value.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra o dossiê antes de baixar o Excel."
            return
        }
        scope.launch {
            _acompAmbBaixando.value = true
            try {
                if (_acompAmbForm.value.dirty && !_acompAmbForm.value.readOnly) {
                    salvarAcompAmbAtualSync()
                }
                val bytes = AuthApi.downloadAcompAmbExcel(dossierId).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao gerar Excel Acomp. Ambiental"
                    return@launch
                }
                val name =
                    "Acompanhamento_Ambiental_${_acompAmbForm.value.obra.replace(' ', '_')}_${_acompAmbForm.value.ano}.xlsx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.ACOMPANHAMENTO_AMBIENTAL.rotulo, _acompAmbForm.value.obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "Baixar Excel Acomp. Ambiental"
                    )
                }
                _mensagem.value = "Excel Acomp. Ambiental gerado."
            } finally {
                _acompAmbBaixando.value = false
            }
        }
    }


    private fun acompAmbDossierIdOrWarn(): String? {
        val id = _acompAmbForm.value.dossierId
        if (id.isNullOrBlank()) {
            _mensagem.value = "Abra ou crie o dossiê antes de anexar fotos."
            return null
        }
        return id
    }

    fun adicionarFotoAcompAmb(slot: String, fromGallery: Boolean = false) {
        if (_acompAmbForm.value.readOnly) return
        val dossierId = acompAmbDossierIdOrWarn() ?: return
        val schemaSlot = AcompAmbSchema.schema(_acompAmbForm.value.aba).photoSlots
            .find { it.key == slot }
        val max = schemaSlot?.maxPhotos ?: 4
        val curRefs = _acompAmbForm.value.payload.fotosDoSlot(slot)
        if (curRefs.size >= max) {
            _mensagem.value = "Limite de $max fotos neste registro."
            return
        }
        launchFoto {
            try {
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val cur = _acompAmbForm.value
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = "",
                        pergunta = schemaSlot?.label ?: "Acomp. Ambiental",
                        resposta = "Foto ${curRefs.size + 1}",
                        responsavelFrente = "",
                        localTexto = cur.obra,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude,
                        longitude = captured.longitude,
                        numeroInspecao = null
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val index = cur.payload.fotosDoSlot(slot).size
                val key = AuthApi.uploadAcompAmbPhoto(dossierId, stampedBytes, slot, index).getOrElse {
                    throw it
                }.key
                val next = cur.payload.fotosDoSlot(slot) + key
                val payload = cur.payload.withFotosSlot(slot, next)
                val cache = upsertAcompAmbCache(cur.rowsCache, cur.aba, cur.effectiveMes(), payload)
                _acompAmbForm.value = acompAmbFormWithReadOnly(
                    cur.copy(payload = payload, rowsCache = cache, dirty = true)
                )
                _mensagem.value = "Foto anexada (${next.size}/$max)."
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoAcompAmb(slot: String, index: Int) {
        val cur = _acompAmbForm.value
        if (cur.readOnly) return
        val list = cur.payload.fotosDoSlot(slot).toMutableList()
        if (index !in list.indices) return
        list.removeAt(index)
        val payload = cur.payload.withFotosSlot(slot, list)
        val cache = upsertAcompAmbCache(cur.rowsCache, cur.aba, cur.effectiveMes(), payload)
        _acompAmbForm.value = acompAmbFormWithReadOnly(
            cur.copy(payload = payload, rowsCache = cache, dirty = true)
        )
    }

    fun excluirAcompAmbDossier(dossierId: String) {
        scope.launch {
            AuthApi.deleteAcompAmbDossier(dossierId)
                .onSuccess {
                    _acompAmbDossiers.value = _acompAmbDossiers.value.filterNot { it.id == dossierId }
                    if (_acompAmbForm.value.dossierId == dossierId) {
                        _acompAmbForm.value = _acompAmbForm.value.copy(
                            dossierId = null,
                            rowsCache = emptyList()
                        )
                    }
                    _historico.value = HistoricoUiState(mensagem = "Dossiê Acomp. Ambiental movido para a lixeira (7 dias).")
                }
                .onFailure {
                    _historico.value = HistoricoUiState(
                        mensagem = "Erro ao excluir Acomp. Ambiental: ${it.message}"
                    )
                }
        }
    }

    private suspend fun salvarAcompAmbAtualSync() {
        val cur = _acompAmbForm.value
        val dossierId = cur.dossierId ?: return
        val effMes = cur.effectiveMes()
        val payloadJson = AcompAmbJson.payloadToJson(cur.payload)
        val emailTo = _appConfig.value.emailsParaForm(FormTipo.ACOMPANHAMENTO_AMBIENTAL).joinToString(",")
        AuthApi.upsertAcompAmbMonth(
            dossierId,
            cur.aba.id,
            effMes,
            payloadJson,
            emailTo
        ).getOrNull()
    }


    fun atualizarRelSegObra(obra: String) {
        _relSegForm.value = _relSegForm.value.copy(
            obra = obra,
            dossierId = null,
            dirty = true,
            payload = _relSegForm.value.payload.copy(
                dadosGerais = _relSegForm.value.payload.dadosGerais.copy(obra = obra)
            )
        )
        persistirRascunhoRelSegLocal()
    }

    fun atualizarRelSegAno(ano: Int) {
        _relSegForm.value = _relSegForm.value.copy(ano = ano, dossierId = null, dirty = true)
        persistirRascunhoRelSegLocal()
    }

    fun atualizarRelSegMes(mes: Int) {
        _relSegForm.value = _relSegForm.value.copy(mes = mes, dossierId = null, dirty = true)
        persistirRascunhoRelSegLocal()
    }

    fun atualizarRelSegPayload(p: br.com.htms.inspeccaocampo.data.RelSegPayload) {
        if (_relSegForm.value.readOnly) return
        _relSegForm.value = _relSegForm.value.copy(payload = p.withDdsSize().withTreinamentosSize(), dirty = true)
        persistirRascunhoRelSegLocal()
    }

    fun abrirOuCriarRelSegDossier() {
        val cur = _relSegForm.value
        if (cur.obra.isBlank()) {
            _mensagem.value = "Selecione a obra."
            return
        }
        scope.launch {
            _relSegSalvando.value = true
            try {
                val created = AuthApi.createRelSegDossier(cur.obra, cur.ano, cur.mes).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao abrir dossiê Rel. Seg."
                    return@launch
                }
                val full = AuthApi.getRelSegDossier(created.id).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao carregar dossiê Rel. Seg."
                    return@launch
                }
                val readOnly = relSegReadOnlyFrom(full)
                _relSegForm.value = cur.copy(
                    dossierId = full.id,
                    obra = full.obra,
                    ano = full.ano,
                    mes = full.mes,
                    payload = full.payload.withDdsSize().withTreinamentosSize(),
                    dirty = false,
                    lastSyncedAt = currentTimeMillis(),
                    readOnly = readOnly
                )
                persistirRascunhoRelSegLocal()
                _mensagem.value = if (readOnly) {
                    "Dossiê Rel. Seg. aberto (${full.obra} / ${br.com.htms.inspeccaocampo.data.RelSegMeses.rotulo(full.mes)}/${full.ano}). Somente leitura."
                } else {
                    "Dossiê Rel. Seg. pronto (${full.obra} / ${br.com.htms.inspeccaocampo.data.RelSegMeses.rotulo(full.mes)}/${full.ano})."
                }
                recarregarRelSegDossiers()
            } finally {
                _relSegSalvando.value = false
            }
        }
    }

    fun salvarRelSegDossier() {
        val cur = _relSegForm.value
        if (cur.readOnly) {
            _mensagem.value = "Este relatório já foi salvo. Somente admin pode alterar."
            return
        }
        val dossierId = cur.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra ou crie o dossiê antes de salvar."
            return
        }
        scope.launch {
            _relSegSalvando.value = true
            try {
                persistirRascunhoRelSegLocal()
                val payloadJson = br.com.htms.inspeccaocampo.data.RelSegJson.payloadToJson(cur.payload)
                val emailTo = _appConfig.value.emailsParaForm(FormTipo.RELATORIO_SEGURANCA).joinToString(",")
                val saved = AuthApi.saveRelSegDossier(dossierId, payloadJson, emailTo).getOrElse {
                    _mensagem.value = "Rascunho local ok. Sync: ${it.message ?: "falha"}"
                    return@launch
                }
                _relSegForm.value = cur.copy(
                    payload = saved.payload.withDdsSize().withTreinamentosSize(),
                    dirty = false,
                    lastSyncedAt = currentTimeMillis(),
                    readOnly = !isAdmin
                )
                persistirRascunhoRelSegLocal()
                _mensagem.value =
                    "Rel. Seg. salvo. Disponível em Histórico (${cur.obra} / ${br.com.htms.inspeccaocampo.data.RelSegMeses.rotulo(cur.mes)}/${cur.ano})."
                recarregarRelSegDossiers()
            } finally {
                _relSegSalvando.value = false
            }
        }
    }

    fun baixarRelSegPptx() {
        val dossierId = _relSegForm.value.dossierId
        if (dossierId.isNullOrBlank()) {
            _mensagem.value = "Abra o dossiê antes de baixar o PPTX."
            return
        }
        scope.launch {
            _relSegBaixando.value = true
            try {
                if (_relSegForm.value.dirty && !_relSegForm.value.readOnly) {
                    val cur = _relSegForm.value
                    val payloadJson = br.com.htms.inspeccaocampo.data.RelSegJson.payloadToJson(cur.payload)
                    val emailTo = _appConfig.value.emailsParaForm(FormTipo.RELATORIO_SEGURANCA).joinToString(",")
                    AuthApi.saveRelSegDossier(dossierId, payloadJson, emailTo).getOrElse {
                        _mensagem.value = it.message ?: "Falha ao salvar antes do PPTX"
                        return@launch
                    }
                    _relSegForm.value = cur.copy(
                        dirty = false,
                        lastSyncedAt = currentTimeMillis(),
                        readOnly = !isAdmin
                    )
                }
                val bytes = AuthApi.downloadRelSegPptx(dossierId).getOrElse {
                    _mensagem.value = it.message ?: "Falha ao gerar PPTX"
                    return@launch
                }
                val f = _relSegForm.value
                val name = "Relatorio_Seguranca_${f.obra.replace(' ', '_')}_${f.ano}_${f.mes.toString().padStart(2, '0')}.pptx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.RELATORIO_SEGURANCA.rotulo, f.obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                        "Baixar PPTX Rel. Seg."
                    )
                }
                _mensagem.value = "PPTX Rel. Seg. gerado."
            } finally {
                _relSegBaixando.value = false
            }
        }
    }

    private fun relSegDossierIdOrWarn(): String? {
        val id = _relSegForm.value.dossierId
        if (id.isNullOrBlank()) {
            _mensagem.value = "Abra ou crie o dossiê antes de anexar fotos."
            return null
        }
        return id
    }

    fun adicionarFotoRelSegDds(index: Int, fromGallery: Boolean = false) {
        val dossierId = relSegDossierIdOrWarn() ?: return
        launchFoto {
            try {
                persistirRascunhoRelSegLocal()
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val cur = _relSegForm.value
                val tema = cur.payload.withDdsSize().dds.getOrNull(index)?.temaData?.ifBlank { "DDS" } ?: "DDS"
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = "",
                        pergunta = "DDS dia ${index + 1}",
                        resposta = tema,
                        responsavelFrente = "",
                        localTexto = cur.obra,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude,
                        longitude = captured.longitude,
                        numeroInspecao = null
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val key = AuthApi.uploadRelSegPhoto(dossierId, stampedBytes, "dds", index = index).getOrElse {
                    throw it
                }.key
                val list = cur.payload.withDdsSize().dds.toMutableList()
                list[index] = list[index].copy(fotoRef = key)
                _relSegForm.value = cur.copy(payload = cur.payload.copy(dds = list), dirty = true)
                persistirRascunhoRelSegLocal()
                _mensagem.value = "Foto DDS ${index + 1} anexada."
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoRelSegDds(index: Int) {
        val cur = _relSegForm.value
        val list = cur.payload.withDdsSize().dds.toMutableList()
        list[index] = list[index].copy(fotoRef = "")
        _relSegForm.value = cur.copy(payload = cur.payload.copy(dds = list), dirty = true)
        persistirRascunhoRelSegLocal()
    }

    fun adicionarFotoRelSegTreinamento(block: Int, photo: Int, fromGallery: Boolean = false) {
        val dossierId = relSegDossierIdOrWarn() ?: return
        launchFoto {
            try {
                persistirRascunhoRelSegLocal()
                val captured = obterFotoCapturada(fromGallery) ?: return@launchFoto
                val cur = _relSegForm.value
                val tre = cur.payload.withTreinamentosSize().treinamentos.getOrNull(block)
                val titulo = tre?.treinamento?.ifBlank { "Treinamento ${block + 1}" } ?: "Treinamento ${block + 1}"
                val stampedBytes = aplicarCarimbo(
                    captured.path,
                    PhotoStampData(
                        tstResponsavel = "",
                        pergunta = titulo,
                        resposta = "Foto ${photo + 1}",
                        responsavelFrente = "",
                        localTexto = cur.obra,
                        dataHoraMs = currentTimeMillis(),
                        latitude = captured.latitude,
                        longitude = captured.longitude,
                        numeroInspecao = null
                    )
                )
                if (stampedBytes == null || stampedBytes.isEmpty()) {
                    _mensagem.value = "Não foi possível carimbar a foto."
                    return@launchFoto
                }
                val key = AuthApi.uploadRelSegPhoto(
                    dossierId, stampedBytes, "tre", block = block, photo = photo
                ).getOrElse { throw it }.key
                val list = cur.payload.withTreinamentosSize().treinamentos.toMutableList()
                val t = list[block].withFotosSize()
                val fotos = t.fotos.toMutableList()
                fotos[photo] = key
                list[block] = t.copy(fotos = fotos)
                _relSegForm.value = cur.copy(payload = cur.payload.copy(treinamentos = list), dirty = true)
                persistirRascunhoRelSegLocal()
                _mensagem.value = "Foto treinamento ${block + 1} (${photo + 1}/4) anexada."
            } catch (t: Throwable) {
                _mensagem.value = "Falha ao anexar foto: ${t.message ?: "tente novamente"}"
            }
        }
    }

    fun removerFotoRelSegTreinamento(block: Int, photo: Int) {
        val cur = _relSegForm.value
        val list = cur.payload.withTreinamentosSize().treinamentos.toMutableList()
        val t = list[block].withFotosSize()
        val fotos = t.fotos.toMutableList()
        fotos[photo] = ""
        list[block] = t.copy(fotos = fotos)
        _relSegForm.value = cur.copy(payload = cur.payload.copy(treinamentos = list), dirty = true)
        persistirRascunhoRelSegLocal()
    }

    fun abrirRelSegDossierDoHistorico(dossierId: String) {
        if (!isAdmin) {
            _historico.value = HistoricoUiState(
                mensagem = "Somente admin pode editar Rel. Seg. pelo Histórico. Use o formulário para preencher meses novos."
            )
            return
        }
        scope.launch {
            _relSegSalvando.value = true
            try {
                val full = AuthApi.getRelSegDossier(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(mensagem = it.message ?: "Falha ao abrir Rel. Seg.")
                    return@launch
                }
                _relSegForm.value = br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca(
                    dossierId = full.id,
                    obra = full.obra,
                    ano = full.ano,
                    mes = full.mes,
                    payload = full.payload.withDdsSize().withTreinamentosSize(),
                    dirty = false,
                    lastSyncedAt = currentTimeMillis(),
                    readOnly = false
                )
                persistirRascunhoRelSegLocal()
                _formTipoAtivo.value = FormTipo.RELATORIO_SEGURANCA
                _tab.value = AppTab.FORM
                _mensagem.value = "Editando Rel. Seg. ${full.obra} / ${br.com.htms.inspeccaocampo.data.RelSegMeses.rotulo(full.mes)}/${full.ano}"
            } finally {
                _relSegSalvando.value = false
            }
        }
    }

    fun baixarRelSegPptxDoHistorico(dossierId: String, obra: String, ano: Int, mes: Int) {
        scope.launch {
            _relSegExportandoId.value = dossierId
            try {
                val bytes = AuthApi.downloadRelSegPptx(dossierId).getOrElse {
                    _historico.value = HistoricoUiState(mensagem = it.message ?: "Falha ao gerar PPTX")
                    return@launch
                }
                val name = "Relatorio_Seguranca_${obra.replace(' ', '_')}_${ano}_${mes.toString().padStart(2, '0')}.pptx"
                val path = PlatformFiles.join(PlatformFiles.cacheDir(), name)
                PlatformFiles.writeBytes(path, bytes)
                br.com.htms.inspeccaocampo.platform.BackupSharePoint.com(MODULO_FORMULARIOS, FormTipo.RELATORIO_SEGURANCA.rotulo, obra) {
                    PlatformFiles.shareFile(
                        path,
                        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                        "Baixar PPTX Rel. Seg."
                    )
                }
                _historico.value = HistoricoUiState(mensagem = "PPTX Rel. Seg. baixado.")
            } finally {
                _relSegExportandoId.value = null
            }
        }
    }

    fun excluirRelSegDossier(id: String) {
        scope.launch {
            AuthApi.deleteRelSegDossier(id).getOrElse {
                _historico.value = HistoricoUiState(mensagem = it.message ?: "Falha ao excluir")
                return@launch
            }
            if (_relSegForm.value.dossierId == id) {
                _relSegForm.value = _relSegForm.value.copy(dossierId = null)
            }
            recarregarRelSegDossiers()
            _historico.value = HistoricoUiState(mensagem = "Dossiê Rel. Seg. movido para a lixeira (7 dias).")
        }
    }

    private suspend fun recarregarRelSegDossiers() {
        if (!temAcessoForm(FormTipo.RELATORIO_SEGURANCA)) {
            _relSegDossiers.value = emptyList()
            return
        }
        _relSegDossiers.value = AuthApi.listRelSegDossiers(all = false).getOrElse { emptyList() }
    }

    private fun relSegDraftPath(): String =
        PlatformFiles.join(PlatformFiles.documentsDir(), "rascunho_rel_seguranca.json")

    private fun persistirRascunhoRelSegLocal() {
        val f = _relSegForm.value
        val json = buildString {
            append('{')
            append("\"dossierId\":"); append(if (f.dossierId == null) "null" else "\"${f.dossierId}\"")
            append(",\"obra\":\""); append(f.obra.replace("\"", "\\\"")); append('"')
            append(",\"ano\":"); append(f.ano)
            append(",\"mes\":"); append(f.mes)
            append(",\"dirty\":"); append(f.dirty)
            append(",\"payload\":"); append(br.com.htms.inspeccaocampo.data.RelSegJson.payloadToJson(f.payload))
            append('}')
        }
        runCatching { PlatformFiles.writeText(relSegDraftPath(), json) }
    }

    private fun carregarRascunhoRelSegLocal() {
        val text = PlatformFiles.readText(relSegDraftPath()) ?: return
        val payloadStart = text.indexOf("\"payload\":")
        val payloadJson = if (payloadStart >= 0) {
            val brace = text.indexOf('{', payloadStart)
            if (brace >= 0) {
                var depth = 0
                var end = brace
                for (i in brace until text.length) {
                    when (text[i]) {
                        '{' -> depth++
                        '}' -> { depth--; if (depth == 0) { end = i; break } }
                    }
                }
                text.substring(brace, end + 1)
            } else "{}"
        } else "{}"
        val idMatch = Regex("\"dossierId\"\\s*:\\s*(null|\"([^\"]*)\")").find(text)
        val dossierId = idMatch?.groups?.get(2)?.value
        val obra = Regex("\"obra\"\\s*:\\s*\"((?:\\\\.|[^\"\\\\])*)\"").find(text)?.groupValues?.get(1)?.replace("\\\"", "\"") ?: ""
        val ano = Regex("\"ano\"\\s*:\\s*(\\d+)").find(text)?.groupValues?.get(1)?.toIntOrNull() ?: yearOf(currentTimeMillis())
        val mes = Regex("\"mes\"\\s*:\\s*(\\d+)").find(text)?.groupValues?.get(1)?.toIntOrNull() ?: 1
        _relSegForm.value = br.com.htms.inspeccaocampo.data.FormRelatorioSeguranca(
            dossierId = dossierId,
            obra = obra,
            ano = ano,
            mes = mes,
            payload = br.com.htms.inspeccaocampo.data.RelSegJson.payloadFromJson(payloadJson),
            dirty = text.contains("\"dirty\":true")
        )
    }

    private fun remDraftPath(): String =
        PlatformFiles.join(PlatformFiles.documentsDir(), "rascunho_rem_seguranca.json")

    private fun persistirRascunhoRemLocal() {
        val f = _remForm.value
        val json = buildString {
            append('{')
            append("\"dossierId\":")
            append(if (f.dossierId == null) "null" else "\"${f.dossierId}\"")
            append(",\"obra\":"); append(jsonQuote(f.obra))
            append(",\"ano\":"); append(f.ano)
            append(",\"abrangencia\":"); append(jsonQuote(f.abrangencia.id))
            append(",\"mes\":"); append(f.mes)
            append(",\"payload\":"); append(RemJson.payloadToJson(f.payload))
            append('}')
        }
        runCatching { PlatformFiles.writeText(remDraftPath(), json) }
    }

    private fun carregarRascunhoRemLocal() {
        val text = PlatformFiles.readText(remDraftPath()) ?: return
        runCatching {
            fun extractString(key: String): String? {
                val needle = "\"" + key + "\""
                val i = text.indexOf(needle)
                if (i < 0) return null
                var j = i + needle.length
                while (j < text.length && text[j].isWhitespace()) j++
                if (j >= text.length || text[j] != ':') return null
                j++
                while (j < text.length && text[j].isWhitespace()) j++
                if (j >= text.length) return null
                if (text.startsWith("null", j)) return null
                if (text[j] == '"') {
                    j++
                    val sb = StringBuilder()
                    while (j < text.length) {
                        val c = text[j]
                        if (c == '\\' && j + 1 < text.length) {
                            sb.append(text[j + 1]); j += 2; continue
                        }
                        if (c == '"') break
                        sb.append(c); j++
                    }
                    return sb.toString()
                }
                val startNum = j
                while (j < text.length && (text[j].isDigit() || text[j] == '-' || text[j] == '.')) j++
                return text.substring(startNum, j)
            }
            val payloadKey = "\"payload\""
            val payloadStart = text.indexOf(payloadKey)
            val payloadJson = if (payloadStart >= 0) {
                val brace = text.indexOf('{', payloadStart)
                if (brace >= 0) {
                    var depth = 0
                    var endIdx = brace
                    while (endIdx < text.length) {
                        val ch = text[endIdx]
                        if (ch == '{') depth++
                        else if (ch == '}') {
                            depth--
                            if (depth == 0) break
                        }
                        endIdx++
                    }
                    text.substring(brace, endIdx + 1)
                } else "{}"
            } else "{}"
            _remForm.value = FormRemSeguranca(
                dossierId = extractString("dossierId"),
                obra = extractString("obra").orEmpty(),
                ano = extractString("ano")?.toIntOrNull() ?: yearOf(currentTimeMillis()),
                abrangencia = RemAbrangencia.fromId(extractString("abrangencia")),
                mes = extractString("mes")?.toIntOrNull()?.coerceIn(1, 12) ?: 1,
                payload = RemJson.payloadFromJson(payloadJson),
                dirty = true
            )
        }
    }
    private fun jsonQuote(s: String): String {
        val esc = s.replace("\\", "\\\\").replace("\"", "\\\"")
            .replace("\n", "\\n").replace("\r", "\\r")
        return "\"$esc\""
    }


    fun registrarManualAberto(formTipo: FormTipo = _formTipoAtivo.value) {
        registrarAcesso(
            "MANUAL_OPEN",
            formTipo.id,
            detalheFormularioAtual(tipo = formTipo, command = "manual")
        )
    }

    private fun registrarFalhaValidacao(tipo: FormTipo, erros: List<ErroCampo>) {
        val resumo = erros.joinToString(" | ") { it.mensagem }
        registrarAcesso(
            "FORM_SAVE_FAIL",
            tipo.id,
            detalheFormularioAtual(
                tipo = tipo,
                command = "salvar",
                extra = mapOf(
                    "result" to "fail",
                    "pendencias" to erros.size.toString(),
                    "error" to resumo
                )
            )
        )
    }

    private fun registrarAberturaFormulario(
        tipo: FormTipo,
        editando: Boolean,
        localId: Long? = null
    ) {
        val action = when (tipo) {
            FormTipo.CHECKLIST_ALOJAMENTO,
            FormTipo.CHECKLIST_VETORES,
            FormTipo.CHECKLIST_DIARIO_HTMS,
            FormTipo.CHECKLIST_DIARIO_AXIA -> "CHECKLIST_OPEN"
            else -> "FORM_OPEN"
        }
        registrarAcesso(
            action,
            tipo.id,
            detalheFormularioAtual(
                tipo = tipo,
                command = if (editando) "editar" else "abrir",
                localId = localId ?: _idEdicao.value
            )
        )
    }

    /** Se o POST falhou no browser mas o Worker já gravou, recupera o id remoto. */
    private suspend fun remotoPorLocalId(localId: Long): String? {
        val list = AuthApi.listInspections().getOrNull() ?: return null
        _remoteInspections.value = list
        return list.firstOrNull { it.localId == localId }?.id
    }

    /**
     * Completa PDF/Excel quando o JSON já está no servidor (envio interrompido no Chrome).
     */
    private suspend fun completarAnexosRemotosIncompletos() {
        if (AuthApi.currentSession() == null) return
        if (!PlatformServices.isNetworkAvailable()) return
        val remotas = AuthApi.listInspections().getOrNull() ?: return
        _remoteInspections.value = remotas
        val incompletas = remotas.filter { !it.hasPdf && !it.hasExcel && it.localId != null }
        if (incompletas.isEmpty()) return
        val locais = store.listar().associateBy { it.id }
        for (remota in incompletas) {
            val lid = remota.localId ?: continue
            val local = locais[lid] ?: continue
            if (local.formTipo == FormTipo.RELATORIO_SEGURANCA ||
                local.formTipo == FormTipo.REM_SEGURANCA_OBRAS ||
                local.formTipo == FormTipo.ACOMPANHAMENTO_AMBIENTAL
            ) {
                continue
            }
            val tentativas = tentativasAnexo[lid] ?: 0
            if (tentativas >= 3) continue
            tentativasAnexo[lid] = tentativas + 1
            runCatching { enviarInspecaoAoServidor(local) }
        }
    }

    private fun isTransientNetworkError(err: Throwable): Boolean {
        val msg = (err.message ?: err::class.simpleName ?: "").lowercase()
        return msg.contains("sem conexão") ||
            msg.contains("falha de rede") ||
            msg.contains("failed to fetch") ||
            msg.contains("networkerror") ||
            msg.contains("network request failed") ||
            msg.contains("load failed") ||
            msg.contains("timeout") ||
            msg.contains("timed out") ||
            msg.contains("request timed out") ||
            msg.contains("connection reset") ||
            msg.contains("connection abort") ||
            msg.contains("broken pipe") ||
            msg.contains("unable to resolve") ||
            msg.contains("failed to connect") ||
            msg.contains("network is unreachable") ||
            msg.contains("sslhandshake") ||
            msg.contains("socket") ||
            msg.contains("cancelled") ||
            msg.contains("canceled") ||
            msg.contains("abort") ||
            msg.contains("connection was lost") ||
            msg.contains("appears to be offline") ||
            msg.contains("cannot parse response") ||
            msg.contains("nsurlerror") ||
            msg.contains("the operation couldn't be completed") ||
            msg.contains("offline") ||
            msg == "rede"
    }

    /** POST com retries curtos em rede ruim; não repete erro de validação/auth. */
    private suspend fun enviarInspecaoComRetry(insp: InspecaoCompleta): Result<String> {
        var last: Result<String> = Result.failure(IllegalStateException("Sem tentativa"))
        repeat(UPLOAD_RETRY_MAX) { attempt ->
            if (attempt > 0) {
                delay(UPLOAD_RETRY_BACKOFF_MS.getOrElse(attempt - 1) { 60_000L })
                // Só short-circuit se o remoto já tem PDF/Excel; JSON-only continua para anexar.
                val list = AuthApi.listInspections().getOrNull()
                if (list != null) {
                    _remoteInspections.value = list
                    val remota = list.firstOrNull { it.localId == insp.id }
                    if (remota != null && (remota.hasPdf || remota.hasExcel)) {
                        store.atualizar(insp.copy(enviadoRemoto = true))
                        return Result.success(remota.id)
                    }
                }
            }
            last = enviarInspecaoAoServidor(insp)
            if (last.isSuccess) return last
            val err = last.exceptionOrNull() ?: return last
            if (!isTransientNetworkError(err)) return last
        }
        return last
    }

    private suspend fun enviarInspecaoAoServidor(insp: InspecaoCompleta): Result<String> {
        return try {
            val slim = when (insp.formTipo) {
                FormTipo.INSPECAO_CAMPO ->
                    insp.copy(form = insp.form.semConteudoBase64())
                FormTipo.RELATORIO_FOTO_ALOJAMENTO,
                FormTipo.RELATORIO_ALOJAMENTO ->
                    insp.copy(relatorioFoto = insp.relatorioFoto?.semConteudoBase64())
                FormTipo.COMUNICACAO_OCORRENCIAS ->
                    insp.copy(
                        comunicacaoOcorrencias = insp.comunicacaoOcorrencias?.semConteudoBase64()
                    )
                FormTipo.CHECKLIST_DIARIO_HTMS,
                FormTipo.CHECKLIST_DIARIO_AXIA ->
                    insp.copy(checklistDiario = insp.checklistDiario?.checklistDiarioSemBase64())
                FormTipo.CHECKLIST_ALOJAMENTO,
                FormTipo.CHECKLIST_VETORES -> insp
                FormTipo.REM_SEGURANCA_OBRAS,
                FormTipo.RELATORIO_SEGURANCA,
                FormTipo.ACOMPANHAMENTO_AMBIENTAL,
                FormTipo.EVIDENCIA_TREINAMENTO -> insp
                FormTipo.ANALISE_VISUAL_NR ->
                    insp.copy(analiseVisualNr = insp.analiseVisualNr?.semConteudoBase64())
            }
            val jsonText = FormJson.inspecaoToJson(slim)
            val summaryEfetivo = when (insp.formTipo) {
                FormTipo.INSPECAO_CAMPO -> insp.form.efetivo.ifBlank { null }
                FormTipo.RELATORIO_FOTO_ALOJAMENTO,
                FormTipo.RELATORIO_ALOJAMENTO ->
                    insp.relatorioFoto?.quantidadeFuncionarios?.ifBlank { null }
                else -> null
            }

            // Fase 1: JSON slim (sem PDF/Excel) — garante registro remoto mesmo se o browser abortar.
            ultimoEnvioComAnexos = false
            progressoEnvio(20, "Enviando dados da inspeção...")
            val remoteId = AuthApi.uploadInspection(
                localId = insp.id,
                createdAt = insp.criadoEm,
                summaryTst = insp.responsavelResumo(),
                summaryLocal = insp.localResumo(),
                summaryEfetivo = summaryEfetivo,
                summaryObra = insp.obraResumo().ifBlank { null },
                dataHorarioMs = insp.dataHorarioMsResumo().takeIf { it > 0 },
                formType = insp.formTipo.id,
                emailTo = _appConfig.value.emailsParaForm(insp.formTipo).joinToString(","),
                pdfFileName = ExportNames.pdf(insp),
                excelFileName = ExportNames.excel(insp),
                pdfBytes = null,
                excelBytes = null,
                jsonText = jsonText
            ).getOrElse { return Result.failure(it) }

            // Fase 2: gera e anexa PDF/Excel; falha aqui não desfaz o JSON já enviado.
            progressoEnvio(45, "Dados registrados. Gerando PDF...")
            try {
                val pdfBytes = withContext(Dispatchers.Default) {
                    try {
                        when (insp.formTipo) {
                            FormTipo.INSPECAO_CAMPO -> JpegPdfBuilder.build(insp)
                            FormTipo.RELATORIO_FOTO_ALOJAMENTO -> JpegPdfBuilder.buildRelatorio(insp)
                            FormTipo.CHECKLIST_ALOJAMENTO,
                            FormTipo.CHECKLIST_VETORES -> JpegPdfBuilder.buildChecklist(insp)
                            FormTipo.RELATORIO_ALOJAMENTO -> JpegPdfBuilder.buildRelatorioAlojamento(insp)
                            FormTipo.COMUNICACAO_OCORRENCIAS -> JpegPdfBuilder.buildComunicacao(insp)
                            FormTipo.ANALISE_VISUAL_NR -> JpegPdfBuilder.buildAnaliseVisualNr(insp)
                            FormTipo.CHECKLIST_DIARIO_HTMS,
                            FormTipo.CHECKLIST_DIARIO_AXIA -> JpegPdfBuilder.buildChecklistDiario(insp)
                            FormTipo.RELATORIO_SEGURANCA ->
                                error("Relatório de segurança usa PPTX no Worker (/rel-seg/dossiers/:id/pptx).")
                            FormTipo.REM_SEGURANCA_OBRAS ->
                                error("REM não gera PDF de inspeção.")
                            FormTipo.ACOMPANHAMENTO_AMBIENTAL ->
                                error("Acompanhamento Ambiental usa Excel no Worker (/acomp-amb/dossiers/:id/excel).")
                            FormTipo.EVIDENCIA_TREINAMENTO ->
                                error("Evidência de Treinamento fica no próprio formulário.")
                        }
                    } catch (t: Throwable) {
                        if (t is CancellationException) throw t
                        throw IllegalStateException(
                            "Falha ao gerar PDF: ${t.message ?: t::class.simpleName}",
                            t
                        )
                    }
                }
                if (pdfBytes.isNotEmpty()) {
                    progressoEnvio(65, "PDF pronto. Gerando Excel...")
                    val excelBytes = withContext(Dispatchers.Default) {
                        try {
                            SharedExcelBuilder.build(insp)
                        } catch (t: Throwable) {
                            if (t is CancellationException) throw t
                            throw IllegalStateException(
                                "Falha ao gerar Excel: ${t.message ?: t::class.simpleName}",
                                t
                            )
                        }
                    }
                    progressoEnvio(80, "Enviando PDF e Excel...")
                    AuthApi.uploadInspection(
                        localId = insp.id,
                        createdAt = insp.criadoEm,
                        summaryTst = insp.responsavelResumo(),
                        summaryLocal = insp.localResumo(),
                        summaryEfetivo = summaryEfetivo,
                        summaryObra = insp.obraResumo().ifBlank { null },
                        dataHorarioMs = insp.dataHorarioMsResumo().takeIf { it > 0 },
                        formType = insp.formTipo.id,
                        emailTo = _appConfig.value.emailsParaForm(insp.formTipo).joinToString(","),
                        pdfFileName = ExportNames.pdf(insp),
                        excelFileName = ExportNames.excel(insp),
                        pdfBytes = pdfBytes,
                        excelBytes = excelBytes,
                        jsonText = jsonText
                    ).onSuccess {
                        ultimoEnvioComAnexos = true
                        tentativasAnexo.remove(insp.id)
                        progressoEnvio(95, "Finalizando...")
                    }
                }
            } catch (e: CancellationException) {
                throw e
            } catch (_: Throwable) {
                // ignora — JSON já está no servidor; anexos podem ser completados depois
            }
            Result.success(remoteId)
        } catch (e: CancellationException) {
            throw e
        } catch (t: Throwable) {
            Result.failure(t)
        }
    }

    private fun agendarReenvioPendentes() {
        if (reenvioAgendado) return
        reenvioAgendado = true
        scope.launch {
            try {
                val atrasos = listOf(8_000L, 20_000L, 45_000L, 90_000L, 180_000L, 300_000L)
                for (ms in atrasos) {
                    delay(ms)
                    if (AuthApi.currentSession() == null) break
                    sincronizarPendentesInterno()
                    if (store.listar().none { !it.enviadoRemoto }) break
                }
            } finally {
                reenvioAgendado = false
            }
        }
    }

    private suspend fun sincronizarPendentesInterno(forcadoPeloUsuario: Boolean = false) {
        if (AuthApi.currentSession() == null) {
            if (forcadoPeloUsuario) {
                _historico.value = HistoricoUiState(mensagem = "Faça login para sincronizar.")
            }
            return
        }
        if (sincronizandoPendentes) {
            if (forcadoPeloUsuario) {
                _historico.value = _historico.value.copy(
                    mensagem = "Sincronização já em andamento..."
                )
            }
            return
        }
        // Sem rede: não gera PDF/Excel (estoura memória no mobile e derruba a página).
        if (!PlatformServices.isNetworkAvailable()) {
            if (forcadoPeloUsuario) {
                _historico.value = HistoricoUiState(
                    mensagem = "Sem conexão. Conecte-se e toque em Sincronizar novamente."
                )
            }
            return
        }
        sincronizandoPendentes = true
        if (forcadoPeloUsuario) {
            _historico.value = _historico.value.copy(
                sincronizandoPendentes = true,
                mensagem = "Verificando pendências neste aparelho..."
            )
        }
        try {
            val listResult = AuthApi.listInspections()
            if (listResult.isFailure) {
                if (forcadoPeloUsuario) {
                    val err = listResult.exceptionOrNull()?.message ?: "erro"
                    _historico.value = HistoricoUiState(
                        mensagem = "Não foi possível consultar o servidor: $err"
                    )
                }
                return
            }
            _remoteInspections.value = listResult.getOrElse { emptyList() }
            val remoteLocalIds = _remoteInspections.value.mapNotNull { it.localId }.toSet()
            val remotasPorLocal = _remoteInspections.value
                .mapNotNull { r -> r.localId?.let { it to r } }
                .toMap()
            store.listar()
                .filter { !it.enviadoRemoto && it.id in remoteLocalIds }
                .forEach { pendente ->
                    val remota = remotasPorLocal[pendente.id]
                    val semAnexos = remota != null &&
                        !remota.hasPdf &&
                        !remota.hasExcel &&
                        pendente.formTipo != FormTipo.RELATORIO_SEGURANCA &&
                        pendente.formTipo != FormTipo.REM_SEGURANCA_OBRAS &&
                        pendente.formTipo != FormTipo.ACOMPANHAMENTO_AMBIENTAL
                    if (semAnexos) {
                        // JSON chegou mas PDF/Excel não: segue pendente para anexar no loop abaixo.
                        val tentativas = tentativasAnexo[pendente.id] ?: 0
                        if (tentativas < 3) {
                            tentativasAnexo[pendente.id] = tentativas + 1
                            return@forEach
                        }
                    }
                    store.atualizar(pendente.copy(enviadoRemoto = true))
                    val remoteId = _remoteInspections.value.firstOrNull { it.localId == pendente.id }?.id
                    registrarAcesso(
                        "FORM_SEND",
                        pendente.formTipo.id,
                        detalheInspecao(
                            pendente,
                            "enviar",
                            buildMap {
                                put("result", "ok")
                                put("recovered", "sync")
                                if (remoteId != null) put("remoteId", remoteId)
                            }
                        )
                    )
                }
            // Marcado como enviado no aparelho, mas não existe no servidor (envio órfão).
            // Só no clique manual e na janela de 60 dias — evita reenvio em massa de JSON antigo.
            if (forcadoPeloUsuario) {
                val agora = currentTimeMillis()
                val janelaMs = 60L * 24 * 60 * 60 * 1000
                store.listar()
                    .filter {
                        it.enviadoRemoto &&
                            it.id !in remoteLocalIds &&
                            (agora - it.criadoEm) in 0..janelaMs
                    }
                    .forEach { orfao ->
                        store.atualizar(orfao.copy(enviadoRemoto = false))
                        registrarAcesso(
                            "FORM_SEND",
                            orfao.formTipo.id,
                            detalheInspecao(
                                orfao,
                                "enviar",
                                mapOf("result" to "requeue", "reason" to "missing_remote")
                            )
                        )
                    }
            }
            recarregarHistorico()
            val pendentes = store.listar().filter {
                !it.enviadoRemoto &&
                    it.formTipo != FormTipo.RELATORIO_SEGURANCA &&
                    it.formTipo != FormTipo.REM_SEGURANCA_OBRAS
            }
            if (pendentes.isEmpty()) {
                if (forcadoPeloUsuario) {
                    _historico.value = HistoricoUiState(
                        mensagem = "Nenhuma inspeção pendente neste aparelho."
                    )
                }
                return
            }
            _historico.value = _historico.value.copy(
                sincronizandoPendentes = true,
                mensagem = "Reenviando ${pendentes.size} inspeção(ões) pendente(s)..."
            )
            var ok = 0
            var falha = 0
            for (insp in pendentes) {
                if (!PlatformServices.isNetworkAvailable()) {
                    falha += pendentes.size - ok - falha
                    break
                }
                if (enviarInspecaoComRetry(insp).isSuccess) {
                    store.atualizar(insp.copy(enviadoRemoto = true))
                    registrarAcessoGarantido(
                        "FORM_SEND",
                        insp.formTipo.id,
                        detalheInspecao(insp, "enviar", mapOf("result" to "ok", "retry" to "1"))
                    )
                    ok++
                } else {
                    val jaNoServidor = remotoPorLocalId(insp.id)
                    if (jaNoServidor != null) {
                        store.atualizar(insp.copy(enviadoRemoto = true))
                        registrarAcessoGarantido(
                            "FORM_SEND",
                            insp.formTipo.id,
                            detalheInspecao(
                                insp,
                                "enviar",
                                mapOf(
                                    "result" to "ok",
                                    "remoteId" to jaNoServidor,
                                    "recovered" to "1",
                                    "retry" to "1"
                                )
                            )
                        )
                        ok++
                    } else {
                        falha++
                    }
                }
            }
            recarregarHistorico()
            recarregarHistoricoRemoto()
            _historico.value = HistoricoUiState(
                mensagem = when {
                    ok > 0 && falha == 0 ->
                        "$ok inspeção(ões) reenviada(s) ao servidor."
                    ok > 0 ->
                        "$ok reenviada(s); $falha ainda pendente(s). Nova tentativa automática em breve."
                    !PlatformServices.isNetworkAvailable() ->
                        "Sem conexão: $falha inspeção(ões) aguardando reenvio automático."
                    else ->
                        "Não foi possível reenviar $falha inspeção(ões). Tente de novo ou abra e salve o formulário."
                }
            )
            if (falha > 0) agendarReenvioPendentes()
        } finally {
            sincronizandoPendentes = false
            if (_historico.value.sincronizandoPendentes) {
                _historico.value = _historico.value.copy(sincronizandoPendentes = false)
            }
        }
    }

    /**
     * Android/iOS nao embutem Base64 no formulario (quota). A IA precisa dos
     * bytes da foto: usa o campo se existir, senao le o JPEG no disco.
     */
    private fun fotoBase64ParaAnalise(foto: FotoAnexo): String? {
        val embutido = foto.conteudoBase64
            ?.substringAfter("base64,", foto.conteudoBase64 ?: "")
            ?.takeIf { it.isNotBlank() }
        if (embutido != null) return embutido
        val bytes = PlatformFiles.readBytes(foto.path)?.takeIf { it.isNotEmpty() } ?: return null
        return PlatformServices.encodeBase64(bytes).takeIf { it.isNotBlank() }
    }

    private fun embedPhotoBase64(stampedBytes: ByteArray): String? {
        if (!PlatformServices.shouldEmbedPhotoBytesInForm()) return null
        if (stampedBytes.isEmpty()) return null
        // Preferir JPEG menor: se > ~1.8MB raw, ainda embute (PDF depende disso na Web).
        return PlatformServices.encodeBase64(stampedBytes)
    }

}

private data class CacheVisaoNr(
    val texto: String,
    val objetos: List<String>,
    val cena: String,
    val modo: String
)

private data class ResultadoVisaoFoto(
    val numero: Int,
    val fotoId: String,
    val texto: String,
    val nomes: List<String>,
    val cenaSug: String,
    val modoFoto: String,
    val falhasFoto: List<br.com.htms.inspeccaocampo.data.nrvisual.NrAchado>,
    val falhou: Boolean,
    val doCache: Boolean
)

/** Compat: FormController antigo → AppController. */
typealias FormController = AppController
